import "zod/compile";
import { z as e } from "zod";
function vn(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var ze = {}, Ye = {}, vt = {}, We = {}, bi;
function In() {
  if (bi) return We;
  bi = 1, Object.defineProperty(We, "__esModule", { value: !0 }), We.APP_ID_TO_NAME_MAP = We.EAppId = void 0;
  var t;
  return (function(r) {
    r.TE_ACTIVITIES = "TE_ACTIVITIES", r.TE_ADMIN = "TE_ADMIN", r.TE_ALLOCATE = "TE_ALLOCATE", r.TE_ALLOCATE_PREFERENTIAL = "TE_ALLOCATE_PREFERENTIAL", r.TE_ATTENDANCE = "TE_ATTENDANCE", r.TE_AUTOPILOT = "TE_AUTOPILOT", r.TE_CALENDAR_INTEGRATION = "TE_CALENDAR_INTEGRATION", r.TE_CORE = "TE_CORE", r.TE_CURRICULUM = "TE_CURRICULUM", r.TE_DATA_MANAGER = "TE_DATA_MANAGER", r.TE_DEBIT = "TE_DEBIT", r.TE_EVALUATION = "TE_EVALUATION", r.TE_EVENT_BROKER = "TE_EVENT_BROKER", r.TE_EXAM = "TE_EXAM", r.TE_EXAM_V3 = "TE_EXAM_V3", r.TE_FLOW = "TE_FLOW", r.TE_HUB = "TE_HUB", r.TE_INSIGHT = "TE_INSIGHT", r.TE_PLAN = "TE_PLAN", r.TE_PREFERENCES = "TE_PREFERENCES", r.TE_REGISTRATION = "TE_REGISTRATION", r.TE_REPORTING = "TE_REPORTING", r.TE_RESERVE = "TE_RESERVE", r.TE_SEAT_MANAGEMENT = "TE_SEAT_MANAGEMENT", r.TE_STATISTICS = "TE_STATISTICS", r.TE_STUDY_GUIDE = "TE_STUDY_GUIDE", r.TE_STUDY_PLANNER = "TE_STUDY_PLANNER", r.TE_VIEWER = "TE_VIEWER", r.TE_WORKLOAD = "TE_WORKLOAD", r.JAVA_CLIENT = "JAVA_CLIENT", r.TE_AM = "TE_AM", r.TE_PORTAL = "TE_PORTAL", r.TE_MCP = "TE_MCP", r.TE_REST = "TE_REST", r.TE_SERVER_THREAD = "TE_SERVER_THREAD", r.TE_SOAP = "TE_SOAP";
  })(t || (We.EAppId = t = {})), We.APP_ID_TO_NAME_MAP = {
    // Products
    [t.TE_ACTIVITIES]: "Activities",
    [t.TE_ADMIN]: "Admin",
    [t.TE_ALLOCATE]: "Allocate",
    [t.TE_ALLOCATE_PREFERENTIAL]: "Allocate Preferential",
    [t.TE_ATTENDANCE]: "Attendance",
    [t.TE_AUTOPILOT]: "Autopilot",
    [t.TE_CALENDAR_INTEGRATION]: "Calendar Integration",
    [t.TE_CORE]: "Core",
    [t.TE_CURRICULUM]: "Curriculum",
    [t.TE_DATA_MANAGER]: "Data Manager",
    [t.TE_DEBIT]: "Debit",
    [t.TE_EVALUATION]: "Evaluation",
    [t.TE_EVENT_BROKER]: "Event Broker",
    [t.TE_EXAM]: "Exam",
    [t.TE_EXAM_V3]: "Assessment",
    [t.TE_FLOW]: "Flow",
    [t.TE_HUB]: "Hub",
    [t.TE_INSIGHT]: "Insight",
    [t.TE_PLAN]: "Plan",
    [t.TE_PREFERENCES]: "Preferences",
    [t.TE_REGISTRATION]: "Registration",
    [t.TE_REPORTING]: "Reporting",
    [t.TE_RESERVE]: "Reserve",
    [t.TE_SEAT_MANAGEMENT]: "Seat Management",
    [t.TE_STATISTICS]: "Statistics",
    [t.TE_STUDY_GUIDE]: "Study Guide",
    [t.TE_STUDY_PLANNER]: "Study Planner",
    [t.TE_VIEWER]: "Viewer",
    [t.TE_WORKLOAD]: "Workload",
    // Supporting apps
    [t.JAVA_CLIENT]: "Java Client",
    [t.TE_AM]: "Activity Manager",
    [t.TE_PORTAL]: "Portal",
    [t.TE_MCP]: "MCP",
    [t.TE_REST]: "REST",
    [t.TE_SERVER_THREAD]: "Server Thread",
    [t.TE_SOAP]: "SOAP"
  }, We;
}
var gi;
function as() {
  if (gi) return vt;
  gi = 1, Object.defineProperty(vt, "__esModule", { value: !0 }), vt.AppIdsArr = void 0;
  const t = In();
  return vt.AppIdsArr = Object.values(t.EAppId), vt;
}
var re = {}, xe = {}, yi;
function Pn() {
  if (yi) return xe;
  yi = 1, Object.defineProperty(xe, "__esModule", { value: !0 }), xe.EScopeLevel = xe.EPermissionTypes = void 0;
  var t;
  (function(a) {
    a.SCOPE = "SCOPE", a.APP_PERMISSION = "APP_PERMISSION";
  })(t || (xe.EPermissionTypes = t = {}));
  var r;
  return (function(a) {
    a.ADMIN = "ADMIN", a.SUPER = "SUPER";
  })(r || (xe.EScopeLevel = r = {})), xe;
}
var _i;
function Lo() {
  if (_i) return re;
  _i = 1, Object.defineProperty(re, "__esModule", { value: !0 }), re.adminLevelAppPermissions = re.ScopeLevelArr = re.SCOPE_LEVEL_ADMIN = re.SCOPE_LEVEL_SUPER = re.TE_SOAP_SCOPE = re.TE_SERVER_THREAD_SCOPE = re.TE_ROOT_USER = re.SERVICE_ACCOUNT = void 0;
  const t = Pn();
  return re.SERVICE_ACCOUNT = "SERVICE_ACCOUNT", re.TE_ROOT_USER = "TE_ROOT_USER", re.TE_SERVER_THREAD_SCOPE = "TE_SERVER_THREAD::user", re.TE_SOAP_SCOPE = "TE_SOAP::user", re.SCOPE_LEVEL_SUPER = t.EScopeLevel.SUPER, re.SCOPE_LEVEL_ADMIN = t.EScopeLevel.ADMIN, re.ScopeLevelArr = [t.EScopeLevel.ADMIN, t.EScopeLevel.SUPER], re.adminLevelAppPermissions = [
    "TE_ADMIN::manageUsers",
    "TE_ADMIN::viewCullingReport",
    "TE_ADMIN::manageObjects",
    "TE_ADMIN::exportObjects",
    "TE_ADMIN::importObjects",
    "TE_ADMIN::manageTimeRules",
    "TE_CORE::activityManager",
    "TE_CORE::noTimeRules",
    "TE_CORE::setOrganizationsOnReservations",
    "TE_CORE::managePeriods",
    "TE_CORE::teExam",
    "TE_CORE::manageViews",
    "TE_RESERVE::noTimeRules",
    "TE_EXAM::supervisor",
    "TE_EXAM::supervisorCoordinator",
    "TE_EXAM::dec",
    "TE_EXAM::decCoordinator",
    "TE_EXAM::cea",
    "TE_EXAM_V3::invigilator",
    "TE_EXAM_V3::manager",
    "TE_PREFERENCES::recipient",
    "TE_HUB::student",
    "TE_HUB::invigilator",
    "TE_ACTIVITIES::readReservationTemplates"
  ], re;
}
var It = {}, Ke = {}, ie = {}, Ai;
function Cn() {
  if (Ai) return ie;
  Ai = 1, Object.defineProperty(ie, "__esModule", { value: !0 }), ie.SAMLIdentifierFormat = ie.EUserObjectMatching = ie.EApplySSOPermissions = ie.EAuthSaml2SigantureAlgorithm = ie.EAuthSaml2Signing = ie.EAuthLogLevel = ie.EAuthStrategy = void 0;
  var t;
  (function(m) {
    m.TE_IDP = "TE_IDP", m.SAML2 = "SAML2", m.CAS = "CAS";
  })(t || (ie.EAuthStrategy = t = {}));
  var r;
  (function(m) {
    m.NONE = "NONE", m.LOW = "LOW", m.HIGH = "HIGH", m.DEBUG = "DEBUG";
  })(r || (ie.EAuthLogLevel = r = {}));
  var a;
  (function(m) {
    m.NONE = "NONE", m.SIGN = "SIGN", m.REQUIRED = "REQUIRED";
  })(a || (ie.EAuthSaml2Signing = a = {}));
  var o;
  (function(m) {
    m.SHA1 = "sha1", m.SHA256 = "sha256", m.SHA512 = "sha512";
  })(o || (ie.EAuthSaml2SigantureAlgorithm = o = {}));
  var d;
  (function(m) {
    m.ALWAYS = "ALWAYS", m.NEW_USERS = "NEW_USERS", m.NEVER = "NEVER";
  })(d || (ie.EApplySSOPermissions = d = {}));
  var E;
  return (function(m) {
    m.OBJECT_EXTID = "OBJECT_EXTID", m.OBJECT_FIELD = "OBJECT_FIELD";
  })(E || (ie.EUserObjectMatching = E = {})), ie.SAMLIdentifierFormat = {
    Unspecified: "urn:oasis:names:tc:SAML:1.1:nameid-format:unspecified",
    Email: "urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress",
    Persistent: "urn:oasis:names:tc:SAML:2.0:nameid-format:persistent",
    Transient: "urn:oasis:names:tc:SAML:2.0:nameid-format:transient"
  }, ie;
}
var Pt = {}, Si;
function os() {
  if (Si) return Pt;
  Si = 1, Object.defineProperty(Pt, "__esModule", { value: !0 }), Pt.ESuiteId = void 0;
  var t;
  return (function(r) {
    r.CURRICULUM = "CURRICULUM", r.WORKLOAD = "WORKLOAD", r.SCHEDULING = "SCHEDULING", r.ENGAGEMENT = "ENGAGEMENT";
  })(t || (Pt.ESuiteId = t = {})), Pt;
}
var Ct = {}, Oi;
function Uo() {
  if (Oi) return Ct;
  Oi = 1, Object.defineProperty(Ct, "__esModule", { value: !0 }), Ct.EAuth = void 0;
  var t;
  return (function(r) {
    r.NOT_AUTHENTICATED = "NOT_AUTHENTICATED", r.AUTHENTICATED = "AUTHENTICATED", r.PENDING = "PENDING";
  })(t || (Ct.EAuth = t = {})), Ct;
}
var Ze = {}, Ri;
function Fo() {
  if (Ri) return Ze;
  Ri = 1, Object.defineProperty(Ze, "__esModule", { value: !0 }), Ze.EExternalServiceMethods = Ze.EExternalServices = void 0;
  var t;
  (function(a) {
    a.AUTH_SERVICE = "AUTH_SERVICE", a.USER_SERVICE = "USER_SERVICE", a.ORGANIZATION_SERVICE = "ORGANIZATION_SERVICE", a.APP_SERVICE = "APP_SERVICE", a.BACKUP_SERVICE = "BACKUP_SERVICE", a.TE_SERVER = "TE_SERVER", a.INTEGRATION_SERVICE = "INTEGRATION_SERVICE", a.PATHWAY_SERVICE = "PATHWAY_SERVICE", a.TE_PREFERENCES = "TE_PREFERENCES", a.ACTIVITY_MANAGER = "ACTIVITY_MANAGER", a.ACTIVITY_IMPORTER = "ACTIVITY_IMPORTER", a.REPORTING = "REPORTING", a.NOTIFICATION = "NOTIFICATION_SERVICE", a.EXAM_V3 = "EXAM_V3", a.HUB_SERVICE = "HUB_SERVICE", a.OBJECTS_BATCH_SERVICE = "OBJECTS_BATCH_SERVICE";
  })(t || (Ze.EExternalServices = t = {}));
  var r;
  return (function(a) {
    a.GET = "get", a.POST = "post", a.PUT = "put", a.PATCH = "patch", a.DELETE = "delete";
  })(r || (Ze.EExternalServiceMethods = r = {})), Ze;
}
var Nt = {}, hi;
function us() {
  if (hi) return Nt;
  hi = 1, Object.defineProperty(Nt, "__esModule", { value: !0 }), Nt.EPaddingRuleType = void 0;
  var t;
  return (function(r) {
    r.DIRECT = "DIRECT", r.TRAVEL_TIME = "TRAVEL_TIME";
  })(t || (Nt.EPaddingRuleType = t = {})), Nt;
}
var Mt = {}, vi;
function Nn() {
  if (vi) return Mt;
  vi = 1, Object.defineProperty(Mt, "__esModule", { value: !0 }), Mt.ERegion = void 0;
  var t;
  return (function(r) {
    r.ANZ = "ANZ", r.EU_EES = "EU_EES", r.SGP = "SGP", r.UK = "UK";
  })(t || (Mt.ERegion = t = {})), Mt;
}
var ye = {}, Ii;
function wo() {
  if (Ii) return ye;
  Ii = 1, Object.defineProperty(ye, "__esModule", { value: !0 }), ye.ERelativeTimeTypes = ye.EReservationPeriodType = ye.EWeekdaySelection = ye.EWeekdays = void 0;
  var t;
  (function(d) {
    d.MON = "MON", d.TUE = "TUE", d.WED = "WED", d.THU = "THU", d.FRI = "FRI", d.SAT = "SAT", d.SUN = "SUN";
  })(t || (ye.EWeekdays = t = {}));
  var r;
  (function(d) {
    d.noWeekDaySelection = "no_weekday_selection";
  })(r || (ye.EWeekdaySelection = r = {}));
  var a;
  (function(d) {
    d.NONE = "NONE", d.RESERVATION_PERIOD = "RESERVATION_PERIOD", d.DAY = "DAY", d.WEEK = "WEEK", d.MONTH = "MONTH", d.YEAR = "YEAR";
  })(a || (ye.EReservationPeriodType = a = {}));
  var o;
  return (function(d) {
    d.DAYS = "DAYS", d.HOURS = "HOURS", d.MINUTES = "MINUTES";
  })(o || (ye.ERelativeTimeTypes = o = {})), ye;
}
var Dt = {}, Pi;
function Bo() {
  if (Pi) return Dt;
  Pi = 1, Object.defineProperty(Dt, "__esModule", { value: !0 }), Dt.ETokenType = void 0;
  var t;
  return (function(r) {
    r.M2M = "M2M", r.USER = "USER";
  })(t || (Dt.ETokenType = t = {})), Dt;
}
var Je = {}, Ci;
function ss() {
  if (Ci) return Je;
  Ci = 1, Object.defineProperty(Je, "__esModule", { value: !0 }), Je.EUserAllowJavaClientAccess = Je.EUserVisibility = void 0;
  var t;
  (function(a) {
    a.STANDARD = "STANDARD", a.READ_ONLY = "READ_ONLY", a.HIDDEN = "HIDDEN";
  })(t || (Je.EUserVisibility = t = {}));
  var r;
  return (function(a) {
    a.STANDARD = "STANDARD", a.YES = "YES", a.NO = "NO";
  })(r || (Je.EUserAllowJavaClientAccess = r = {})), Je;
}
var jt = {}, Ni;
function ls() {
  if (Ni) return jt;
  Ni = 1, Object.defineProperty(jt, "__esModule", { value: !0 }), jt.EOrganizationType = void 0;
  var t;
  return (function(r) {
    r.CUSTOMER_PRODUCTION = "CUSTOMER_PRODUCTION", r.CUSTOMER_TESTING = "CUSTOMER_TESTING", r.INTERNAL_PRODUCTION = "INTERNAL_PRODUCTION", r.INTERNAL_OTHER = "INTERNAL_OTHER";
  })(t || (jt.EOrganizationType = t = {})), jt;
}
var Ce = {}, Mi;
function Go() {
  if (Mi) return Ce;
  Mi = 1, Object.defineProperty(Ce, "__esModule", { value: !0 }), Ce.EPreferencesFilter = Ce.EPersonalDataCheck = Ce.EFieldType = void 0;
  var t;
  (function(o) {
    o.TEXT = "TEXT", o.SIGNATURE = "SIGNATURE", o.EMAIL = "EMAIL", o.URL = "URL", o.TELEPHONE = "TELEPHONE", o.CATEGORY = "CATEGORY", o.COMMENT = "COMMENT", o.INTEGER = "INTEGER", o.LENGTH = "LENGTH", o.CHECKBOX = "CHECKBOX", o.REFERENCE = "REFERENCE", o.NON_SEARCHABLE_TEXT = "NON_SEARCHABLE_TEXT", o.NON_SEARCHABLE_REFERENCE = "NON_SEARCHABLE_REFERENCE";
  })(t || (Ce.EFieldType = t = {}));
  var r;
  (function(o) {
    o.STANDARD = "STANDARD", o.YES = "YES", o.NO = "NO";
  })(r || (Ce.EPersonalDataCheck = r = {}));
  var a;
  return (function(o) {
    o.CHOICE1 = "[0-9]", o.CHOICE2 = "[0-9\\- +]", o.CHOICE3 = "[0-9a-z]", o.CHOICE4 = "[0-9a-zA-ZåäöÅÄÖ_-]", o.CHOICE5 = "[@_\\-\\.0-9a-zA-Z]", o.CHOICE6 = "[@_\\-\\.0-9a-zA-ZåäöÅÄÖ]";
  })(a || (Ce.EPreferencesFilter = a = {})), Ce;
}
var Xe = {}, Di;
function cs() {
  if (Di) return Xe;
  Di = 1, Object.defineProperty(Xe, "__esModule", { value: !0 }), Xe.EMatchMode = Xe.EOperator = void 0;
  var t;
  (function(a) {
    a.E = "=", a.GTE = ">=", a.GT = ">", a.LTE = "<=", a.LT = "<";
  })(t || (Xe.EOperator = t = {}));
  var r;
  return (function(a) {
    a.MATCH_ONE = "MATCH_ONE", a.MATCH_ALL = "MATCH_ALL";
  })(r || (Xe.EMatchMode = r = {})), Xe;
}
var Ne = {}, ji;
function ds() {
  if (ji) return Ne;
  ji = 1, Object.defineProperty(Ne, "__esModule", { value: !0 }), Ne.ELoggedEventType = Ne.ELoggedEventItemDataType = Ne.ELoggedEventLevel = void 0;
  var t;
  (function(o) {
    o.LOW = "LOW", o.MEDIUM = "MEDIUM", o.HIGH = "HIGH", o.CRITICAL = "CRITICAL";
  })(t || (Ne.ELoggedEventLevel = t = {}));
  var r;
  (function(o) {
    o.TEXT = "text/plain", o.JSON = "application/json";
  })(r || (Ne.ELoggedEventItemDataType = r = {}));
  var a;
  return (function(o) {
    o.MIGRATION = "MIGRATION", o.IMPORT = "IMPORT", o.SSO = "SSO";
  })(a || (Ne.ELoggedEventType = a = {})), Ne;
}
var Qe = {}, Li;
function ps() {
  if (Li) return Qe;
  Li = 1, Object.defineProperty(Qe, "__esModule", { value: !0 }), Qe.EPersonalInformation = Qe.EProperty = void 0;
  var t;
  (function(a) {
    a.STANDARD = "STANDARD", a.ABSTRACT = "ABSTRACT", a.VIRTUAL_STANDARD = "VIRTUAL_STANDARD", a.VIRTUAL_ABSTRACT = "VIRTUAL_ABSTRACT", a.TEMPLATE_OBJECT = "TEMPLATE_OBJECT";
  })(t || (Qe.EProperty = t = {}));
  var r;
  return (function(a) {
    a.YES = "YES", a.NO = "NO", a.STANDARD = "STANDARD";
  })(r || (Qe.EPersonalInformation = r = {})), Qe;
}
var et = {}, Ui;
function $o() {
  if (Ui) return et;
  Ui = 1, Object.defineProperty(et, "__esModule", { value: !0 }), et.EPeriodAccess = et.ETimeIntervals = void 0;
  var t;
  (function(a) {
    a.DATE = "DATE", a.YEAR = "YEAR", a.WEEK = "WEEK", a.WEEK_NUMBER = "WEEK_NUMBER", a.MONTH = "MONTH", a.DAY = "DAY", a.WEEKDAY = "WEEKDAY", a.TIME = "TIME", a.NONE = "-";
  })(t || (et.ETimeIntervals = t = {}));
  var r;
  return (function(a) {
    a.PUBLIC = "PUBLIC", a.LIMITED = "LIMITED", a.HIDDEN = "HIDDEN";
  })(r || (et.EPeriodAccess = r = {})), et;
}
var Lt = {}, Fi;
function Vo() {
  if (Fi) return Lt;
  Fi = 1, Object.defineProperty(Lt, "__esModule", { value: !0 }), Lt.ERelationType = void 0;
  var t;
  return (function(r) {
    r.USE_ONLY = "USE_ONLY", r.STRICT = "STRICT", r.DYNAMIC = "DYNAMIC";
  })(t || (Lt.ERelationType = t = {})), Lt;
}
var ne = {}, wi;
function ko() {
  if (wi) return ne;
  wi = 1, Object.defineProperty(ne, "__esModule", { value: !0 }), ne.EReservationStatuses = ne.ETemplateType = ne.ETemplateTypesText = ne.EOptionalRelation = ne.EObjectProperty = ne.EMandatoryProperty = ne.EReservationKind = ne.EDefaultStatus = void 0;
  var t;
  (function(f) {
    f.CONFIRMED = "CONFIRMED", f.PLANNED = "PLANNED", f.PRELIMINARY = "PRELIMINARY";
  })(t || (ne.EDefaultStatus = t = {}));
  var r;
  (function(f) {
    f.PHYSICAL = "PHYSICAL", f.PHYSICAL_DOUBLE = "PHYSICAL_DOUBLE", f.ABSTRACT = "ABSTRACT", f.ABSTRACT_DISPLAY = "ABSTRACT_DISPLAY";
  })(r || (ne.EReservationKind = r = {}));
  var a;
  (function(f) {
    f.MANDATORY = "MANDATORY", f.COMBINATION = "COMBINATION", f.OPTIONAL = "OPTIONAL";
  })(a || (ne.EMandatoryProperty = a = {}));
  var o;
  (function(f) {
    f.OBJECT = "OBJECT", f.VIRTUAL = "VIRTUAL", f.INCOMPLETE = "INCOMPLETE";
  })(o || (ne.EObjectProperty = o = {}));
  var d;
  (function(f) {
    f.NONE = "NONE", f.OPTIONAL = "OPTIONAL", f.ABSTRACT = "ABSTRACT";
  })(d || (ne.EOptionalRelation = d = {}));
  var E;
  (function(f) {
    f.STANDARD = "STANDARD", f.NEVER = "NEVER", f.ALWAYS = "ALWAYS";
  })(E || (ne.ETemplateTypesText = E = {}));
  var m;
  (function(f) {
    f.RESERVATION = "RESERVATION", f.AVAILABILITY = "AVAILABILITY", f.INFO_RESERVATION = "INFO_RESERVATION";
  })(m || (ne.ETemplateType = m = {}));
  var c;
  return (function(f) {
    f.UNKNOWN = "UNKNOWN", f.Reservation = "A_RESERVATION", f.Availability = "A_AVAILABILITY", f.Info = "A_INFO", f.Complete = "B_COMPLETE", f.Incomplete = "B_INCOMPLETE", f.Confirmed = "C_CONFIRMED", f.Preliminary = "C_PRELIMINARY", f.Planned = "C_PLANNED", f.Requested = "C_REQUESTED", f.Rejected = "C_REJECTED", f.Time = "D_TIME", f.WaitingList = "D_WAITING_LIST";
  })(c || (ne.EReservationStatuses = c = {})), ne;
}
var Ut = {}, Bi;
function ms() {
  if (Bi) return Ut;
  Bi = 1, Object.defineProperty(Ut, "__esModule", { value: !0 }), Ut.EAcceptJavaClient = void 0;
  var t;
  return (function(r) {
    r.YES = "YES", r.NO = "NO", r.DEFAULT = "DEFAULT";
  })(t || (Ut.EAcceptJavaClient = t = {})), Ut;
}
var Ft = {}, Gi;
function fs() {
  if (Gi) return Ft;
  Gi = 1, Object.defineProperty(Ft, "__esModule", { value: !0 }), Ft.EFieldMappingModes = void 0;
  var t;
  return (function(r) {
    r.RAW = "RAW", r.FREE_MAPPING = "FREE_MAPPING", r.MAPPED = "MAPPED";
  })(t || (Ft.EFieldMappingModes = t = {})), Ft;
}
var wt = {}, $i;
function Es() {
  if ($i) return wt;
  $i = 1, Object.defineProperty(wt, "__esModule", { value: !0 }), wt.ETEReportingDataSource = void 0;
  var t;
  return (function(r) {
    r.SCHEDULE_GENERATOR = "SCHEDULE_GENERATOR", r.RESERVATIONS = "RESERVATIONS", r.ORDERS = "ORDERS", r.EXAMS = "EXAMS", r.FORMS = "FORMS", r.ACTIVITIES = "ACTIVITIES";
  })(t || (wt.ETEReportingDataSource = t = {})), wt;
}
var Me = {}, Vi;
function Ts() {
  if (Vi) return Me;
  Vi = 1, Object.defineProperty(Me, "__esModule", { value: !0 }), Me.EAppProperties = Me.EObjectTypeMappingStatuses = Me.EApplicationObjectTypeGroup = void 0;
  var t;
  (function(o) {
    o.NONE = "NONE", o.ROOM = "ROOM", o.PROFESSOR = "PROFESSOR", o.COURSE = "COURSE", o.COURSE_INFORMATION = "COURSE_INFORMATION", o.INVOICING = "INVOICING", o.STUDENT_SET = "STUDENT_SET", o.STUDENT_SET_GROUP = "STUDENT_SET_GROUP", o.PROGRAM = "PROGRAM", o.ACTIVITY_TYPE = "ACTIVITY_TYPE", o.STUDENT = "STUDENT", o.STAFF = "STAFF", o.CHANGE_REQUEST = "CHANGE_REQUEST", o.INVIGILATOR = "INVIGILATOR";
  })(t || (Me.EApplicationObjectTypeGroup = t = {}));
  var r;
  (function(o) {
    o.NOT_TESTED = "NOT_TESTED", o.NOT_MAPPED = "NOT_MAPPED", o.MAPPED = "MAPPED", o.TESTED = "TESTED", o.FAILED = "FAILED";
  })(r || (Me.EObjectTypeMappingStatuses = r = {}));
  var a;
  return (function(o) {
    o.NONE = "NONE", o.NAME = "NAME", o.LABEL = "LABEL", o.EMAIL = "EMAIL", o.FIRST_NAME = "FIRST_NAME", o.LAST_NAME = "LAST_NAME", o.TITLE = "TITLE", o.ID = "ID", o.SEMESTER = "SEMESTER", o.MAX_STUDENTS = "MAX_STUDENTS", o.ACTIVITY_TYPE = "ACTIVITY_TYPE", o.START_DATE = "START_DATE", o.END_DATE = "END_DATE", o.BUFFER = "BUFFER", o.HIDETRACK = "HIDETRACK", o.DEDICATETRACK = "DEDICATETRACK", o.TRACK = "TRACK", o.SEATS = "SEATS", o.COURSE_OCCURENCE = "COURSE_OCCURENCE", o.PLANNED_SIZE = "PLANNED_SIZE", o.PROGRAM = "PROGRAM", o.ROOM_NAME = "ROOM_NAME", o.ROOM_TYPE = "ROOM_TYPE", o.BUILDING = "BUILDING", o.CAMPUS = "CAMPUS", o.REASONABLE_ADJUSTMENT = "REASONABLE_ADJUSTMENT";
  })(a || (Me.EAppProperties = a = {})), Me;
}
var fe = {}, ki;
function bs() {
  if (ki) return fe;
  ki = 1, Object.defineProperty(fe, "__esModule", { value: !0 }), fe.CalculatedValueProps = fe.ECalculatedValueKey = fe.EReportTemplateType = fe.EReportingCapacitySource = fe.EReportingTimeType = void 0;
  var t;
  (function(d) {
    d.FIXED_HOUR = "FIXED_HOUR", d.TIME_RANGE = "TIME_RANGE", d.MAX_HOURS = "MAX_HOURS";
  })(t || (fe.EReportingTimeType = t = {}));
  var r;
  (function(d) {
    d.FROM_FIELD = "FROM_FIELD", d.FROM_MEMBERSHIP = "FROM_MEMBERSHIP";
  })(r || (fe.EReportingCapacitySource = r = {}));
  var a;
  (function(d) {
    d.UTILIZATION = "UTILIZATION", d.LOAD = "LOAD", d.DEMAND_ANALYTIC = "DEMAND_ANALYTIC", d.HEATMAP = "HEATMAP";
  })(a || (fe.EReportTemplateType = a = {}));
  var o;
  return (function(d) {
    d.FREQUENCY = "frequency", d.OCCUPANCY = "occupancy", d.UTILIZATION = "utilization", d.BOOKED_HOURS = "bookedHours", d.AVAILABLE_HOUR = "availableHour", d.LOAD_PERCENTAGE = "loadPercentage", d.WEEKS_ABOVE_TARGET = "weeksAboveTarget", d.DEMAND_PERCENTAGE = "demandPercentage";
  })(o || (fe.ECalculatedValueKey = o = {})), fe.CalculatedValueProps = {
    [o.FREQUENCY]: { label: "Frequency", templateType: a.UTILIZATION },
    [o.OCCUPANCY]: { label: "Occupancy", templateType: a.UTILIZATION },
    [o.UTILIZATION]: { label: "Utilization", templateType: a.UTILIZATION },
    [o.BOOKED_HOURS]: { label: "Booked Hours", templateType: a.LOAD },
    [o.AVAILABLE_HOUR]: { label: "Available Hours", templateType: a.LOAD },
    [o.LOAD_PERCENTAGE]: { label: "Load", templateType: a.LOAD },
    [o.WEEKS_ABOVE_TARGET]: {
      label: "Weeks Above Target",
      templateType: a.DEMAND_ANALYTIC
    },
    [o.DEMAND_PERCENTAGE]: {
      label: "Average Weekly Demand",
      templateType: a.DEMAND_ANALYTIC
    }
  }, fe;
}
var qi;
function pe() {
  return qi || (qi = 1, (function(t) {
    var r = Ke && Ke.__createBinding || (Object.create ? (function(q, M, H, ee) {
      ee === void 0 && (ee = H);
      var P = Object.getOwnPropertyDescriptor(M, H);
      (!P || ("get" in P ? !M.__esModule : P.writable || P.configurable)) && (P = { enumerable: !0, get: function() {
        return M[H];
      } }), Object.defineProperty(q, ee, P);
    }) : (function(q, M, H, ee) {
      ee === void 0 && (ee = H), q[ee] = M[H];
    })), a = Ke && Ke.__exportStar || function(q, M) {
      for (var H in q) H !== "default" && !Object.prototype.hasOwnProperty.call(M, H) && r(M, q, H);
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.EReportTemplateType = t.EReportingCapacitySource = t.EReportingTimeType = t.EAppProperties = t.EObjectTypeMappingStatuses = t.EApplicationObjectTypeGroup = t.ETEReportingDataSource = t.EFieldMappingModes = t.EAcceptJavaClient = t.EReservationStatuses = t.ETemplateType = t.ETemplateTypesText = t.EOptionalRelation = t.EObjectProperty = t.EMandatoryProperty = t.EReservationKind = t.EDefaultStatus = t.ERelationType = t.EPeriodAccess = t.ETimeIntervals = t.EPersonalInformation = t.EProperty = t.EOperator = t.EMatchMode = t.EPreferencesFilter = t.EPersonalDataCheck = t.EFieldType = t.EOrganizationType = t.EUserVisibility = t.EUserAllowJavaClientAccess = t.ETokenType = t.EWeekdaySelection = t.EWeekdays = t.EReservationPeriodType = t.ERelativeTimeTypes = t.ERegion = t.EScopeLevel = t.EPermissionTypes = t.EPaddingRuleType = t.EExternalServices = t.EExternalServiceMethods = t.EAuth = t.ESuiteId = t.EAppId = t.EUserObjectMatching = t.EAuthStrategy = t.EAuthSaml2Signing = t.EAuthSaml2SigantureAlgorithm = t.EAuthLogLevel = t.EApplySSOPermissions = void 0, t.CalculatedValueProps = t.ECalculatedValueKey = void 0;
    var o = Cn();
    Object.defineProperty(t, "EApplySSOPermissions", { enumerable: !0, get: function() {
      return o.EApplySSOPermissions;
    } }), Object.defineProperty(t, "EAuthLogLevel", { enumerable: !0, get: function() {
      return o.EAuthLogLevel;
    } }), Object.defineProperty(t, "EAuthSaml2SigantureAlgorithm", { enumerable: !0, get: function() {
      return o.EAuthSaml2SigantureAlgorithm;
    } }), Object.defineProperty(t, "EAuthSaml2Signing", { enumerable: !0, get: function() {
      return o.EAuthSaml2Signing;
    } }), Object.defineProperty(t, "EAuthStrategy", { enumerable: !0, get: function() {
      return o.EAuthStrategy;
    } }), Object.defineProperty(t, "EUserObjectMatching", { enumerable: !0, get: function() {
      return o.EUserObjectMatching;
    } });
    var d = In();
    Object.defineProperty(t, "EAppId", { enumerable: !0, get: function() {
      return d.EAppId;
    } });
    var E = os();
    Object.defineProperty(t, "ESuiteId", { enumerable: !0, get: function() {
      return E.ESuiteId;
    } });
    var m = Uo();
    Object.defineProperty(t, "EAuth", { enumerable: !0, get: function() {
      return m.EAuth;
    } });
    var c = Fo();
    Object.defineProperty(t, "EExternalServiceMethods", { enumerable: !0, get: function() {
      return c.EExternalServiceMethods;
    } }), Object.defineProperty(t, "EExternalServices", { enumerable: !0, get: function() {
      return c.EExternalServices;
    } });
    var f = us();
    Object.defineProperty(t, "EPaddingRuleType", { enumerable: !0, get: function() {
      return f.EPaddingRuleType;
    } });
    var _ = Pn();
    Object.defineProperty(t, "EPermissionTypes", { enumerable: !0, get: function() {
      return _.EPermissionTypes;
    } }), Object.defineProperty(t, "EScopeLevel", { enumerable: !0, get: function() {
      return _.EScopeLevel;
    } });
    var u = Nn();
    Object.defineProperty(t, "ERegion", { enumerable: !0, get: function() {
      return u.ERegion;
    } });
    var b = wo();
    Object.defineProperty(t, "ERelativeTimeTypes", { enumerable: !0, get: function() {
      return b.ERelativeTimeTypes;
    } }), Object.defineProperty(t, "EReservationPeriodType", { enumerable: !0, get: function() {
      return b.EReservationPeriodType;
    } }), Object.defineProperty(t, "EWeekdays", { enumerable: !0, get: function() {
      return b.EWeekdays;
    } }), Object.defineProperty(t, "EWeekdaySelection", { enumerable: !0, get: function() {
      return b.EWeekdaySelection;
    } });
    var O = Bo();
    Object.defineProperty(t, "ETokenType", { enumerable: !0, get: function() {
      return O.ETokenType;
    } });
    var T = ss();
    Object.defineProperty(t, "EUserAllowJavaClientAccess", { enumerable: !0, get: function() {
      return T.EUserAllowJavaClientAccess;
    } }), Object.defineProperty(t, "EUserVisibility", { enumerable: !0, get: function() {
      return T.EUserVisibility;
    } });
    var A = ls();
    Object.defineProperty(t, "EOrganizationType", { enumerable: !0, get: function() {
      return A.EOrganizationType;
    } });
    var g = Go();
    Object.defineProperty(t, "EFieldType", { enumerable: !0, get: function() {
      return g.EFieldType;
    } }), Object.defineProperty(t, "EPersonalDataCheck", { enumerable: !0, get: function() {
      return g.EPersonalDataCheck;
    } }), Object.defineProperty(t, "EPreferencesFilter", { enumerable: !0, get: function() {
      return g.EPreferencesFilter;
    } });
    var C = cs();
    Object.defineProperty(t, "EMatchMode", { enumerable: !0, get: function() {
      return C.EMatchMode;
    } }), Object.defineProperty(t, "EOperator", { enumerable: !0, get: function() {
      return C.EOperator;
    } }), a(ds(), t);
    var G = ps();
    Object.defineProperty(t, "EProperty", { enumerable: !0, get: function() {
      return G.EProperty;
    } }), Object.defineProperty(t, "EPersonalInformation", { enumerable: !0, get: function() {
      return G.EPersonalInformation;
    } });
    var D = $o();
    Object.defineProperty(t, "ETimeIntervals", { enumerable: !0, get: function() {
      return D.ETimeIntervals;
    } }), Object.defineProperty(t, "EPeriodAccess", { enumerable: !0, get: function() {
      return D.EPeriodAccess;
    } });
    var F = Vo();
    Object.defineProperty(t, "ERelationType", { enumerable: !0, get: function() {
      return F.ERelationType;
    } });
    var k = ko();
    Object.defineProperty(t, "EDefaultStatus", { enumerable: !0, get: function() {
      return k.EDefaultStatus;
    } }), Object.defineProperty(t, "EReservationKind", { enumerable: !0, get: function() {
      return k.EReservationKind;
    } }), Object.defineProperty(t, "EMandatoryProperty", { enumerable: !0, get: function() {
      return k.EMandatoryProperty;
    } }), Object.defineProperty(t, "EObjectProperty", { enumerable: !0, get: function() {
      return k.EObjectProperty;
    } }), Object.defineProperty(t, "EOptionalRelation", { enumerable: !0, get: function() {
      return k.EOptionalRelation;
    } }), Object.defineProperty(t, "ETemplateTypesText", { enumerable: !0, get: function() {
      return k.ETemplateTypesText;
    } }), Object.defineProperty(t, "ETemplateType", { enumerable: !0, get: function() {
      return k.ETemplateType;
    } }), Object.defineProperty(t, "EReservationStatuses", { enumerable: !0, get: function() {
      return k.EReservationStatuses;
    } });
    var j = ms();
    Object.defineProperty(t, "EAcceptJavaClient", { enumerable: !0, get: function() {
      return j.EAcceptJavaClient;
    } });
    var W = fs();
    Object.defineProperty(t, "EFieldMappingModes", { enumerable: !0, get: function() {
      return W.EFieldMappingModes;
    } });
    var Q = Es();
    Object.defineProperty(t, "ETEReportingDataSource", { enumerable: !0, get: function() {
      return Q.ETEReportingDataSource;
    } });
    var X = Ts();
    Object.defineProperty(t, "EApplicationObjectTypeGroup", { enumerable: !0, get: function() {
      return X.EApplicationObjectTypeGroup;
    } }), Object.defineProperty(t, "EObjectTypeMappingStatuses", { enumerable: !0, get: function() {
      return X.EObjectTypeMappingStatuses;
    } }), Object.defineProperty(t, "EAppProperties", { enumerable: !0, get: function() {
      return X.EAppProperties;
    } });
    var Y = bs();
    Object.defineProperty(t, "EReportingTimeType", { enumerable: !0, get: function() {
      return Y.EReportingTimeType;
    } }), Object.defineProperty(t, "EReportingCapacitySource", { enumerable: !0, get: function() {
      return Y.EReportingCapacitySource;
    } }), Object.defineProperty(t, "EReportTemplateType", { enumerable: !0, get: function() {
      return Y.EReportTemplateType;
    } }), Object.defineProperty(t, "ECalculatedValueKey", { enumerable: !0, get: function() {
      return Y.ECalculatedValueKey;
    } }), Object.defineProperty(t, "CalculatedValueProps", { enumerable: !0, get: function() {
      return Y.CalculatedValueProps;
    } });
  })(Ke)), Ke;
}
var Hi;
function gs() {
  if (Hi) return It;
  Hi = 1, Object.defineProperty(It, "__esModule", { value: !0 }), It.FieldMappingModeProps = void 0;
  const t = pe();
  return It.FieldMappingModeProps = {
    [t.EFieldMappingModes.RAW]: {
      label: "Only first primary field"
    },
    [t.EFieldMappingModes.FREE_MAPPING]: {
      label: "Free field selection"
    },
    [t.EFieldMappingModes.MAPPED]: {
      label: "Predetermined fields"
    }
  }, It;
}
var De = {}, zi;
function ys() {
  if (zi) return De;
  zi = 1, Object.defineProperty(De, "__esModule", { value: !0 }), De.AppPropertyProps = De.ObjectTypeGroupProps = De.ObjectTypeMappingStatusProps = void 0;
  const t = pe();
  return De.ObjectTypeMappingStatusProps = {
    [t.EObjectTypeMappingStatuses.NOT_TESTED]: {
      label: "Not mapped",
      color: "#ffdd5c"
    },
    [t.EObjectTypeMappingStatuses.NOT_MAPPED]: {
      label: "Not mapped",
      color: "#ffdd5c"
    },
    [t.EObjectTypeMappingStatuses.MAPPED]: {
      label: "Mapped",
      color: "#3fa5b3"
    },
    [t.EObjectTypeMappingStatuses.TESTED]: {
      label: "Tested",
      color: "#29b68f"
    },
    [t.EObjectTypeMappingStatuses.FAILED]: {
      label: "Failed",
      color: "#ff6357"
    }
  }, De.ObjectTypeGroupProps = {
    [t.EApplicationObjectTypeGroup.NONE]: {
      label: "None"
    },
    [t.EApplicationObjectTypeGroup.ROOM]: {
      label: "Room"
    },
    [t.EApplicationObjectTypeGroup.PROFESSOR]: {
      label: "Professor"
    },
    [t.EApplicationObjectTypeGroup.COURSE]: {
      label: "Course"
    },
    [t.EApplicationObjectTypeGroup.COURSE_INFORMATION]: {
      label: "Course Information"
    },
    [t.EApplicationObjectTypeGroup.INVOICING]: {
      label: "Invoicing"
    },
    [t.EApplicationObjectTypeGroup.STUDENT_SET]: {
      label: "Student set"
    },
    [t.EApplicationObjectTypeGroup.STUDENT_SET_GROUP]: {
      label: "Student set group"
    },
    [t.EApplicationObjectTypeGroup.PROGRAM]: {
      label: "Program"
    },
    [t.EApplicationObjectTypeGroup.ACTIVITY_TYPE]: {
      label: "Activity type"
    },
    [t.EApplicationObjectTypeGroup.STUDENT]: {
      label: "Student"
    },
    [t.EApplicationObjectTypeGroup.STAFF]: {
      label: "Staff"
    },
    [t.EApplicationObjectTypeGroup.CHANGE_REQUEST]: {
      label: "Change request"
    },
    [t.EApplicationObjectTypeGroup.INVIGILATOR]: {
      label: "Invigilator"
    }
  }, De.AppPropertyProps = {
    [t.EAppProperties.NONE]: {
      label: "None"
    },
    [t.EAppProperties.EMAIL]: {
      label: "Email"
    },
    [t.EAppProperties.LABEL]: {
      label: "Label"
    },
    [t.EAppProperties.TITLE]: {
      label: "Title"
    },
    [t.EAppProperties.SEMESTER]: {
      label: "Semester"
    },
    [t.EAppProperties.MAX_STUDENTS]: {
      label: "Max class size"
    },
    [t.EAppProperties.ACTIVITY_TYPE]: {
      label: "Activity type"
    },
    [t.EAppProperties.START_DATE]: {
      label: "Start date"
    },
    [t.EAppProperties.END_DATE]: {
      label: "End date"
    },
    [t.EAppProperties.TRACK]: {
      label: "Group number"
    },
    [t.EAppProperties.SEATS]: {
      label: "Capacity"
    },
    [t.EAppProperties.BUFFER]: {
      label: "Buffer"
    },
    [t.EAppProperties.HIDETRACK]: {
      label: "Hide track"
    },
    [t.EAppProperties.DEDICATETRACK]: {
      label: "Dedicate track"
    },
    [t.EAppProperties.FIRST_NAME]: {
      label: "First name"
    },
    [t.EAppProperties.LAST_NAME]: {
      label: "Last name"
    },
    [t.EAppProperties.NAME]: {
      label: "Study combination: id"
    },
    [t.EAppProperties.COURSE_OCCURENCE]: {
      label: "Course occurence"
    },
    [t.EAppProperties.PLANNED_SIZE]: {
      label: "Planned size"
    },
    [t.EAppProperties.ID]: {
      label: "Id"
    },
    [t.EAppProperties.PROGRAM]: {
      label: "Program"
    },
    [t.EAppProperties.ROOM_NAME]: {
      label: "Room name"
    },
    [t.EAppProperties.ROOM_TYPE]: {
      label: "Room type"
    },
    [t.EAppProperties.BUILDING]: {
      label: "Building"
    },
    [t.EAppProperties.CAMPUS]: {
      label: "Campus"
    },
    [t.EAppProperties.REASONABLE_ADJUSTMENT]: {
      label: "Reasonable adjustment"
    }
  }, De;
}
var Bt = {}, Yi;
function _s() {
  if (Yi) return Bt;
  Yi = 1, Object.defineProperty(Bt, "__esModule", { value: !0 }), Bt.DefaultTEExamObjectTypesMapping = void 0;
  const t = pe();
  return Bt.DefaultTEExamObjectTypesMapping = [
    {
      applicationObjectTypeName: "room",
      applicationObjectTypeGroup: t.EApplicationObjectTypeGroup.ROOM,
      applicationObjectTypeLabel: "Room",
      // User is free to override, but we provide a default
      status: t.EObjectTypeMappingStatuses.NOT_MAPPED,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "description",
          fieldLabel: "Description"
          // User can override but we provide default
        },
        {
          appFieldName: "capacity",
          fieldLabel: "Capacity"
          // User can override but we provide default
        },
        {
          appFieldName: "building",
          fieldLabel: "Building"
          // User can override but we provide default
        },
        {
          appFieldName: "campus",
          fieldLabel: "Campus"
          // User can override but we provide default
        },
        {
          appFieldName: "floor",
          fieldLabel: "Floor"
          // User can override but we provide default
        },
        {
          appFieldName: "address",
          fieldLabel: "Address"
          // User can override but we provide default
        },
        {
          appFieldName: "pricePerSeatPerHour",
          fieldLabel: "Price per seat per hour"
          // User can override but we provide default
        },
        {
          appFieldName: "roomType",
          fieldLabel: "Room type"
          // User can override but we provide default
        }
      ]
    },
    {
      applicationObjectTypeName: "professor",
      applicationObjectTypeGroup: t.EApplicationObjectTypeGroup.PROFESSOR,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "Professor",
      // User is free to override, but we provide a default
      status: t.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "id",
          fieldLabel: "Id"
          // User can override but we provide default
        },
        {
          appFieldName: "email",
          fieldLabel: "Email"
          // User can override but we provide default
        },
        {
          appFieldName: "department",
          fieldLabel: "Department"
          // User can override but we provide default
        }
      ]
    },
    {
      applicationObjectTypeName: "coordinator",
      applicationObjectTypeGroup: t.EApplicationObjectTypeGroup.PROFESSOR,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "Coordinator",
      // User is free to override, but we provide a default
      status: t.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "id",
          fieldLabel: "Id"
          // User can override but we provide default
        },
        {
          appFieldName: "email",
          fieldLabel: "Email"
          // User can override but we provide default
        },
        {
          appFieldName: "department",
          fieldLabel: "Department"
          // User can override but we provide default
        }
      ]
    },
    {
      applicationObjectTypeName: "course",
      applicationObjectTypeGroup: t.EApplicationObjectTypeGroup.COURSE_INFORMATION,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "Course",
      // User is free to override, but we provide a default
      status: t.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "code",
          fieldLabel: "Code"
          // User can override but we provide default
        },
        {
          appFieldName: "credits",
          fieldLabel: "Credits"
          // User can override but we provide default
        },
        {
          appFieldName: "courseCode",
          fieldLabel: "Course Code"
          // User can override but we provide default
        },
        {
          appFieldName: "department",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Department"
        }
      ]
    },
    {
      applicationObjectTypeName: "courseEvent",
      applicationObjectTypeGroup: t.EApplicationObjectTypeGroup.COURSE_INFORMATION,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "Course Event",
      // User is free to override, but we provide a default
      status: t.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "id",
          fieldLabel: "Id"
          // User can override but we provide default
        },
        {
          appFieldName: "number",
          fieldLabel: "Number"
          // User can override but we provide default
        },
        {
          appFieldName: "courseName",
          fieldLabel: "Course name"
          // User can override but we provide default
        },
        {
          appFieldName: "courseCode",
          fieldLabel: "Course code"
          // User can override but we provide default
        },
        {
          appFieldName: "department",
          fieldLabel: "Department"
          // User can override but we provide default
        }
      ]
    },
    {
      applicationObjectTypeName: "module",
      applicationObjectTypeGroup: t.EApplicationObjectTypeGroup.COURSE_INFORMATION,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "Module",
      // User is free to override, but we provide a default
      status: t.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "id",
          fieldLabel: "Id"
          // User can override but we provide default
        },
        {
          appFieldName: "credits",
          fieldLabel: "Credits"
          // User can override but we provide default
        },
        {
          appFieldName: "moduleId",
          fieldLabel: "Module Id"
          // User can override but we provide default
        },
        {
          appFieldName: "code",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Code"
        },
        {
          appFieldName: "courseCode",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Course Code"
        },
        {
          appFieldName: "department",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Department"
        }
      ]
    },
    {
      applicationObjectTypeName: "coursePart",
      applicationObjectTypeGroup: t.EApplicationObjectTypeGroup.COURSE_INFORMATION,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "Course Part",
      // User is free to override, but we provide a default
      status: t.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "id",
          fieldLabel: "Id"
          // User can override but we provide default
        },
        {
          appFieldName: "credits",
          fieldLabel: "Credits"
          // User can override but we provide default
        },
        {
          appFieldName: "code",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Code"
        },
        {
          appFieldName: "courseCode",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Course Code"
        },
        {
          appFieldName: "department",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Department"
        }
      ]
    },
    {
      applicationObjectTypeName: "program",
      applicationObjectTypeGroup: t.EApplicationObjectTypeGroup.COURSE_INFORMATION,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "Program",
      // User is free to override, but we provide a default
      status: t.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "id",
          fieldLabel: "Id"
          // User can override but we provide default
        },
        {
          appFieldName: "number",
          fieldLabel: "Number"
          // User can override but we provide default
        },
        {
          appFieldName: "code",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Code"
        },
        {
          appFieldName: "credits",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Credits"
        },
        {
          appFieldName: "courseCode",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Course Code"
        },
        {
          appFieldName: "department",
          appProperty: null,
          fieldExtId: null,
          fieldLabel: "Department"
        }
      ]
    },
    {
      applicationObjectTypeName: "studentGroup",
      applicationObjectTypeGroup: t.EApplicationObjectTypeGroup.COURSE_INFORMATION,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "Student Group",
      // User is free to override, but we provide a default
      status: t.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "id",
          fieldLabel: "Id"
          // User can override but we provide default
        },
        {
          appFieldName: "number",
          fieldLabel: "Number"
          // User can override but we provide default
        },
        {
          appFieldName: "courseName",
          fieldLabel: "Course name"
          // User can override but we provide default
        },
        {
          appFieldName: "courseCode",
          fieldLabel: "Course code"
          // User can override but we provide default
        },
        {
          appFieldName: "department",
          fieldLabel: "Department"
          // User can override but we provide default
        }
      ]
    },
    {
      applicationObjectTypeName: "costCenter",
      applicationObjectTypeGroup: t.EApplicationObjectTypeGroup.INVOICING,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "Cost center",
      // User is free to override, but we provide a default
      status: t.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "id",
          fieldLabel: "Id"
          // User can override but we provide default
        }
      ]
    },
    {
      applicationObjectTypeName: "department",
      applicationObjectTypeGroup: t.EApplicationObjectTypeGroup.INVOICING,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "Department",
      // User is free to override, but we provide a default
      status: t.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "code",
          fieldLabel: "code"
          // User can override but we provide default
        }
      ]
    },
    {
      applicationObjectTypeName: "externalCustomer",
      applicationObjectTypeGroup: t.EApplicationObjectTypeGroup.INVOICING,
      objectTypeExtId: null,
      // This is set in the mapping by the user, not in the template
      applicationObjectTypeLabel: "External Customer",
      // User is free to override, but we provide a default
      status: t.EObjectTypeMappingStatuses.NOT_MAPPED,
      labelField: null,
      secondaryLabelField: null,
      fields: [
        {
          appFieldName: "name",
          fieldLabel: "Name"
          // User can override but we provide default
        },
        {
          appFieldName: "id",
          fieldLabel: "Id"
          // User can override but we provide default
        }
      ]
    }
  ], Bt;
}
var ae = {}, Wi;
function As() {
  return Wi || (Wi = 1, Object.defineProperty(ae, "__esModule", { value: !0 }), ae.mongoReactSortOrderMapping = ae.mongoSortOrders = ae.studentSetGenerationStatusStringValues = ae.dataManagerObjectReviewStatusses = ae.generateStudentSetsSortableFields = ae.reviewByCourseSortableFields = ae.reviewByStudyCombinationSortableFields = void 0, ae.reviewByStudyCombinationSortableFields = [
    "inputObject.inputContent.expectedEnrollment",
    "inputObject.inputContent.status",
    "reviewStatus",
    "metadata.courses",
    "metadata.totalCredits",
    "inputObject.inputContent.historicalEnrollmentCopyForSortingAndFiltering"
  ], ae.reviewByCourseSortableFields = [
    "name",
    "combinationIds",
    "expectedEnrollmentOfCourse",
    "expectedEnrollmentOfStudyCombinations",
    "expectedEnrollmentDiff",
    "numberOfStudyCombinations"
  ], ae.generateStudentSetsSortableFields = [
    "studentSetGenerationStatusString",
    "metadata.courses",
    "inputObject.inputContent.historicalEnrollmentCopyForSortingAndFiltering"
  ], ae.dataManagerObjectReviewStatusses = ["NOT_REVIEWED", "KEEP", "REJECTED", "DELETED"], ae.studentSetGenerationStatusStringValues = [
    "ACTIVITY_DATA_ERROR",
    "GENERATION_ERROR",
    "ALLOCATION_ERROR",
    "DEALLOCATION_ERROR",
    "COMPLETE",
    "GENERATING",
    "STUDENT_SETS_GENERATED",
    "STUDENT_SETS_ALLOCATED"
  ], ae.mongoSortOrders = [-1, 1], ae.mongoReactSortOrderMapping = {
    asc: 1,
    desc: -1
  }), ae;
}
var de = {}, xi;
function Ss() {
  return xi || (xi = 1, Object.defineProperty(de, "__esModule", { value: !0 }), de.CALENDAR_WEEK_MODE = de.FORM_SOURCE = de.AUTO_CALCULATION = de.EVENT_OUTSIDE_ENUM = de.FORM_TYPE = de.FORM_STATUS_TYPE = void 0, de.FORM_STATUS_TYPE = {
    FORM_STATUS_DRAFT: "FORM_STATUS_DRAFT",
    FORM_STATUS_ACTIVE: "FORM_STATUS_ACTIVE",
    FORM_STATUS_ARCHIVED: "FORM_STATUS_ARCHIVED",
    FORM_STATUS_PUBLISHED: "FORM_STATUS_PUBLISHED"
  }, de.FORM_TYPE = {
    REGULAR: "REGULAR",
    AVAILABILITY: "AVAILABILITY",
    UNAVAILABILITY: "UNAVAILABILITY",
    PATHWAYS: "PATHWAYS"
  }, de.EVENT_OUTSIDE_ENUM = {
    MANUAL: "MANUAL",
    MODIFY: "MODIFY",
    REMOVE: "REMOVE"
  }, de.AUTO_CALCULATION = {
    TRACKS: "TRACKS",
    MAX_CLASS_SIZE: "MAX_CLASS_SIZE",
    OFF: "OFF"
  }, de.FORM_SOURCE = {
    ACTIVITY_CREATE_TEMPLATE: "ACTIVITY_CREATE_TEMPLATE"
  }, de.CALENDAR_WEEK_MODE = {
    INDIVIDUAL: "individual",
    RECURRING: "recurring"
  }), de;
}
var Gt = {}, Ki;
function Os() {
  return Ki || (Ki = 1, Object.defineProperty(Gt, "__esModule", { value: !0 }), Gt.FORM_INSTANCE_STATUS_TYPE = void 0, Gt.FORM_INSTANCE_STATUS_TYPE = {
    NOT_SENT: "NOT_SENT",
    SENT: "SENT",
    OPENED: "OPENED",
    DRAFT: "DRAFT",
    SUBMITTED: "SUBMITTED",
    OVERDUE: "OVERDUE",
    INVALIDATE: "INVALIDATE",
    DECLINED: "DECLINED",
    COLLABORATED: "COLLABORATED"
  }), Gt;
}
var tt = {}, Zi;
function Rs() {
  return Zi || (Zi = 1, Object.defineProperty(tt, "__esModule", { value: !0 }), tt.TE_CORE_SCHEDULING_PROGRESS = tt.TE_CORE_ACCEPTANCE_STATUS = void 0, tt.TE_CORE_ACCEPTANCE_STATUS = {
    NOT_SET: "NOT_SET",
    ACCEPTED: "ACCEPTED",
    REJECTED: "REJECTED"
  }, tt.TE_CORE_SCHEDULING_PROGRESS = {
    NOT_SCHEDULED: "NOT_SCHEDULED",
    IN_PROGRESS: "IN_PROGRESS",
    SCHEDULING_FINISHED: "SCHEDULING_FINISHED"
  }), tt;
}
var rt = {}, Ji;
function hs() {
  return Ji || (Ji = 1, Object.defineProperty(rt, "__esModule", { value: !0 }), rt.pathwayStatuses = rt.pathwaysNameSuffixTypes = void 0, rt.pathwaysNameSuffixTypes = {
    ALPHA: "ALPHA",
    DECIMAL: "DECIMAL",
    ROMAN: "ROMAN"
  }, rt.pathwayStatuses = {
    NEW: "NEW",
    ACCEPTED: "ACCEPTED",
    EDITED: "EDITED",
    REJECTED: "REJECTED"
  }), rt;
}
var je = {}, Xi;
function vs() {
  return Xi || (Xi = 1, Object.defineProperty(je, "__esModule", { value: !0 }), je.exportedUserColumns = je.TEUserImportPropertiesArr = je.userProfilePropertiesArr = void 0, je.userProfilePropertiesArr = [
    "id",
    "legacyId",
    "profileName",
    "description",
    "contactEmail",
    "standardOrganization",
    "organizationsAndRoles",
    "scopes",
    "appPermissions",
    "userObjects",
    "inactiveSince"
  ], je.TEUserImportPropertiesArr = [
    "inactiveSince",
    "username",
    "email",
    "firstName",
    "lastName",
    "language",
    "dateFormat",
    "timezone",
    "displayTimezones",
    "visibility",
    "personalData",
    "description",
    "recoveryEmail",
    "contactEmail",
    "standardOrganization",
    "organizationsAndRoles",
    "scopes",
    "appPermissions",
    "userObjects",
    "lockedForExternalAuthentication"
  ], je.exportedUserColumns = {
    id: "Profile ID",
    profileName: "Profile Name",
    email: "Email",
    username: "User Name",
    firstName: "First Name",
    lastName: "Last Name",
    contactEmail: "Contact Email",
    userObjects: "User Objects",
    standardOrganization: "Standard Organization",
    organizationsAndRoles: "Org Nodes & Roles",
    scopes: "Scopes",
    appPermissions: "App Permissions",
    language: "Language",
    inactiveSince: "Inactive Since",
    logins: "Last Login",
    visibility: "Visibility",
    description: "Description",
    lockedForExternalAuthentication: "Locked for External Authentication"
  }), je;
}
var $t = {}, Qi;
function Is() {
  return Qi || (Qi = 1, Object.defineProperty($t, "__esModule", { value: !0 }), $t.TERootUserInfoPropertiesArr = void 0, $t.TERootUserInfoPropertiesArr = ["id", "firstName", "lastName", "email"]), $t;
}
var Vt = {}, ea;
function Ps() {
  return ea || (ea = 1, Object.defineProperty(Vt, "__esModule", { value: !0 }), Vt.FINGERPRINT_COOKIE_NAME = void 0, Vt.FINGERPRINT_COOKIE_NAME = "te_fingerprint"), Vt;
}
var kt = {}, ta;
function qo() {
  if (ta) return kt;
  ta = 1, Object.defineProperty(kt, "__esModule", { value: !0 }), kt.REGION_LOCATIONS = void 0;
  const t = Nn();
  return kt.REGION_LOCATIONS = {
    [t.ERegion.ANZ]: "anz",
    [t.ERegion.EU_EES]: "eu",
    [t.ERegion.SGP]: "sgp",
    [t.ERegion.UK]: "uk"
  }, kt;
}
var ra;
function Ho() {
  return ra || (ra = 1, (function(t) {
    var r = Ye && Ye.__createBinding || (Object.create ? (function(f, _, u, b) {
      b === void 0 && (b = u);
      var O = Object.getOwnPropertyDescriptor(_, u);
      (!O || ("get" in O ? !_.__esModule : O.writable || O.configurable)) && (O = { enumerable: !0, get: function() {
        return _[u];
      } }), Object.defineProperty(f, b, O);
    }) : (function(f, _, u, b) {
      b === void 0 && (b = u), f[b] = _[u];
    })), a = Ye && Ye.__exportStar || function(f, _) {
      for (var u in f) u !== "default" && !Object.prototype.hasOwnProperty.call(_, u) && r(_, f, u);
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.DefaultTEExamObjectTypesMapping = t.ObjectTypeGroupProps = t.AppPropertyProps = t.ObjectTypeMappingStatusProps = t.FieldMappingModeProps = t.SERVICE_ACCOUNT = t.TE_ROOT_USER = t.SCOPE_LEVEL_SUPER = t.SCOPE_LEVEL_ADMIN = t.ScopeLevelArr = t.AppIdsArr = void 0;
    const o = as();
    Object.defineProperty(t, "AppIdsArr", { enumerable: !0, get: function() {
      return o.AppIdsArr;
    } });
    const d = Lo();
    Object.defineProperty(t, "ScopeLevelArr", { enumerable: !0, get: function() {
      return d.ScopeLevelArr;
    } }), Object.defineProperty(t, "SCOPE_LEVEL_ADMIN", { enumerable: !0, get: function() {
      return d.SCOPE_LEVEL_ADMIN;
    } }), Object.defineProperty(t, "SCOPE_LEVEL_SUPER", { enumerable: !0, get: function() {
      return d.SCOPE_LEVEL_SUPER;
    } }), Object.defineProperty(t, "TE_ROOT_USER", { enumerable: !0, get: function() {
      return d.TE_ROOT_USER;
    } }), Object.defineProperty(t, "SERVICE_ACCOUNT", { enumerable: !0, get: function() {
      return d.SERVICE_ACCOUNT;
    } });
    const E = gs();
    Object.defineProperty(t, "FieldMappingModeProps", { enumerable: !0, get: function() {
      return E.FieldMappingModeProps;
    } });
    const m = ys();
    Object.defineProperty(t, "AppPropertyProps", { enumerable: !0, get: function() {
      return m.AppPropertyProps;
    } }), Object.defineProperty(t, "ObjectTypeMappingStatusProps", { enumerable: !0, get: function() {
      return m.ObjectTypeMappingStatusProps;
    } }), Object.defineProperty(t, "ObjectTypeGroupProps", { enumerable: !0, get: function() {
      return m.ObjectTypeGroupProps;
    } });
    const c = _s();
    Object.defineProperty(t, "DefaultTEExamObjectTypesMapping", { enumerable: !0, get: function() {
      return c.DefaultTEExamObjectTypesMapping;
    } }), t.default = {
      AppIdsArr: o.AppIdsArr,
      ScopeLevelArr: d.ScopeLevelArr,
      SCOPE_LEVEL_ADMIN: d.SCOPE_LEVEL_ADMIN,
      SCOPE_LEVEL_SUPER: d.SCOPE_LEVEL_SUPER,
      TE_ROOT_USER: d.TE_ROOT_USER,
      SERVICE_ACCOUNT: d.SERVICE_ACCOUNT,
      FieldMappingModeProps: E.FieldMappingModeProps,
      ObjectTypeMappingStatusProps: m.ObjectTypeMappingStatusProps,
      AppPropertyProps: m.AppPropertyProps,
      ObjectTypeGroupProps: m.ObjectTypeGroupProps,
      DefaultTEExamObjectTypesMapping: c.DefaultTEExamObjectTypesMapping
    }, a(As(), t), a(Ss(), t), a(Os(), t), a(Rs(), t), a(hs(), t), a(vs(), t), a(Is(), t), a(Ps(), t), a(qo(), t);
  })(Ye)), Ye;
}
var nt = {}, kr = {}, na;
function Cs() {
  return na || (na = 1, Object.defineProperty(kr, "__esModule", { value: !0 })), kr;
}
var qr = {}, ia;
function Ns() {
  return ia || (ia = 1, Object.defineProperty(qr, "__esModule", { value: !0 })), qr;
}
var qt = {}, aa;
function Ms() {
  return aa || (aa = 1, Object.defineProperty(qt, "__esModule", { value: !0 }), qt.SERVICE_ACCOUNT_USE_WITH_CAUTION = void 0, qt.SERVICE_ACCOUNT_USE_WITH_CAUTION = "SERVICE_ACCOUNT_USE_WITH_CAUTION"), qt;
}
var Hr = {}, oa;
function Ds() {
  return oa || (oa = 1, Object.defineProperty(Hr, "__esModule", { value: !0 })), Hr;
}
var zr = {}, ua;
function js() {
  return ua || (ua = 1, Object.defineProperty(zr, "__esModule", { value: !0 })), zr;
}
var Yr = {}, sa;
function Ls() {
  return sa || (sa = 1, Object.defineProperty(Yr, "__esModule", { value: !0 })), Yr;
}
var Wr = {}, la;
function Us() {
  return la || (la = 1, Object.defineProperty(Wr, "__esModule", { value: !0 })), Wr;
}
var xr = {}, ca;
function Fs() {
  return ca || (ca = 1, Object.defineProperty(xr, "__esModule", { value: !0 })), xr;
}
var Kr = {}, da;
function ws() {
  return da || (da = 1, Object.defineProperty(Kr, "__esModule", { value: !0 })), Kr;
}
var Zr = {}, pa;
function Bs() {
  return pa || (pa = 1, Object.defineProperty(Zr, "__esModule", { value: !0 })), Zr;
}
var Jr = {}, ma;
function Gs() {
  return ma || (ma = 1, Object.defineProperty(Jr, "__esModule", { value: !0 })), Jr;
}
var Xr = {}, fa;
function $s() {
  return fa || (fa = 1, Object.defineProperty(Xr, "__esModule", { value: !0 })), Xr;
}
var Qr = {}, Ea;
function Vs() {
  return Ea || (Ea = 1, Object.defineProperty(Qr, "__esModule", { value: !0 })), Qr;
}
var Le = {}, Ta;
function ks() {
  if (Ta) return Le;
  Ta = 1, Object.defineProperty(Le, "__esModule", { value: !0 }), Le.EFullWeekDays = Le.ETimeScope = Le.EDynamicAvailabilityType = void 0;
  var t;
  (function(o) {
    o.TOTAL_HOURS = "TOTAL_HOURS", o.CONSECUTIVE_HOURS = "CONSECUTIVE_HOURS", o.FREE_TIME = "FREE_TIME", o.TOTAL_RESERVATIONS = "TOTAL_RESERVATIONS";
  })(t || (Le.EDynamicAvailabilityType = t = {}));
  var r;
  (function(o) {
    o.DAILY = "DAILY", o.WEEKLY = "WEEKLY";
  })(r || (Le.ETimeScope = r = {}));
  var a;
  return (function(o) {
    o.SUNDAY = "SUNDAY", o.MONDAY = "MONDAY", o.TUESDAY = "TUESDAY", o.WEDNESDAY = "WEDNESDAY", o.THURSDAY = "THURSDAY", o.FRIDAY = "FRIDAY", o.SATURDAY = "SATURDAY";
  })(a || (Le.EFullWeekDays = a = {})), Le;
}
var en = {}, ba;
function qs() {
  return ba || (ba = 1, Object.defineProperty(en, "__esModule", { value: !0 })), en;
}
var tn = {}, ga;
function Hs() {
  return ga || (ga = 1, Object.defineProperty(tn, "__esModule", { value: !0 })), tn;
}
var rn = {}, ya;
function zs() {
  return ya || (ya = 1, Object.defineProperty(rn, "__esModule", { value: !0 })), rn;
}
var _a;
function Ys() {
  return _a || (_a = 1, (function(t) {
    var r = nt && nt.__createBinding || (Object.create ? (function(u, b, O, T) {
      T === void 0 && (T = O);
      var A = Object.getOwnPropertyDescriptor(b, O);
      (!A || ("get" in A ? !b.__esModule : A.writable || A.configurable)) && (A = { enumerable: !0, get: function() {
        return b[O];
      } }), Object.defineProperty(u, T, A);
    }) : (function(u, b, O, T) {
      T === void 0 && (T = O), u[T] = b[O];
    })), a = nt && nt.__exportStar || function(u, b) {
      for (var O in u) O !== "default" && !Object.prototype.hasOwnProperty.call(b, O) && r(b, u, O);
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.SERVICE_ACCOUNT_USE_WITH_CAUTION = t.ETokenType = t.EWeekdaySelection = t.EWeekdays = t.EReservationPeriodType = t.ERelativeTimeTypes = t.EPermissionTypes = t.EExternalServices = t.EExternalServiceMethods = t.EAuth = t.EAppId = void 0;
    var o = In();
    Object.defineProperty(t, "EAppId", { enumerable: !0, get: function() {
      return o.EAppId;
    } });
    var d = Uo();
    Object.defineProperty(t, "EAuth", { enumerable: !0, get: function() {
      return d.EAuth;
    } });
    var E = Fo();
    Object.defineProperty(t, "EExternalServiceMethods", { enumerable: !0, get: function() {
      return E.EExternalServiceMethods;
    } }), Object.defineProperty(t, "EExternalServices", { enumerable: !0, get: function() {
      return E.EExternalServices;
    } });
    var m = Pn();
    Object.defineProperty(t, "EPermissionTypes", { enumerable: !0, get: function() {
      return m.EPermissionTypes;
    } });
    var c = wo();
    Object.defineProperty(t, "ERelativeTimeTypes", { enumerable: !0, get: function() {
      return c.ERelativeTimeTypes;
    } }), Object.defineProperty(t, "EReservationPeriodType", { enumerable: !0, get: function() {
      return c.EReservationPeriodType;
    } }), Object.defineProperty(t, "EWeekdays", { enumerable: !0, get: function() {
      return c.EWeekdays;
    } }), Object.defineProperty(t, "EWeekdaySelection", { enumerable: !0, get: function() {
      return c.EWeekdaySelection;
    } });
    var f = Bo();
    Object.defineProperty(t, "ETokenType", { enumerable: !0, get: function() {
      return f.ETokenType;
    } }), a(Cs(), t), a(Ns(), t);
    var _ = Ms();
    Object.defineProperty(t, "SERVICE_ACCOUNT_USE_WITH_CAUTION", { enumerable: !0, get: function() {
      return _.SERVICE_ACCOUNT_USE_WITH_CAUTION;
    } }), a(Cn(), t), a(Ds(), t), a(js(), t), a(Ls(), t), a(Us(), t), a(Fs(), t), a(ws(), t), a(Bs(), t), a(Gs(), t), a($s(), t), a(Vs(), t), a(ks(), t), a(qs(), t), a(Hs(), t), a(zs(), t);
  })(nt)), nt;
}
var nn = {}, Ht = {}, zt = {}, Aa;
function Ws() {
  if (Aa) return zt;
  Aa = 1, Object.defineProperty(zt, "__esModule", { value: !0 }), zt.ESAMLParameterType = void 0;
  var t;
  return (function(r) {
    r.CUSTOM_PARAMETERS = "CUSTOM_PARAMETERS", r.RELAY_STATE = "RELAY_STATE";
  })(t || (zt.ESAMLParameterType = t = {})), zt;
}
var Sa;
function xs() {
  if (Sa) return Ht;
  Sa = 1, Object.defineProperty(Ht, "__esModule", { value: !0 }), Ht.createAuthConfig = void 0;
  const t = pe(), r = Ws(), a = Cn(), o = (d) => {
    var E, m, c, f;
    return {
      id: d.id,
      name: d.name,
      description: d.description,
      strategy: d.strategy || t.EAuthStrategy.TE_IDP,
      config: d.strategy === t.EAuthStrategy.SAML2 ? Object.assign(Object.assign({}, d.config), { parameterType: ((E = d.config) === null || E === void 0 ? void 0 : E.parameterType) || r.ESAMLParameterType.CUSTOM_PARAMETERS, signAuthnRequest: (c = (m = d.config) === null || m === void 0 ? void 0 : m.signAuthnRequest) !== null && c !== void 0 ? c : !0, identifierFormat: ((f = d.config) === null || f === void 0 ? void 0 : f.identifierFormat) || a.SAMLIdentifierFormat.Email }) : Object.assign(Object.assign({}, d.config), { useMFA: d.config.useMFA || !1 }),
      active: d.active || !1,
      default: d.default || !1,
      enabledForAppIds: d.enabledForAppIds || []
    };
  };
  return Ht.createAuthConfig = o, Ht;
}
var Yt = {}, it = {}, Oa;
function Ks() {
  if (Oa) return it;
  Oa = 1, Object.defineProperty(it, "__esModule", { value: !0 }), it.EImportStatus = it.EImportType = void 0;
  var t;
  (function(a) {
    a.ORGANIZATION_HIERARCHY = "ORGANIZATION_HIERARCHY", a.USERS = "USERS", a.AUTH_CONFIGS = "AUTH_CONFIGS";
  })(t || (it.EImportType = t = {}));
  var r;
  return (function(a) {
    a.SUCCESS = "SUCCESS", a.FAILURE = "FAILURE";
  })(r || (it.EImportStatus = r = {})), it;
}
var Ra;
function Zs() {
  if (Ra) return Yt;
  Ra = 1, Object.defineProperty(Yt, "__esModule", { value: !0 }), Yt.createImport = void 0;
  const t = Ks(), r = (a) => ({
    id: a.id,
    type: a.type || t.EImportType.ORGANIZATION_HIERARCHY,
    settings: a.settings || { fromCustomerSignature: "" },
    status: a.status || t.EImportStatus.FAILURE,
    log: a.log || [],
    timestamp: a.timestamp
  });
  return Yt.createImport = r, Yt;
}
var Wt = {}, ha;
function Js() {
  if (ha) return Wt;
  ha = 1, Object.defineProperty(Wt, "__esModule", { value: !0 }), Wt.createAltDesignation = void 0;
  const t = (r) => ({
    language: r,
    name: "",
    description: ""
  });
  return Wt.createAltDesignation = t, Wt;
}
var xt = {}, Kt = {}, va;
function zo() {
  if (va) return Kt;
  va = 1, Object.defineProperty(Kt, "__esModule", { value: !0 }), Kt.EOrganizationVisibility = void 0;
  var t;
  return (function(r) {
    r.PUBLIC = "PUBLIC", r.HIDDEN = "HIDDEN", r.PRIVATE = "PRIVATE";
  })(t || (Kt.EOrganizationVisibility = t = {})), Kt;
}
var Ia;
function Xs() {
  if (Ia) return xt;
  Ia = 1, Object.defineProperty(xt, "__esModule", { value: !0 }), xt.createOrganization = void 0;
  const t = pe(), r = zo(), a = (o) => ({
    id: o.id,
    name: o.name,
    customerSignature: o.customerSignature,
    customerLogo: o.customerLogo,
    customerColor: o.customerColor,
    teServerUrl: o.teServerUrl,
    public: o.public,
    inactive: !1,
    inactiveSince: null,
    enabledProducts: o.enabledProducts || [],
    type: o.type || t.EOrganizationType.CUSTOMER_PRODUCTION,
    visibility: o.visibility || r.EOrganizationVisibility.PUBLIC,
    rootUserPermissions: o.rootUserPermissions || [],
    rootUserStandardOrganizationNode: o.rootUserStandardOrganizationNode,
    region: o.region,
    cluster: o.cluster,
    database: o.database,
    language: o.language,
    dateFormat: o.dateFormat
  });
  return xt.createOrganization = a, xt;
}
var Zt = {}, Pa;
function Qs() {
  if (Pa) return Zt;
  Pa = 1, Object.defineProperty(Zt, "__esModule", { value: !0 }), Zt.createOrganizationNode = void 0;
  const t = (r) => ({
    id: r.id,
    extId: r.extId || void 0,
    legacyId: r.legacyId || void 0,
    name: r.name,
    description: r.description || void 0,
    parentNodeIds: r.parentNodeIds || []
  });
  return Zt.createOrganizationNode = t, Zt;
}
var an = {}, Ca;
function el() {
  return Ca || (Ca = 1, (function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.createOrganizationTreeNode = void 0;
    const r = (a) => ({
      id: a.id,
      children: (a.children || []).map((o) => (0, t.createOrganizationTreeNode)(o)),
      name: a.name,
      virtualId: a.virtualId
    });
    t.createOrganizationTreeNode = r;
  })(an)), an;
}
var Jt = {}, Na;
function tl() {
  if (Na) return Jt;
  Na = 1, Object.defineProperty(Jt, "__esModule", { value: !0 }), Jt.createPaddingRule = void 0;
  const t = pe(), r = (a) => ({
    id: a.id,
    paddingType: a.paddingType || t.EPaddingRuleType.DIRECT,
    name: a.name || "",
    description: a.description || "",
    includeAbstractObjects: a.includeAbstractObjects || !1,
    rule: a.rule || {
      objectsOnReservation: [],
      impactedObjects: [],
      paddingBefore: 0,
      paddingAfter: 0
    },
    history: a.history
  });
  return Jt.createPaddingRule = r, Jt;
}
var Xt = {}, Ma;
function rl() {
  if (Ma) return Xt;
  Ma = 1, Object.defineProperty(Xt, "__esModule", { value: !0 }), Xt.createPermission = void 0;
  const t = pe(), r = (a) => ({
    type: a.type || t.EPermissionTypes.SCOPE,
    value: a.value,
    name: a.name,
    description: a.description || void 0,
    requiredScopeLevel: a.requiredScopeLevel || void 0
  });
  return Xt.createPermission = r, Xt;
}
var Ue = {}, Da;
function nl() {
  if (Da) return Ue;
  Da = 1, Object.defineProperty(Ue, "__esModule", { value: !0 }), Ue.createRolePermissionGroup = Ue.createRolePermission = Ue.createRole = void 0;
  const t = (o) => ({
    id: o.id,
    name: o.name,
    description: o.description || "",
    rolePermissions: o.rolePermissions || []
  });
  Ue.createRole = t;
  const r = (o) => ({
    id: o.id,
    name: o.name,
    rolePermissionGroup: o.rolePermissionGroup,
    groupActions: o.groupActions || []
  });
  Ue.createRolePermission = r;
  const a = (o) => ({
    id: o.id,
    groupActions: o.groupActions || []
  });
  return Ue.createRolePermissionGroup = a, Ue;
}
var Qt = {}, ja;
function il() {
  if (ja) return Qt;
  ja = 1, Object.defineProperty(Qt, "__esModule", { value: !0 }), Qt.createSOAPConnectionSettings = void 0;
  const t = (r) => ({
    username: r.username || "",
    password: r.password || "",
    certificateKey: r.certificateKey || "",
    baseUrl: r.baseUrl || ""
  });
  return Qt.createSOAPConnectionSettings = t, Qt;
}
var _e = {}, La;
function al() {
  if (La) return _e;
  La = 1, Object.defineProperty(_e, "__esModule", { value: !0 }), _e.createEmptyTWeekdaySelection = _e.createTTime = _e.createEmptyTTime = _e.createEmptyTTimeRule = void 0;
  const t = pe(), r = () => ({
    name: "",
    id: 0,
    description: "",
    history: [],
    weekdays: [t.EWeekdays.MON, t.EWeekdays.TUE, t.EWeekdays.WED, t.EWeekdays.THU, t.EWeekdays.FRI, t.EWeekdays.SAT, t.EWeekdays.SUN],
    clockTimeStart: 28800,
    clockTimeEnd: 64800,
    standardStep: 900,
    minimumStep: 900,
    beginStep: 900,
    importStep: 900,
    minimumLength: 1800,
    maximumLength: 86400,
    defaultLength: 3600,
    beginOffset: 0,
    relativeStartTime: -15552e3,
    relativeEndTime: 4752e4,
    useStartTimeToOpenNextDay: !1,
    useSeparateCancellationRules: !1,
    relativeCancellationStartTime: -15552e3,
    relativeCancellationEndTime: 4752e4,
    reservationPeriod1: t.EReservationPeriodType.NONE,
    reservationLength1: 0,
    reservationCount1: 0,
    reservationPeriod2: t.EReservationPeriodType.NONE,
    reservationLength2: 0,
    reservationCount2: 0,
    useModifiedByWhenCalculatingUserQuota: !1,
    templates: []
  });
  _e.createEmptyTTimeRule = r;
  const a = () => ({
    clockTimeStart: 28800,
    clockTimeEnd: 36e3
  });
  _e.createEmptyTTime = a;
  const o = (E, m) => ({
    clockTimeStart: E,
    clockTimeEnd: m
  });
  _e.createTTime = o;
  const d = () => ({
    weekdays: [],
    times: []
  });
  return _e.createEmptyTWeekdaySelection = d, _e;
}
var Ee = {}, Ua;
function ol() {
  if (Ua) return Ee;
  Ua = 1, Object.defineProperty(Ee, "__esModule", { value: !0 }), Ee.createUnsignedFromM2MUser = Ee.createUnsignedReadOnlyFromTERootUser = Ee.createUnsignedFromTERootUser = Ee.createUnsignedReadOnlyFromTEUser = Ee.createUnsignedFromTEUser = void 0;
  const t = pe(), r = Lo(), a = (c, f, _, u) => {
    var b;
    return {
      region: f,
      id: c.id || "",
      type: t.ETokenType.USER,
      username: c.username,
      email: c.email,
      organizationId: _,
      customerSignature: u,
      appPermissions: c.appPermissions,
      scopes: c.scopes,
      profile: { id: c.id, profileName: c.profileName },
      profiles: ((b = c.profiles) === null || b === void 0 ? void 0 : b.filter(({ inactiveSince: O }) => O === null).map(({ id: O, profileName: T }) => ({ id: O, profileName: T }))) || [],
      organizationsAndRoles: c.organizationsAndRoles
    };
  };
  Ee.createUnsignedFromTEUser = a;
  const o = (c, f, _, u) => ({
    region: f,
    id: c.id || "",
    type: t.ETokenType.USER,
    email: c.email,
    username: c.username,
    organizationId: _,
    customerSignature: u,
    appPermissions: [],
    scopes: ["TE_Viewer::readOnly"]
  });
  Ee.createUnsignedReadOnlyFromTEUser = o;
  const d = (c, f, _, u) => ({
    region: f,
    id: c.id || "",
    type: t.ETokenType.USER,
    email: c.email,
    organizationId: _,
    customerSignature: u,
    appPermissions: [],
    scopes: [r.TE_ROOT_USER]
  });
  Ee.createUnsignedFromTERootUser = d;
  const E = (c, f, _, u) => ({
    region: f,
    id: c.id || "",
    type: t.ETokenType.USER,
    email: c.email,
    organizationId: _,
    customerSignature: u,
    appPermissions: [],
    scopes: ["TE_Viewer::readOnly"]
  });
  Ee.createUnsignedReadOnlyFromTERootUser = E;
  const m = (c, f, _, u) => ({
    region: f,
    id: c.id || "",
    type: t.ETokenType.M2M,
    organizationId: _,
    customerSignature: u,
    appPermissions: c.appPermissions,
    scopes: c.scopes,
    organizationsAndRoles: c.organizationsAndRoles
  });
  return Ee.createUnsignedFromM2MUser = m, Ee;
}
var er = {}, Fa;
function ul() {
  if (Fa) return er;
  Fa = 1, Object.defineProperty(er, "__esModule", { value: !0 }), er.createTokenPermissions = void 0;
  const t = (r) => ({
    appPermissions: r.appPermissions || [],
    scopes: r.scopes || []
  });
  return er.createTokenPermissions = t, er;
}
var tr = {}, wa;
function sl() {
  if (wa) return tr;
  wa = 1, Object.defineProperty(tr, "__esModule", { value: !0 }), tr.createEmptyType = void 0;
  const t = () => ({
    name: "",
    extId: "",
    id: 0,
    active: !0,
    personalData: !1,
    sensitiveData: !1,
    description: "",
    altDesignations: [],
    allowStandardObjects: !1,
    allowAbstractObjects: !1,
    allowVirtualObjects: !1,
    personType: !1,
    locationType: !1,
    aliasType: 0,
    externalOwner: "",
    subTypes: [],
    fields: [],
    parentFields: [],
    organizations: [],
    reservationTemplates: [],
    documentation: "",
    history: [],
    skipLastReserved: !1
  });
  return tr.createEmptyType = t, tr;
}
var on = {}, Ba;
function ll() {
  return Ba || (Ba = 1, (function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.createUserCSVMapper = t.mapUserCSVData = t.getLabelForUser = t.createFromTemplateWithNewUsernameAndAuthConfig = t.createUser = void 0;
    const r = Ho(), a = pe(), o = (u) => ({
      inactiveSince: u.inactiveSince,
      id: u.id,
      /**
       * DESCRIPTIVES
       */
      username: u.username,
      email: u.email,
      firstName: u.firstName,
      lastName: u.lastName,
      recoveryEmail: u.recoveryEmail,
      contactEmail: u.contactEmail,
      /**
       * LEGACY INFORMATION
       */
      legacyId: u.legacyId || null,
      /**
       * CONFIG SETTINGS
       */
      language: u.language,
      dateFormat: u.dateFormat,
      displayTimezones: u.displayTimezones,
      timezone: u.timezone,
      visibility: u.visibility || a.EUserVisibility.STANDARD,
      personalData: u.personalData,
      description: u.description,
      /**
       * ORGANIZATIONS AND PERMISSIONS
       */
      standardOrganization: u.standardOrganization,
      organizationsAndRoles: u.organizationsAndRoles,
      scopes: u.scopes,
      appPermissions: u.appPermissions,
      profileName: u.profileName,
      profiles: u.profiles,
      /**
       * USER OBJECTS
       */
      userObjects: u.userObjects,
      /**
       * AUTH CONFIGS
       */
      authConfigId: u.authConfigId,
      logins: u.logins || [],
      createdBy: u.createdBy,
      history: u.history || [],
      lockedForExternalAuthentication: u.lockedForExternalAuthentication || !1,
      createdAt: u.createdAt,
      updatedAt: u.updatedAt
    });
    t.createUser = o;
    const d = (u, b, O) => ({
      inactiveSince: null,
      id: u.id,
      /**
       * DESCRIPTIVES
       */
      username: b,
      email: "",
      firstName: null,
      lastName: null,
      recoveryEmail: null,
      contactEmail: null,
      /**
       * LEGACY INFORMATION
       */
      legacyId: null,
      /**
       * CONFIG SETTINGS
       */
      language: u.language,
      dateFormat: u.dateFormat,
      displayTimezones: u.displayTimezones,
      timezone: u.timezone,
      visibility: a.EUserVisibility.STANDARD,
      personalData: !0,
      description: null,
      /**
       * ORGANIZATIONS AND PERMISSIONS
       */
      standardOrganization: u.standardOrganization,
      organizationsAndRoles: u.organizationsAndRoles,
      scopes: u.scopes,
      appPermissions: u.appPermissions,
      /**
       * USER OBJECTS
       */
      userObjects: u.userObjects,
      /**
       * AUTH CONFIGS
       */
      authConfigId: O,
      logins: [],
      createdBy: "External IdP",
      history: [],
      lockedForExternalAuthentication: !1
    });
    t.createFromTemplateWithNewUsernameAndAuthConfig = d;
    const E = (u) => u.firstName && u.lastName ? `${u.firstName} ${u.lastName}` : u.username ? u.username : u.email ? u.email : "";
    t.getLabelForUser = E;
    const m = {
      id: (u) => u.toString(),
      appPermissions: (u) => u.join(", "),
      lockedForExternalAuthentication: (u) => u ? "Yes" : "No",
      organizationsAndRoles: (u, b) => u.map(([O, T]) => [b[O], T].join("|")).join("; "),
      scopes: (u) => u.join(", "),
      standardOrganization: (u, b) => u && b[u] || u,
      userObjects: (u) => u.join(", "),
      inactiveSince: (u) => u ? new Date(u * 1e3).toISOString() : null,
      logins: (u) => u.length === 0 ? "never" : new Date(u[0].login * 1e3).toISOString()
    }, c = (u) => Object.entries(u), f = (u, b) => {
      const O = Object.keys(r.exportedUserColumns).reduce((T, A) => (T[A] = u[A], T), {});
      return c(O).forEach(([T, A]) => {
        var g;
        const C = m[T];
        O[T] = (g = C == null ? void 0 : C(A, b)) !== null && g !== void 0 ? g : A;
      }), O;
    };
    t.mapUserCSVData = f;
    const _ = (u) => (b) => (0, t.mapUserCSVData)(b, u);
    t.createUserCSVMapper = _;
  })(on)), on;
}
var rr = {}, Ga;
function cl() {
  if (Ga) return rr;
  Ga = 1, Object.defineProperty(rr, "__esModule", { value: !0 }), rr.createM2MUser = void 0;
  const t = pe(), r = (a) => ({
    inactiveSince: a.inactiveSince,
    id: a.id,
    /**
     * DESCRIPTIVES
     */
    name: a.name,
    contactEmail: a.contactEmail,
    /**
     * CONFIG SETTINGS
     */
    language: a.language,
    visibility: a.visibility || t.EUserVisibility.STANDARD,
    description: a.description,
    /**
     * ORGANIZATIONS AND PERMISSIONS
     */
    standardOrganization: a.standardOrganization,
    organizationsAndRoles: a.organizationsAndRoles,
    scopes: a.scopes,
    appPermissions: a.appPermissions,
    /**
     * AUTH CONFIGS
     */
    createdBy: a.createdBy,
    history: a.history || [],
    createdAt: a.createdAt,
    updatedAt: a.updatedAt
  });
  return rr.createM2MUser = r, rr;
}
var Fe = {}, $a;
function dl() {
  if ($a) return Fe;
  $a = 1, Object.defineProperty(Fe, "__esModule", { value: !0 }), Fe.createEmptyAPIProperty = Fe.createEmptyAPIPropertyGroup = Fe.createEmptyApi = void 0;
  const t = () => ({
    isActive: !0,
    id: 0,
    name: "",
    signature: "",
    validFrom: null,
    expires: null,
    certificateName: "",
    certificateRegistered: Date.now(),
    certificateExpires: 0,
    certificateIssuer: "-",
    propertyGroups: [],
    description: ""
  });
  Fe.createEmptyApi = t;
  const r = () => ({
    id: 0,
    signature: "",
    name: "",
    properties: []
  });
  Fe.createEmptyAPIPropertyGroup = r;
  const a = () => ({
    id: 0,
    signature: "",
    name: "",
    isActive: !0,
    description: "",
    organizations: [],
    properties: ""
  });
  return Fe.createEmptyAPIProperty = a, Fe;
}
var at = {}, Va;
function pl() {
  if (Va) return at;
  Va = 1, Object.defineProperty(at, "__esModule", { value: !0 }), at.createAvailabilityTypesItem = at.createEmptyAvailabilityRelationType = void 0;
  const t = () => ({
    name: "",
    extId: "",
    id: 0,
    description: "",
    constitutesObstacles: !1,
    occupiedByDefault: !1,
    availabilityTypes: []
  });
  at.createEmptyAvailabilityRelationType = t;
  const r = (a) => ({
    type: a,
    ownObject: !1,
    userObject: !1
  });
  return at.createAvailabilityTypesItem = r, at;
}
var ot = {}, ka;
function ml() {
  if (ka) return ot;
  ka = 1, Object.defineProperty(ot, "__esModule", { value: !0 }), ot.createEmptyField = ot.createEmptyCategory = void 0;
  const t = Go(), r = () => ({
    label: ""
  });
  ot.createEmptyCategory = r;
  const a = () => ({
    fieldType: "",
    name: "",
    id: 0,
    extId: "",
    personalData: t.EPersonalDataCheck.NO,
    description: "",
    altDesignations: [],
    filter: t.EPreferencesFilter.CHOICE1,
    length: 0,
    min: 0,
    max: 100,
    sumType: 0,
    topLevelType: 0,
    titleType: 0,
    refSeparator: " ",
    searchableInReservationList: !1,
    reservationTextField: !1,
    mandatory: !1,
    unique: !1,
    multiple: !1,
    editable: !1,
    searchable: !1,
    listable: !1,
    primary: !1,
    sortable: !1,
    virtualCategory: "",
    abstractCategory: "",
    defaultValue: "",
    checkSum: 0,
    categories: [],
    referenceFields: [],
    types: [],
    reservationTemplates: [],
    organizations: [],
    documentation: "",
    history: [],
    memberMaxCount: !1,
    memberMaxType: 0
  });
  return ot.createEmptyField = a, ot;
}
var nr = {}, qa;
function fl() {
  if (qa) return nr;
  qa = 1, Object.defineProperty(nr, "__esModule", { value: !0 }), nr.createEmptyFieldRelation = void 0;
  const t = () => ({
    name: "",
    id: 0,
    description: "",
    sourceField: null,
    matchField: null,
    operator: null,
    matchMode: null,
    reservationTemplates: [],
    documentation: "",
    history: []
  });
  return nr.createEmptyFieldRelation = t, nr;
}
var ut = {}, ir = {}, Ha;
function El() {
  if (Ha) return ir;
  Ha = 1, Object.defineProperty(ir, "__esModule", { value: !0 }), ir.EReservationKindMemberType = void 0;
  var t;
  return (function(r) {
    r.ABSTRACT = "ABSTRACT", r.PHYSICAL = "PHYSICAL";
  })(t || (ir.EReservationKindMemberType = t = {})), ir;
}
var za;
function Tl() {
  if (za) return ut;
  za = 1, Object.defineProperty(ut, "__esModule", { value: !0 }), ut.createEmptyMemberType = ut.createMemberTypesItem = void 0;
  const t = El(), r = (o, d) => ({
    type: o,
    memberLevel: d
  });
  ut.createMemberTypesItem = r;
  const a = () => ({
    name: "",
    id: 0,
    reservationKind: t.EReservationKindMemberType.PHYSICAL,
    description: "",
    memberTypes: []
  });
  return ut.createEmptyMemberType = a, ut;
}
var Ae = {}, Ya;
function bl() {
  if (Ya) return Ae;
  Ya = 1, Object.defineProperty(Ae, "__esModule", { value: !0 }), Ae.createEmptyTEObject = Ae.createAvailabilityRelations = Ae.createDateRangeRelations = Ae.createDateRange = void 0;
  const t = pe(), r = 31556926, a = (m) => ({
    objectId: m,
    start: parseInt((Date.now() / 1e3).toFixed(), 10),
    end: parseInt((Date.now() / 1e3).toFixed(), 10) + r
  });
  Ae.createDateRange = a;
  const o = (m) => ({
    objectIds: [m],
    start: parseInt((Date.now() / 1e3).toFixed(), 10),
    end: parseInt((Date.now() / 1e3).toFixed(), 10) + r
  });
  Ae.createDateRangeRelations = o;
  const d = (m) => ({
    availabilityTypeId: m,
    objectIds: []
  });
  Ae.createAvailabilityRelations = d;
  const E = (m, c) => ({
    id: 0,
    extId: "",
    property: t.EProperty.STANDARD,
    personalInformation: t.EPersonalInformation.STANDARD,
    fields: c.map((f) => ({ fieldId: f, values: [] })),
    types: [m],
    created: parseInt((Date.now() / 1e3).toFixed(), 10),
    createdBy: "",
    active: !0,
    members: [],
    relations: [],
    availabilityRelations: [],
    optionalRelations: [],
    organizations: []
  });
  return Ae.createEmptyTEObject = E, Ae;
}
var st = {}, Wa;
function gl() {
  if (Wa) return st;
  Wa = 1, Object.defineProperty(st, "__esModule", { value: !0 }), st.createEmptyPeriod = st.createPeriodInterval = void 0;
  const t = $o(), r = (E) => E === t.ETimeIntervals.WEEK ? 1 : E === t.ETimeIntervals.YEAR ? 2021 : E === t.ETimeIntervals.MONTH ? 2 : E === t.ETimeIntervals.DATE ? 2021.01 : E === t.ETimeIntervals.DAY || E === t.ETimeIntervals.WEEKDAY ? 1 : E === t.ETimeIntervals.TIME ? 0 : E === t.ETimeIntervals.WEEK_NUMBER ? 1 : Date.now(), a = (E) => E === t.ETimeIntervals.WEEK ? 52 : E === t.ETimeIntervals.YEAR ? 2022 : E === t.ETimeIntervals.MONTH ? 12 : E === t.ETimeIntervals.DATE ? 2022.01 : E === t.ETimeIntervals.DAY ? 28 : E === t.ETimeIntervals.WEEKDAY ? 6 : E === t.ETimeIntervals.TIME ? 17 : E === t.ETimeIntervals.WEEK_NUMBER ? 52 : Date.now(), o = (E) => ({
    type: E,
    start: r(E),
    end: a(E)
  });
  st.createPeriodInterval = o;
  const d = () => ({
    name: "",
    shortName: "",
    id: 0,
    description: "",
    userAccess: t.EPeriodAccess.PUBLIC,
    intervals: [],
    childPeriods: [],
    history: []
  });
  return st.createEmptyPeriod = d, st;
}
var lt = {}, xa;
function yl() {
  if (xa) return lt;
  xa = 1, Object.defineProperty(lt, "__esModule", { value: !0 }), lt.createEmptyRelationType = lt.createRelationTypesItem = void 0;
  const t = Vo(), r = (o) => ({
    type: o,
    helpType: !1
  });
  lt.createRelationTypesItem = r;
  const a = () => ({
    name: "",
    id: 0,
    description: "",
    relationType: t.ERelationType.USE_ONLY,
    relationTypes: [],
    reservationTemplates: []
  });
  return lt.createEmptyRelationType = a, lt;
}
var we = {}, Ka;
function _l() {
  if (Ka) return we;
  Ka = 1, Object.defineProperty(we, "__esModule", { value: !0 }), we.createEmptyReservationTemplate = we.createTemplateType = we.createEmptyReservationMode = void 0;
  const t = ko(), r = () => ({
    name: "",
    extId: "",
    id: 0,
    description: "",
    showInClient: !1,
    showInCulling: !1,
    altDesignations: [],
    reservationTemplates: [],
    documentation: "",
    history: []
  });
  we.createEmptyReservationMode = r;
  const a = (d) => ({
    type: d,
    min: 1,
    max: 5,
    reservationKind: t.EReservationKind.ABSTRACT,
    mandatoryProperty: t.EMandatoryProperty.OPTIONAL,
    objectProperty: t.EObjectProperty.OBJECT,
    memberType: 0,
    availabilityType: 0,
    requestType: !1,
    cancelNoPermisson: !1,
    optionalRelation: t.EOptionalRelation.NONE,
    automaticObjectSelection: !1,
    reservationText: t.ETemplateTypesText.STANDARD,
    obstacleText: t.ETemplateTypesText.STANDARD,
    padding: !1,
    sizeReservationType: !1
  });
  we.createTemplateType = a;
  const o = () => ({
    name: "",
    templateType: t.ETemplateType.RESERVATION,
    timeRule: 0,
    privateRole: 0,
    standardOrganization: 0,
    defaultStatus: t.EDefaultStatus.CONFIRMED,
    active: !0,
    affectOrders: !1,
    id: 0,
    deleteWhenCulling: !1,
    types: [],
    typeCombinations: [],
    relationTypes: [],
    fields: [],
    reservationModes: [],
    organizations: [],
    documentation: "This is some documentation",
    history: [],
    objectSizeFieldId: 0,
    objectSizeSecondFieldId: 0,
    objectCapacityFieldId: 0
  });
  return we.createEmptyReservationTemplate = o, we;
}
var ct = {}, Za;
function Al() {
  if (Za) return ct;
  Za = 1, Object.defineProperty(ct, "__esModule", { value: !0 }), ct.createTimeZone = ct.createEmptyTimeZone = void 0;
  const t = () => ({
    id: 0,
    extId: "",
    name: "",
    timeZone: "",
    identifiers: [],
    daylightSavingsTime: "",
    isDefault: !1,
    offset: ""
  });
  ct.createEmptyTimeZone = t;
  const r = (a) => ({
    id: a.id,
    extId: a.extId,
    name: a.name,
    identifiers: a.identifiers,
    timeZone: a.zoneId,
    daylightSavingsTime: a.daylightSavingsTime,
    isDefault: a.isDefault,
    offset: a.offset
  });
  return ct.createTimeZone = r, ct;
}
var un = {}, Ja;
function Sl() {
  return Ja || (Ja = 1, (function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.createReservationMapping = t.createReservationParamMapping = void 0;
    const r = (o) => ({
      appFieldId: o.appFieldId || "",
      fieldLabel: o.fieldLabel || "",
      fieldExt: o.fieldExt || ""
    });
    t.createReservationParamMapping = r;
    const a = (o) => ({
      appId: o.appId,
      paramMappings: (o.paramMappings || []).map(t.createReservationParamMapping)
    });
    t.createReservationMapping = a;
  })(un)), un;
}
var dt = {}, Xa;
function Ol() {
  if (Xa) return dt;
  Xa = 1, Object.defineProperty(dt, "__esModule", { value: !0 }), dt.createFieldMapping = dt.createObjectTypeMapping = void 0;
  const t = pe(), r = (o) => ({
    applicationObjectTypeName: o.applicationObjectTypeName || "",
    applicationObjectTypeGroup: o.applicationObjectTypeGroup || "",
    objectTypeExtId: o.objectTypeExtId || null,
    objectTypeId: o.objectTypeId || null,
    applicationObjectTypeLabel: o.applicationObjectTypeLabel || "",
    status: o.status || t.EObjectTypeMappingStatuses.NOT_MAPPED,
    labelField: o.labelField || null,
    secondaryLabelField: o.secondaryLabelField || null,
    fields: o.fields || ""
  });
  dt.createObjectTypeMapping = r;
  const a = (o) => ({
    appFieldName: o.appFieldName || "",
    appProperty: o.appProperty || "",
    isSearchable: o.isSearchable || "",
    defaultSorting: o.defaultSorting,
    fieldExtId: o.fieldExtId || null,
    fieldId: o.fieldId || null,
    fieldLabel: o.fieldLabel || "",
    allocationFieldFromObject: o.allocationFieldFromObject || ""
  });
  return dt.createFieldMapping = a, dt;
}
var sn = {}, Qa;
function Rl() {
  return Qa || (Qa = 1, (function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.getRedirectUri = t.getCustomerPrefix = t.removeCloudPrefix = t.transformCustomerSignature = t.transformCustomerSignatureDashed = t.redirectURIs = void 0;
    const r = qo(), a = "timeedit.dev", o = "timeedit.io", d = "test.timeedit.net", E = "timeedit.net";
    t.redirectURIs = {
      development: {
        TE_ADMIN: (u) => "http://localhost:3004",
        TE_ALLOCATE: (u) => "http://localhost:5174",
        TE_AUTOPILOT: (u) => "",
        TE_CORE: (u) => `https://core.timeedit.dev/${u}/client`,
        TE_CURRICULUM: (u) => "http://localhost:3000",
        TE_DATA_MANAGER: (u) => "http://localhost:3060",
        TE_EVALUATION: (u) => "http://localhost:3000",
        TE_EXAM: (u) => "http://localhost:3999",
        TE_EXAM_V3: (u) => `http://localhost:3000/${u}`,
        TE_HUB: (u) => `http://localhost:3008/${u}`,
        TE_PLAN: (u) => `https://cloud.timeedit.net/${u}/web`,
        TE_PORTAL: (u) => `http://localhost:1337/${u}`,
        TE_PREFERENCES: (u) => "http://localhost:3005",
        TE_REGISTRATION: (u) => "http://localhost:5173",
        TE_REPORTING: (u) => "http://localhost:3201",
        TE_RESERVE: (u) => `https://cloud.timeedit.net/${u}/web`,
        TE_STUDY_GUIDE: (u) => "http://localhost:3000",
        TE_STUDY_PLANNER: (u) => `http://localhost:3030/${u}`,
        TE_VIEWER: (u) => `https://cloud.timeedit.net/${u}/web`,
        TE_WORKLOAD: (u) => "http://localhost:3000"
      },
      beta: {
        TE_ADMIN: (u) => `https://admin.timeedit.dev/${(0, t.transformCustomerSignature)(u)}`,
        TE_ALLOCATE: (u) => `https://allocate.timeedit.dev/${(0, t.transformCustomerSignature)(u)}`,
        TE_AUTOPILOT: (u) => "",
        TE_CORE: (u) => `https://core.timeedit.dev/${(0, t.transformCustomerSignature)(u)}/client`,
        TE_CURRICULUM: (u) => `https://${(0, t.transformCustomerSignatureDashed)(u)}.curriculum.timeedit.dev`,
        TE_DATA_MANAGER: (u) => `https://data-manager.timeedit.dev/${(0, t.transformCustomerSignature)(u)}`,
        TE_EVALUATION: (u) => `https://${(0, t.transformCustomerSignatureDashed)(u)}.evaluation.timeedit.dev`,
        TE_EXAM: (u) => `https://exam.timeedit.dev/${(0, t.transformCustomerSignature)(u)}`,
        TE_EXAM_V3: (u) => `https://assessment.timeedit.dev/${(0, t.transformCustomerSignature)(u)}`,
        TE_HUB: (u) => `https://hub.timeedit.dev/${(0, t.transformCustomerSignature)(u)}`,
        TE_PLAN: (u) => `https://cloud.timeedit.dev/${(0, t.transformCustomerSignature)(u)}/web`,
        TE_PORTAL: (u) => `https://portal.timeedit.dev/${(0, t.transformCustomerSignature)(u)}`,
        TE_PREFERENCES: (u) => "https://new-preferences.timeedit.dev",
        TE_REGISTRATION: (u) => `https://registration.timeedit.dev/${(0, t.transformCustomerSignature)(u)}`,
        TE_REPORTING: (u) => "https://reporting.timeedit.dev",
        TE_RESERVE: (u) => `https://cloud.timeedit.dev/${(0, t.transformCustomerSignature)(u)}/web`,
        TE_STUDY_GUIDE: (u) => `https://${(0, t.transformCustomerSignatureDashed)(u)}.studyguide.timeedit.dev`,
        TE_STUDY_PLANNER: (u, b) => f(a, u, b),
        TE_VIEWER: (u) => `https://cloud.timeedit.dev/${(0, t.transformCustomerSignature)(u)}/web`,
        TE_WORKLOAD: (u) => `https://${(0, t.transformCustomerSignatureDashed)(u)}.curriculum.timeedit.dev`
      },
      staging: {
        TE_ADMIN: (u) => `https://admin.timeedit.io/${(0, t.transformCustomerSignature)(u)}`,
        TE_ALLOCATE: (u) => `https://allocate.timeedit.io/${(0, t.transformCustomerSignature)(u)}`,
        TE_AUTOPILOT: (u) => "",
        TE_CORE: (u) => `https://core.timeedit.io/${(0, t.transformCustomerSignature)(u)}/client`,
        TE_CURRICULUM: (u) => `https://${(0, t.transformCustomerSignatureDashed)(u)}.curriculum.timeedit.io`,
        TE_DATA_MANAGER: (u) => `https://data-manager.timeedit.io/${(0, t.transformCustomerSignature)(u)}`,
        TE_EVALUATION: (u) => `https://${(0, t.transformCustomerSignatureDashed)(u)}.evaluation.timeedit.io`,
        TE_EXAM: (u) => `https://exam-v3.timeedit.io/${(0, t.transformCustomerSignature)(u)}`,
        TE_EXAM_V3: (u) => `https://assessment.timeedit.io/${(0, t.transformCustomerSignature)(u)}`,
        TE_HUB: (u) => `https://hub.timeedit.io/${(0, t.transformCustomerSignature)(u)}`,
        TE_PLAN: (u) => `https://cloud.timeedit.io/${(0, t.transformCustomerSignature)(u)}/web`,
        TE_PORTAL: (u) => `https://portal.timeedit.io/${(0, t.transformCustomerSignature)(u)}`,
        TE_PREFERENCES: (u) => "https://new-preferences.timeedit.io",
        TE_REGISTRATION: (u) => `https://registration.timeedit.io/${(0, t.transformCustomerSignature)(u)}`,
        TE_REPORTING: (u) => "https://reporting.timeedit.io",
        TE_RESERVE: (u) => `https://cloud.timeedit.io/${(0, t.transformCustomerSignature)(u)}/web`,
        TE_STUDY_GUIDE: (u) => `https://${(0, t.transformCustomerSignatureDashed)(u)}.studyguide.timeedit.io`,
        TE_STUDY_PLANNER: (u, b) => f(o, u, b),
        TE_VIEWER: (u) => `https://cloud.timeedit.io/${(0, t.transformCustomerSignature)(u)}/web`,
        TE_WORKLOAD: (u) => `https://${(0, t.transformCustomerSignatureDashed)(u)}.curriculum.timeedit.io`
      },
      test: {
        TE_ADMIN: (u) => `https://admin.test.timeedit.net/${(0, t.transformCustomerSignature)(u)}`,
        TE_ALLOCATE: (u) => `https://allocate.test.timeedit.net/${(0, t.transformCustomerSignature)(u)}`,
        TE_AUTOPILOT: (u) => "",
        TE_CORE: (u) => `https://core.test.timeedit.net/${(0, t.transformCustomerSignature)(u)}/client`,
        TE_CURRICULUM: (u) => `https://${(0, t.transformCustomerSignatureDashed)(u)}.curriculum.test.timeedit.net`,
        TE_DATA_MANAGER: (u) => `https://data-manager.test.timeedit.net/${(0, t.transformCustomerSignature)(u)}`,
        TE_EVALUATION: (u) => `https://${(0, t.transformCustomerSignatureDashed)(u)}.evaluation.test.timeedit.net`,
        TE_EXAM: (u) => `https://exam.test.timeedit.net/${(0, t.transformCustomerSignature)(u)}`,
        TE_EXAM_V3: (u) => `https://assessment.test.timeedit.net/${(0, t.transformCustomerSignature)(u)}`,
        TE_HUB: (u) => `https://hub.test.timeedit.net/${(0, t.transformCustomerSignature)(u)}`,
        TE_PLAN: (u) => `https://cloud.test.timeedit.net/${(0, t.transformCustomerSignature)(u)}/web`,
        TE_PORTAL: (u) => `http://portal.test.timeedit.net/${(0, t.transformCustomerSignature)(u)}`,
        TE_PREFERENCES: (u) => "https://preferences.test.timeedit.net",
        TE_REGISTRATION: (u) => `https://registration.test.timeedit.net/${(0, t.transformCustomerSignature)(u)}`,
        TE_REPORTING: (u) => "https://reporting.test.timeedit.net",
        TE_RESERVE: (u) => `https://cloud.test.timeedit.net/${(0, t.transformCustomerSignature)(u)}/web`,
        TE_STUDY_GUIDE: (u) => `https://${(0, t.transformCustomerSignatureDashed)(u)}.studyguide.test.timeedit.net`,
        TE_STUDY_PLANNER: (u, b) => f(d, u, b),
        TE_VIEWER: (u) => `https://cloud.test.timeedit.net/${(0, t.transformCustomerSignature)(u)}/web`,
        TE_WORKLOAD: (u) => `https://${(0, t.transformCustomerSignatureDashed)(u)}.curriculum.test.timeedit.net`
      },
      production: {
        TE_ADMIN: (u) => `https://admin.timeedit.net/${(0, t.transformCustomerSignature)(u)}`,
        TE_ALLOCATE: (u) => `https://allocate.timeedit.net/${(0, t.transformCustomerSignature)(u)}`,
        TE_AUTOPILOT: (u) => "",
        TE_CORE: (u) => `https://core.timeedit.net/${(0, t.transformCustomerSignature)(u)}/client`,
        TE_CURRICULUM: (u) => `https://${(0, t.transformCustomerSignatureDashed)(u)}.curriculum.timeedit.net`,
        TE_DATA_MANAGER: (u) => `https://data-manager.timeedit.net/${(0, t.transformCustomerSignature)(u)}`,
        TE_EVALUATION: (u) => `https://${(0, t.transformCustomerSignatureDashed)(u)}.evaluation.timeedit.net`,
        TE_EXAM: (u) => `https://exam.timeedit.net/${(0, t.transformCustomerSignature)(u)}`,
        TE_EXAM_V3: (u) => `https://assessment.timeedit.net/${(0, t.transformCustomerSignature)(u)}`,
        TE_HUB: (u) => `https://hub.timeedit.net/${(0, t.transformCustomerSignature)(u)}`,
        TE_PLAN: (u) => `https://cloud.timeedit.net/${(0, t.transformCustomerSignature)(u)}/web`,
        TE_PORTAL: (u) => `https://portal.timeedit.net/${(0, t.transformCustomerSignature)(u)}`,
        TE_PREFERENCES: (u) => "https://preferences.timeedit.net",
        TE_REGISTRATION: (u) => `https://registration.timeedit.net/${(0, t.transformCustomerSignature)(u)}`,
        TE_REPORTING: (u) => "https://reporting.timeedit.net",
        TE_RESERVE: (u) => `https://cloud.timeedit.net/${(0, t.transformCustomerSignature)(u)}/web`,
        TE_STUDY_GUIDE: (u) => `https://${(0, t.transformCustomerSignatureDashed)(u)}.studyguide.timeedit.net`,
        TE_STUDY_PLANNER: (u, b) => f(E, u, b),
        TE_VIEWER: (u) => `https://cloud.timeedit.net/${(0, t.transformCustomerSignature)(u)}/web`,
        TE_WORKLOAD: (u) => `https://${(0, t.transformCustomerSignatureDashed)(u)}.curriculum.timeedit.net`
      }
    };
    const m = (u) => u.replace(/_/g, "-").replace(/^cloud-/, "");
    t.transformCustomerSignatureDashed = m;
    const c = (u) => u.replace(/^cloud_/, "");
    t.transformCustomerSignature = c, t.removeCloudPrefix = t.transformCustomerSignature, t.getCustomerPrefix = t.transformCustomerSignatureDashed;
    const f = (u, b, O) => `https://${O ? `studyplanner.${r.REGION_LOCATIONS[O]}.${u}` : `studyplanner.${u}`}/${(0, t.transformCustomerSignature)(b)}`, _ = (u, b, O, T) => {
      var A;
      const g = (A = t.redirectURIs[O]) === null || A === void 0 ? void 0 : A[u];
      if (typeof g == "function")
        return g(b, T);
    };
    t.getRedirectUri = _;
  })(sn)), sn;
}
var ar = {}, eo;
function hl() {
  if (eo) return ar;
  eo = 1, Object.defineProperty(ar, "__esModule", { value: !0 }), ar.convertPartialAttributesRowToAffiliation = t, ar.convertPartialAttributesMatchingToAffiliations = r;
  function t(a, o, d) {
    const [E, m, c, f, _] = a, u = E.map(([O, T]) => ({
      attribute: O,
      value: T
    })), b = m.map(([O, T]) => ({
      organizationId: O,
      role: T
    }));
    return {
      authConfigId: o,
      label: _,
      priority: d,
      matchingCriteria: u,
      organizationsAndRoles: b,
      scopes: [],
      appPermissions: [],
      userObjects: f,
      standardOrganization: c
    };
  }
  function r(a, o) {
    return a.map((d, E) => t(d, o, E));
  }
  return ar;
}
var to;
function vl() {
  return to || (to = 1, (function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.createReservationParamMapping = t.createReservationMapping = t.createTimeZone = t.createTemplateType = t.createEmptyReservationTemplate = t.createEmptyReservationMode = t.createEmptyRelationType = t.createRelationTypesItem = t.createPeriodInterval = t.createEmptyPeriod = t.createEmptyTEObject = t.createDateRangeRelations = t.createAvailabilityRelations = t.createDateRange = t.createMemberTypesItem = t.createEmptyMemberType = t.createEmptyFieldRelation = t.createEmptyCategory = t.createEmptyField = t.createAvailabilityTypesItem = t.createEmptyAvailabilityRelationType = t.createEmptyApi = t.createM2MUser = t.mapUserCSVData = t.getLabelForUser = t.createUser = t.createUserCSVMapper = t.createEmptyType = t.createTokenPermissions = t.createUnsignedReadOnlyFromTEUser = t.createUnsignedReadOnlyFromTERootUser = t.createUnsignedFromTERootUser = t.createUnsignedFromM2MUser = t.createUnsignedFromTEUser = t.createEmptyTTime = t.createEmptyTTimeRule = t.createEmptyTWeekdaySelection = t.createTTime = t.createSOAPConnectionSettings = t.createRolePermissionGroup = t.createRolePermission = t.createRole = t.createPermission = t.createPaddingRule = t.createOrganizationTreeNode = t.createOrganizationNode = t.createOrganization = t.createAltDesignation = t.createImport = t.createAuthConfig = void 0, t.convertPartialAttributesMatchingToAffiliations = t.convertPartialAttributesRowToAffiliation = t.redirectURIs = t.getRedirectUri = t.createFieldMapping = t.createObjectTypeMapping = void 0;
    var r = xs();
    Object.defineProperty(t, "createAuthConfig", { enumerable: !0, get: function() {
      return r.createAuthConfig;
    } });
    var a = Zs();
    Object.defineProperty(t, "createImport", { enumerable: !0, get: function() {
      return a.createImport;
    } });
    var o = Js();
    Object.defineProperty(t, "createAltDesignation", { enumerable: !0, get: function() {
      return o.createAltDesignation;
    } });
    var d = Xs();
    Object.defineProperty(t, "createOrganization", { enumerable: !0, get: function() {
      return d.createOrganization;
    } });
    var E = Qs();
    Object.defineProperty(t, "createOrganizationNode", { enumerable: !0, get: function() {
      return E.createOrganizationNode;
    } });
    var m = el();
    Object.defineProperty(t, "createOrganizationTreeNode", { enumerable: !0, get: function() {
      return m.createOrganizationTreeNode;
    } });
    var c = tl();
    Object.defineProperty(t, "createPaddingRule", { enumerable: !0, get: function() {
      return c.createPaddingRule;
    } });
    var f = rl();
    Object.defineProperty(t, "createPermission", { enumerable: !0, get: function() {
      return f.createPermission;
    } });
    var _ = nl();
    Object.defineProperty(t, "createRole", { enumerable: !0, get: function() {
      return _.createRole;
    } }), Object.defineProperty(t, "createRolePermission", { enumerable: !0, get: function() {
      return _.createRolePermission;
    } }), Object.defineProperty(t, "createRolePermissionGroup", { enumerable: !0, get: function() {
      return _.createRolePermissionGroup;
    } });
    var u = il();
    Object.defineProperty(t, "createSOAPConnectionSettings", { enumerable: !0, get: function() {
      return u.createSOAPConnectionSettings;
    } });
    var b = al();
    Object.defineProperty(t, "createTTime", { enumerable: !0, get: function() {
      return b.createTTime;
    } }), Object.defineProperty(t, "createEmptyTWeekdaySelection", { enumerable: !0, get: function() {
      return b.createEmptyTWeekdaySelection;
    } }), Object.defineProperty(t, "createEmptyTTimeRule", { enumerable: !0, get: function() {
      return b.createEmptyTTimeRule;
    } }), Object.defineProperty(t, "createEmptyTTime", { enumerable: !0, get: function() {
      return b.createEmptyTTime;
    } });
    var O = ol();
    Object.defineProperty(t, "createUnsignedFromTEUser", { enumerable: !0, get: function() {
      return O.createUnsignedFromTEUser;
    } }), Object.defineProperty(t, "createUnsignedFromM2MUser", { enumerable: !0, get: function() {
      return O.createUnsignedFromM2MUser;
    } }), Object.defineProperty(t, "createUnsignedFromTERootUser", { enumerable: !0, get: function() {
      return O.createUnsignedFromTERootUser;
    } }), Object.defineProperty(t, "createUnsignedReadOnlyFromTERootUser", { enumerable: !0, get: function() {
      return O.createUnsignedReadOnlyFromTERootUser;
    } }), Object.defineProperty(t, "createUnsignedReadOnlyFromTEUser", { enumerable: !0, get: function() {
      return O.createUnsignedReadOnlyFromTEUser;
    } });
    var T = ul();
    Object.defineProperty(t, "createTokenPermissions", { enumerable: !0, get: function() {
      return T.createTokenPermissions;
    } });
    var A = sl();
    Object.defineProperty(t, "createEmptyType", { enumerable: !0, get: function() {
      return A.createEmptyType;
    } });
    var g = ll();
    Object.defineProperty(t, "createUserCSVMapper", { enumerable: !0, get: function() {
      return g.createUserCSVMapper;
    } }), Object.defineProperty(t, "createUser", { enumerable: !0, get: function() {
      return g.createUser;
    } }), Object.defineProperty(t, "getLabelForUser", { enumerable: !0, get: function() {
      return g.getLabelForUser;
    } }), Object.defineProperty(t, "mapUserCSVData", { enumerable: !0, get: function() {
      return g.mapUserCSVData;
    } });
    var C = cl();
    Object.defineProperty(t, "createM2MUser", { enumerable: !0, get: function() {
      return C.createM2MUser;
    } });
    var G = dl();
    Object.defineProperty(t, "createEmptyApi", { enumerable: !0, get: function() {
      return G.createEmptyApi;
    } });
    var D = pl();
    Object.defineProperty(t, "createEmptyAvailabilityRelationType", { enumerable: !0, get: function() {
      return D.createEmptyAvailabilityRelationType;
    } }), Object.defineProperty(t, "createAvailabilityTypesItem", { enumerable: !0, get: function() {
      return D.createAvailabilityTypesItem;
    } });
    var F = ml();
    Object.defineProperty(t, "createEmptyField", { enumerable: !0, get: function() {
      return F.createEmptyField;
    } }), Object.defineProperty(t, "createEmptyCategory", { enumerable: !0, get: function() {
      return F.createEmptyCategory;
    } });
    var k = fl();
    Object.defineProperty(t, "createEmptyFieldRelation", { enumerable: !0, get: function() {
      return k.createEmptyFieldRelation;
    } });
    var j = Tl();
    Object.defineProperty(t, "createEmptyMemberType", { enumerable: !0, get: function() {
      return j.createEmptyMemberType;
    } }), Object.defineProperty(t, "createMemberTypesItem", { enumerable: !0, get: function() {
      return j.createMemberTypesItem;
    } });
    var W = bl();
    Object.defineProperty(t, "createDateRange", { enumerable: !0, get: function() {
      return W.createDateRange;
    } }), Object.defineProperty(t, "createAvailabilityRelations", { enumerable: !0, get: function() {
      return W.createAvailabilityRelations;
    } }), Object.defineProperty(t, "createDateRangeRelations", { enumerable: !0, get: function() {
      return W.createDateRangeRelations;
    } }), Object.defineProperty(t, "createEmptyTEObject", { enumerable: !0, get: function() {
      return W.createEmptyTEObject;
    } });
    var Q = gl();
    Object.defineProperty(t, "createEmptyPeriod", { enumerable: !0, get: function() {
      return Q.createEmptyPeriod;
    } }), Object.defineProperty(t, "createPeriodInterval", { enumerable: !0, get: function() {
      return Q.createPeriodInterval;
    } });
    var X = yl();
    Object.defineProperty(t, "createRelationTypesItem", { enumerable: !0, get: function() {
      return X.createRelationTypesItem;
    } }), Object.defineProperty(t, "createEmptyRelationType", { enumerable: !0, get: function() {
      return X.createEmptyRelationType;
    } });
    var Y = _l();
    Object.defineProperty(t, "createEmptyReservationMode", { enumerable: !0, get: function() {
      return Y.createEmptyReservationMode;
    } }), Object.defineProperty(t, "createEmptyReservationTemplate", { enumerable: !0, get: function() {
      return Y.createEmptyReservationTemplate;
    } }), Object.defineProperty(t, "createTemplateType", { enumerable: !0, get: function() {
      return Y.createTemplateType;
    } });
    var q = Al();
    Object.defineProperty(t, "createTimeZone", { enumerable: !0, get: function() {
      return q.createTimeZone;
    } });
    var M = Sl();
    Object.defineProperty(t, "createReservationMapping", { enumerable: !0, get: function() {
      return M.createReservationMapping;
    } }), Object.defineProperty(t, "createReservationParamMapping", { enumerable: !0, get: function() {
      return M.createReservationParamMapping;
    } });
    var H = Ol();
    Object.defineProperty(t, "createObjectTypeMapping", { enumerable: !0, get: function() {
      return H.createObjectTypeMapping;
    } }), Object.defineProperty(t, "createFieldMapping", { enumerable: !0, get: function() {
      return H.createFieldMapping;
    } });
    var ee = Rl();
    Object.defineProperty(t, "getRedirectUri", { enumerable: !0, get: function() {
      return ee.getRedirectUri;
    } }), Object.defineProperty(t, "redirectURIs", { enumerable: !0, get: function() {
      return ee.redirectURIs;
    } });
    var P = hl();
    Object.defineProperty(t, "convertPartialAttributesRowToAffiliation", { enumerable: !0, get: function() {
      return P.convertPartialAttributesRowToAffiliation;
    } }), Object.defineProperty(t, "convertPartialAttributesMatchingToAffiliations", { enumerable: !0, get: function() {
      return P.convertPartialAttributesMatchingToAffiliations;
    } });
  })(nn)), nn;
}
var ro;
function Il() {
  return ro || (ro = 1, (function(t) {
    var r = ze && ze.__createBinding || (Object.create ? (function(o, d, E, m) {
      m === void 0 && (m = E);
      var c = Object.getOwnPropertyDescriptor(d, E);
      (!c || ("get" in c ? !d.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
        return d[E];
      } }), Object.defineProperty(o, m, c);
    }) : (function(o, d, E, m) {
      m === void 0 && (m = E), o[m] = d[E];
    })), a = ze && ze.__exportStar || function(o, d) {
      for (var E in o) E !== "default" && !Object.prototype.hasOwnProperty.call(d, E) && r(d, o, E);
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), a(Ho(), t), a(pe(), t), a(Ys(), t), a(vl(), t);
  })(ze)), ze;
}
var Pl = Il();
const NE = {
  HUB: {
    STUDENT: "TE_HUB::student"
  }
}, br = {
  ALLOCATE: {
    USER: "TE_ALLOCATE::user",
    ADMIN: "TE_ALLOCATE::admin"
  },
  REGISTRATION: {
    USER: "TE_REGISTRATION::user"
  },
  HUB: {
    USER: "TE_HUB::user"
  },
  ROOT: Pl.TE_ROOT_USER
}, Cl = ["ISSUE", "OK", "PENDING"], Yo = e.enum(Cl), Nl = [
  "ALLOCATED_TO_THIS",
  "ALLOCATED_TO_OTHER",
  "NOT_ALLOCATED",
  "MULTIPLE_ALLOCATIONS"
], Ml = e.enum(Nl), Dl = ["NONE", "REQUESTED", "CONFIRMED"], ME = e.enum(Dl), jl = ["OK", "ERROR", "WARNING"], DE = e.enum(jl), Ll = [
  br.REGISTRATION.USER,
  br.ALLOCATE.USER,
  br.ALLOCATE.ADMIN,
  br.ROOT
], jE = e.enum(Ll), no = 3e3, io = 1e3, be = e.object({
  local: e.string(),
  timezone: e.string().optional(),
  unix: e.number().int().nonnegative()
});
var U = pe(), Wo = Nn(), xo = zo();
function pr(t, r) {
  return e.string().optional().nullable().transform(
    (a) => Object.values(t).includes(a ?? "") ? a : r
  ).pipe(e.enum(t));
}
function ke(t) {
  return e.string().optional().nullable().transform(
    (r) => r !== void 0 && Object.values(t).includes(r ?? "") ? r : void 0
  ).pipe(e.enum(t).optional());
}
const Ul = pr(
  U.EApplicationObjectTypeGroup,
  U.EApplicationObjectTypeGroup.NONE
), Fl = pr(
  U.EAppProperties,
  U.EAppProperties.NONE
), wl = ke(U.EAppId), Ko = e.enum(U.EAppId), Zo = ke(Wo.ERegion), LE = e.enum(Wo.ERegion), UE = ke(
  U.EObjectTypeMappingStatuses
), FE = e.enum(
  U.EObjectTypeMappingStatuses
), wE = ke(U.EOrganizationType), BE = e.enum(U.EOrganizationType), GE = e.enum(xo.EOrganizationVisibility), Bl = ke(
  xo.EOrganizationVisibility
), Gl = ke(U.ETokenType), $E = e.enum(U.ETokenType), VE = pr(
  U.EUserVisibility,
  U.EUserVisibility.STANDARD
), kE = pr(
  U.EPersonalDataCheck,
  U.EPersonalDataCheck.STANDARD
);
var fn = ((t) => (t[t.YES = U.EPersonalInformation.YES] = "YES", t[t.NO = U.EPersonalInformation.NO] = "NO", t[t.STANDARD = U.EPersonalInformation.STANDARD] = "STANDARD", t))(fn || {});
const qE = pr(
  fn,
  fn.STANDARD
), HE = ke(U.EPreferencesFilter), zE = e.enum(U.EPreferencesFilter), YE = ke(U.EProperty), WE = e.enum(U.EProperty);
var Mn = /* @__PURE__ */ ((t) => (t.Error = "Error", t.ValidationError = "ValidationError", t.BadRequestError = "BadRequestError", t.NotFoundError = "NotFoundError", t.AdminConfigurationError = "AdminConfigurationError", t.StudentSetGroupConfigurationError = "StudentSetGroupConfigurationError", t.PopulateCacheBusyError = "PopulateCacheBusyError", t.AutoAllocateBusyError = "AutoAllocateBusyError", t.CloudJobRunningError = "CloudJobRunningError", t.NoStudentObjectError = "NoStudentObjectError", t.SubscribeError = "SubscribeError", t.PacemakerFetchError = "PacemakerFetchError", t.PacemakerResponseError = "PacemakerResponseError", t.PermissionError = "PermissionError", t.ExternalServiceError = "ExternalServiceError", t.MultiError = "MultiError", t.RegistrationApiError = "RegistrationApiError", t.HeavyLoadError = "HeavyLoadError", t.NothingToAllocateError = "NothingToAllocateError", t.FrontendError = "FrontendError", t.RegistrationError = "RegistrationError", t.MyScheduleError = "MyScheduleError", t.MaximumMembershipReachedError = "MaximumMembershipReachedError", t.MaximumMembershipReachedByTypeError = "MaximumMembershipReachedByTypeError", t.TEServerFailedError = "TEServerFailedError", t.WorkerInlineFallbackError = "WorkerInlineFallbackError", t.WorkerTimeoutError = "WorkerTimeoutError", t.WorkerQueueSaturated = "WorkerQueueSaturated", t.InterruptAbortException = "InterruptAbortException", t.UnmountAbortException = "UnmountAbortException", t.AddWaitlistError = "AddWaitlistError", t.HistoryError = "HistoryError", t.IssueListCacheError = "IssueListCacheError", t.ReservationError = "ReservationError", t.EnvError = "EnvError", t))(Mn || {});
const Jo = e.enum(Mn);
var Nr = /* @__PURE__ */ ((t) => (t.ASCID = "ASCID", t.DESCID = "DESCID", t.ASCMOD = "ASCMOD", t.DESCMOD = "DESCMOD", t.ASCFIELD = "ASCFIELD", t.DESCFIELD = "DESCFIELD", t))(Nr || {});
const En = e.enum(Nr);
var Xo = /* @__PURE__ */ ((t) => (t.ASCID = "ASCID", t.DESCID = "DESCID", t.ASCTIME = "ASCTIME", t.DESCTIME = "DESCTIME", t.ASCMOD = "ASCMOD", t.DESCMOD = "DESCMOD", t.ASCTAG = "ASCTAG", t.DESCTAG = "DESCTAG", t))(Xo || {});
const $l = e.enum(Xo), Vl = [
  U.EReservationStatuses.Complete,
  U.EReservationStatuses.Incomplete,
  U.EReservationStatuses.Confirmed,
  U.EReservationStatuses.Requested,
  U.EReservationStatuses.Rejected
], xE = e.tuple([e.array(e.string()), e.array(e.string())]).optional(), Dn = e.tuple([e.string(), e.string()]), KE = e.object({
  language: e.string(),
  name: e.string(),
  description: e.string()
}), kl = [
  U.EFieldType.TEXT,
  U.EFieldType.SIGNATURE,
  U.EFieldType.EMAIL,
  U.EFieldType.URL,
  U.EFieldType.TELEPHONE,
  U.EFieldType.CATEGORY,
  U.EFieldType.COMMENT,
  U.EFieldType.INTEGER,
  U.EFieldType.LENGTH,
  U.EFieldType.CHECKBOX,
  U.EFieldType.REFERENCE,
  U.EFieldType.NON_SEARCHABLE_TEXT,
  U.EFieldType.NON_SEARCHABLE_REFERENCE,
  ""
], ql = e.enum(kl), jn = e.object({
  id: e.number(),
  extId: e.string(),
  name: e.string(),
  // description: z.string(),
  // altDesignations: z.array(TAltDesignations),
  // documentation: z.string(),
  // history: z.array(THistory),
  fieldType: ql.default("").optional(),
  // personalData: ZPersonalDataCheck,
  // filter: z.union([ZPreferencesFilterRequired, z.string()]).optional(),
  // length: z.number().optional(),
  // min: z.number().optional(),
  // max: z.number().optional(),
  // sumType: z.number().optional(),
  // topLevelType: z.number().optional(),
  // titleType: z.number().optional(),
  refSeparator: e.string().optional(),
  memberMaxType: e.number().optional(),
  memberMaxCount: e.boolean().optional(),
  // searchableInReservationList: z.boolean().optional(),
  // reservationTextField: z.boolean().optional(),
  mandatory: e.boolean().optional(),
  // unique: z.boolean().optional(),
  // multiple: z.boolean().optional(),
  // editable: z.boolean().optional(),
  searchable: e.boolean(),
  // listable: z.boolean(),
  // primary: z.boolean(),
  // sortable: z.boolean(),
  // virtualCategory: z.string().optional(),
  // abstractCategory: z.string().optional(),
  defaultValue: e.string().optional(),
  checkSum: e.number().optional(),
  categories: e.array(e.string()).optional(),
  referenceFields: e.array(e.number()),
  types: e.array(e.number())
  // reservationTemplates: z.array(z.number()),
  // organizations: z.array(z.string()),
}), ZE = he(jn), Hl = e.object({
  type: e.union([e.string(), e.number()]).optional(),
  memberLevel: e.number()
}), Ln = e.object({
  id: e.number(),
  name: e.string(),
  memberTypes: e.array(Hl).default([])
}), JE = he(Ln), Ve = e.number(), mr = e.object({
  fieldId: Ve,
  values: e.array(e.string())
}), Un = e.object({
  objectId: Ve,
  start: e.number(),
  end: e.number()
}), Qo = e.object({
  start: e.number(),
  end: e.number(),
  objectIds: e.array(Ve)
}), XE = e.object({
  availabilityTypeId: Ve,
  objectIds: e.array(Ve)
}), zl = e.object({
  sort: e.string().optional(),
  objectStatus: e.string().optional(),
  // Type up the options
  page: e.number().optional(),
  limit: e.number().optional(),
  virtual: e.string().optional(),
  // Type up the options
  abstract: e.string().optional(),
  // Type up the options
  active: e.string().optional(),
  // Type up the options
  typeId: e.number().optional(),
  ids: e.array(e.number()).optional(),
  extIds: e.array(e.string()).optional(),
  excludeIds: e.array(e.number()).optional(),
  excludeExtIds: e.array(e.string()).optional(),
  modified: e.object({
    beginModified: e.number(),
    endModified: e.number()
  }).optional(),
  fields: e.object({
    exactSearchFieldIds: e.array(e.number()),
    generalSearchFieldIds: e.array(e.number()),
    searchText: e.string().optional()
  }).optional()
}).optional(), QE = e.object({
  body: zl
}), me = e.object({
  id: e.number(),
  extId: e.string(),
  created: e.number(),
  // createdBy: z.string(),
  // history: z.union([z.array(THistory), THistory]),
  // property: ZPropertyOptional,
  // personalInformation: ZPersonalInformation,
  fields: e.array(mr),
  // organizations: z.array(z.union([z.string(), z.number()])),
  members: e.array(Un),
  types: e.array(Ve),
  relations: e.array(Qo),
  // availabilityRelations: z.array(TAvailabilityRelations),
  // optionalRelations: z.array(RelatedId),
  active: e.boolean(),
  virtual: e.boolean(),
  abstract: e.boolean()
  // color: z.string(),
}), Yl = e.looseObject({
  id: e.number(),
  extId: e.string(),
  created: e.number(),
  fields: e.array(mr),
  members: e.array(Un),
  types: e.array(Ve),
  relations: e.array(Qo),
  active: e.boolean(),
  virtual: e.boolean(),
  abstract: e.boolean()
}), eT = he(me), tT = Wl(Yl);
function he(t) {
  return e.object({
    limit: e.number().optional(),
    page: e.number().optional(),
    results: e.array(t).optional(),
    totalPages: e.number().optional(),
    totalResults: e.number().optional()
  });
}
function Wl(t) {
  return e.looseObject({
    limit: e.number().optional(),
    page: e.number().optional(),
    results: e.array(t).optional(),
    totalPages: e.number().optional(),
    totalResults: e.number().optional()
  });
}
const xl = e.looseObject({
  id: e.number(),
  extId: e.string().optional(),
  status: e.number(),
  errorCode: e.number().optional(),
  message: e.string().optional(),
  localizedMessage: e.string().optional()
});
function Kl(t) {
  return he(t).extend({
    failed: e.number().optional().default(0),
    success: e.number().optional().default(0)
  });
}
const rT = Kl(xl), eu = e.object({
  id: e.string(),
  name: e.string().optional().default(""),
  customerSignature: e.string().optional().default(""),
  customerLogo: e.string().optional().nullable().default(""),
  // teServerUrl: z.string().optional().default(""),
  public: e.boolean().optional().default(!1),
  enabledProducts: e.array(wl).transform((t) => t.filter(Boolean)).optional().default([]),
  // Org type is not trustworthy.
  // type: ZOrganizationTypeRequired,
  rootUserPermissions: e.array(Dn.or(e.string())).optional().default([]),
  rootUserStandardOrganizationNode: e.string().optional().default(""),
  region: Zo,
  visibility: Bl,
  // createdAt: z.number().optional().default(0),
  // updatedAt: z.number().optional().default(0),
  // inactiveSince: z.number().optional().nullable().default(null),
  inactive: e.boolean().optional().default(!1)
}), nT = he(eu), iT = eu.pick({
  id: !0,
  name: !0,
  customerSignature: !0,
  customerLogo: !0,
  enabledProducts: !0,
  region: !0,
  visibility: !0
}).extend({
  customerColor: e.string().nullable().optional(),
  database: e.string().optional()
}), Zl = e.object({
  objectId: e.number(),
  typeId: e.number()
}), Jl = e.object({
  sort: $l.optional(),
  page: e.number().optional(),
  limit: e.number().optional(),
  modified: e.object({
    beginModified: e.number().optional(),
    endModified: e.number().optional()
  }).optional(),
  date: e.object({
    startDate: e.number().optional(),
    endDate: e.number().optional()
  }).optional(),
  searchObjects: e.array(Zl).optional(),
  types: e.array(e.number()).optional(),
  reservationMode: e.number().optional(),
  fields: e.object({
    exactSearchFieldIds: e.array(e.number()),
    generalSearchFieldIds: e.array(e.number()),
    searchText: e.string().optional()
  }).optional(),
  reservationStatus: e.array(e.string()).optional(),
  mineOnly: e.boolean().optional(),
  includeReservationModes: e.boolean().optional(),
  ids: e.array(e.number()).optional(),
  extIds: e.array(e.string()).optional(),
  typeId: e.number().optional()
}), aT = e.object({
  body: Jl
}), Fn = e.object({
  id: e.number(),
  extId: e.string().optional(),
  // organizations: z.array(z.string()).optional(),
  history: e.object({
    modified: e.number().optional(),
    modifiedBy: e.string().optional()
  }),
  // .optional(),
  // created: z.number().optional(),
  // createdBy: z.string().optional(),
  begin: e.number().optional(),
  end: e.number().optional(),
  // originalReservation: z.number().optional(),
  // autoEngineId: z.string().optional(),
  // length: z.number().optional(),
  objects: e.array(
    e.object({
      objectId: e.number(),
      typeId: e.number()
    })
  ).optional(),
  fields: e.array(
    e.object({
      fieldId: e.number(),
      values: e.array(e.string())
    })
  ).optional(),
  status: e.array(e.enum(U.EReservationStatuses)).optional(),
  // Only present when the find request sets `includeReservationModes`.
  reservationModes: e.array(e.number()).optional()
  // tags: z.array(z.string()).optional(),
}), oT = he(Fn), uT = e.partialRecord(e.string(), e.string()), Xl = e.object({
  id: e.string(),
  legacyId: e.string().nullable().optional(),
  profileName: e.string().optional(),
  standardOrganization: e.string().nullable().optional(),
  organizationsAndRoles: e.array(Dn),
  scopes: e.array(e.string()),
  appPermissions: e.array(e.string()),
  userObjects: e.array(e.string()),
  inactiveSince: e.number().nullable()
}), ao = e.object({
  id: e.string(),
  profileName: e.string().optional()
}), Ql = e.object({
  region: Zo,
  // Mandatory identifiers
  id: e.string(),
  // User id
  type: Gl,
  customerSignature: e.string().nullable().optional(),
  organizationId: e.string().nullable().optional(),
  username: e.string().optional(),
  email: e.string().nullable().optional(),
  // Permissions
  appPermissions: e.array(e.string()).optional().default([]),
  scopes: e.array(e.string()),
  organizationsAndRoles: e.array(Dn).optional(),
  // Profiles
  profile: ao.optional(),
  profiles: e.array(ao).optional(),
  // Token stuff
  iat: e.number().optional(),
  exp: e.number().optional(),
  fingerprintHashed: e.string().optional()
}), wn = e.object({
  id: e.number(),
  extId: e.string(),
  name: e.string(),
  // description: z.string(),
  // documentation: z.string(),
  // history: z.array(THistory),
  // altDesignations: z.array(TAltDesignations),
  active: e.boolean(),
  // personalData: z.boolean(),
  // allowStandardObjects: z.boolean(),
  // allowAbstractObjects: z.boolean(),
  // allowVirtualObjects: z.boolean(),
  // personType: z.boolean(),
  // locationType: z.boolean(),
  // aliasType: RelatedId,
  // externalOwner: z.string(),
  subTypes: e.array(Ve).optional()
  // fields: z.array(RelatedId).optional(),
  // parentFields: z.array(RelatedId).optional(),
  // reservationTemplates: z.array(z.number()).optional(),
  // organizations: z.array(z.union([z.string(), z.number()])).optional(),
}), sT = he(wn), lT = e.object({
  login: e.number().optional(),
  appId: Ko
}), Bn = e.object({
  id: e.string(),
  inactiveSince: e.number().nullable().optional(),
  // DESCRIPTIVES
  organizationId: e.string().nullable().optional(),
  username: e.string().optional(),
  email: e.string().nullable().optional(),
  firstName: e.string().nullable().optional(),
  lastName: e.string().nullable().optional(),
  // PROFILES
  profileName: e.string().optional(),
  profiles: e.array(Xl).optional(),
  // LEGACY INFORMATION
  // legacyId: z.string().nullable().optional(),
  // CONFIG SETTINGS
  // language: z.string().nullable().optional(),
  // dateFormat: z.string().nullable().optional(),
  // displayTimezones: z.array(z.string()).optional(),
  timezone: e.string().nullable().optional(),
  // visibility: ZUserVisibility.optional(),
  // personalData: z.boolean().optional(),
  // description: z.string().nullable().optional(),
  // ORGANIZATIONS AND PERMISSIONS
  // standardOrganization: z.string().nullable().optional(), // Only leaves allowed
  // ** NOTE ** organizationAndRoles can fail validation how it looks below. It can have a tuple of value null
  // organizationsAndRoles: z.array(TAttributeValueArrayPair).optional(),
  scopes: e.array(e.string()),
  appPermissions: e.array(e.string()).optional(),
  // USER OBJECTS
  userObjects: e.array(e.string()).optional()
  // AUTH CONFIG
  // authConfigId: z.string().optional(),
  // USAGE STATISTICS
  // logins: z.array(TLogins).optional(),
  // createdBy: z.string().nullable().optional(),
  // history: z.array(THistory),
  // lockedForExternalAuthentication: z.boolean().optional(),
  // createdAt: z.number().optional(),
  // updatedAt: z.number().optional(),
}), cT = he(Bn), dT = Bn.pick({
  id: !0,
  email: !0,
  firstName: !0,
  lastName: !0,
  timezone: !0
}), pT = Bn.pick({
  email: !0,
  firstName: !0,
  lastName: !0,
  profiles: !0
}), ec = e.object({
  id: e.string(),
  email: e.string().nullable().optional(),
  name: e.string()
}), mT = e.array(ec), tc = e.object({
  isSearchable: e.boolean().optional(),
  // appFieldName: z.string(),
  appProperty: Fl,
  fieldExtId: e.string().optional().nullable(),
  fieldId: e.number().optional().nullable()
  // fieldLabel: z.string(),
  // allocationFieldFromObject: z.string().optional().nullable(),
}), rc = e.object({
  // applicationObjectTypeName: z.string(),
  applicationObjectTypeGroup: Ul,
  // applicationObjectTypeLabel: z.string(),
  objectTypeExtId: e.string().optional().nullable(),
  objectTypeId: e.number().optional().nullable(),
  // labelField: z.string().optional().nullable(),
  // secondaryLabelField: z.string().optional().nullable(),
  fields: e.array(tc)
  // status: ZObjectTypeMappingStatusesRequired,
}), tu = e.object({
  appId: Ko,
  objectTypes: e.array(rc)
}), fT = e.object({
  mappingData: tu,
  fields: e.map(e.number(), jn),
  types: e.map(e.number(), wn),
  memberTypes: e.map(e.number(), Ln)
}), ET = e.object({
  mappingData: tu,
  fields: e.array(jn),
  types: e.array(wn),
  memberTypes: e.array(Ln)
}), nc = e.object({
  id: e.number(),
  extId: e.string(),
  name: e.string(),
  identifiers: e.array(e.string()).optional(),
  // daylightSavingsTime: z.string(),
  isDefault: e.boolean(),
  offset: e.string().optional(),
  timeZone: e.string()
}), oo = e.object({
  extId: e.string(),
  name: e.string(),
  identifier: e.string(),
  offset: e.string()
}), ru = e.object({
  server: oo,
  user: oo
}), TT = he(nc), ic = e.object({
  id: e.string().optional(),
  viewLinkSubmitter: e.string().optional(),
  viewerEntry: e.string().optional(),
  viewerPath: e.string().optional(),
  viewerPage: e.string().optional(),
  commentField: e.string().optional(),
  currentPeriod: e.string().optional(),
  reservationMode: e.number().optional()
}), nu = e.object({
  daily: e.boolean().default(!1),
  hourly: e.boolean().default(!1),
  everyMinute: e.boolean().default(!1)
}), bT = Object.keys(
  nu.shape
), ac = e.object({
  deAllocationEnabled: e.boolean().default(!1),
  allocationEnabled: e.boolean().default(!1),
  frequency: nu.default({
    daily: !1,
    hourly: !1,
    everyMinute: !1
  }),
  fromWaitlistEnabled: e.boolean().default(!1)
}), oc = e.object({
  automaticAllocation: ac.optional(),
  blockStudentConflict: e.boolean().default(!1),
  preferencesTimeOfDay: e.boolean().optional(),
  preferencesTime: e.boolean().optional(),
  preferencesGroup: e.boolean().optional(),
  enableWaitlist: e.boolean().default(!1),
  reservationStatuses: e.array(e.enum(U.EReservationStatuses)).default(Vl)
}), uc = e.object({
  startDate: e.number().optional(),
  endDate: e.number().optional()
}), sc = e.object({
  start: e.number(),
  end: e.number()
}), lc = e.partialRecord(e.string(), e.array(e.string())), cc = e.object({
  range: sc.optional(),
  fields: lc.optional()
}), gT = e.object({ id: e.number(), name: e.string() }), dc = ic.extend({
  current: cc,
  dateRange: uc.optional(),
  currentFieldIds: e.array(e.number()),
  reservationMode: e.number().optional()
}), yT = e.object({
  viewLink: dc,
  allocateSettings: oc
}), K = (t) => e.object({
  label: e.string(),
  value: t
}), Sr = e.object({
  id: e.number(),
  begin: be,
  end: be,
  isInfo: e.boolean().optional(),
  title: e.string(),
  subtitle: e.string().optional(),
  examType: K(e.string()).optional(),
  module: e.array(
    e.object({
      name: K(e.string()),
      code: K(e.string())
    })
  ).optional(),
  activity: e.object({ name: K(e.string()) }).optional(),
  location: e.array(
    e.object({
      name: K(e.string()),
      building: K(e.string()).optional()
    })
  ).optional()
});
function iu(t) {
  return (r) => e.union([
    e.object({ value: r }),
    e.object({ availableAt: t }),
    e.object({ disabled: e.literal(!0) })
  ]);
}
const gr = iu(be), au = e.object({
  id: e.number(),
  lastModified: be.optional(),
  begin: be,
  end: be,
  title: e.string(),
  subtitle: e.string(),
  breadcrumb: e.string()
}), pc = au.extend({
  kind: e.literal("general"),
  module: e.array(
    e.object({
      name: K(e.string()),
      code: K(e.string())
    })
  ),
  location: e.array(
    e.object({
      name: K(e.string()),
      building: K(e.string()),
      campus: K(e.string()),
      type: K(e.string()),
      map: K(e.string()),
      image: K(e.string()),
      equipment: K(e.array(e.string())),
      extraFields: e.array(K(e.string()))
    })
  ),
  extraFields: e.array(K(e.string())),
  digitalResource: e.object({
    onlineUrl: e.array(K(e.string())),
    recording: e.array(K(e.string())),
    links: e.array(K(e.string()))
  }),
  staff: e.array(
    e.object({
      name: K(e.string())
    })
  ),
  activity: e.object({
    name: K(e.string())
  }),
  message: e.object({
    comment: K(e.string())
  })
}), mc = au.extend({
  kind: e.literal("exam"),
  location: gr(e.string()),
  seatNo: gr(e.string().nullable()),
  fields: e.array(
    gr(e.string()).and(
      e.object({
        label: e.string(),
        type: e.string().optional()
      })
    )
  ),
  information: e.array(
    gr(
      e.object({
        title: e.string().optional(),
        type: e.enum(["error", "warning", "info"]).optional(),
        value: e.string()
      })
    )
  )
}), _T = e.discriminatedUnion("kind", [
  pc,
  mc
]);
var fc = typeof global == "object" && global && global.Object === Object && global, Ec = typeof self == "object" && self && self.Object === Object && self, Et = fc || Ec || Function("return this")(), yt = Et.Symbol, ou = Object.prototype, Tc = ou.hasOwnProperty, bc = ou.toString, or = yt ? yt.toStringTag : void 0;
function gc(t) {
  var r = Tc.call(t, or), a = t[or];
  try {
    t[or] = void 0;
    var o = !0;
  } catch {
  }
  var d = bc.call(t);
  return o && (r ? t[or] = a : delete t[or]), d;
}
var yc = Object.prototype, _c = yc.toString;
function Ac(t) {
  return _c.call(t);
}
var Sc = "[object Null]", Oc = "[object Undefined]", uo = yt ? yt.toStringTag : void 0;
function St(t) {
  return t == null ? t === void 0 ? Oc : Sc : uo && uo in Object(t) ? gc(t) : Ac(t);
}
function Gn(t) {
  return t != null && typeof t == "object";
}
var Rc = "[object Symbol]";
function $n(t) {
  return typeof t == "symbol" || Gn(t) && St(t) == Rc;
}
function hc(t, r) {
  for (var a = -1, o = t == null ? 0 : t.length, d = Array(o); ++a < o; )
    d[a] = r(t[a], a, t);
  return d;
}
var Mr = Array.isArray, so = yt ? yt.prototype : void 0, lo = so ? so.toString : void 0;
function uu(t) {
  if (typeof t == "string")
    return t;
  if (Mr(t))
    return hc(t, uu) + "";
  if ($n(t))
    return lo ? lo.call(t) : "";
  var r = t + "";
  return r == "0" && 1 / t == -1 / 0 ? "-0" : r;
}
function su(t) {
  var r = typeof t;
  return t != null && (r == "object" || r == "function");
}
var vc = "[object AsyncFunction]", Ic = "[object Function]", Pc = "[object GeneratorFunction]", Cc = "[object Proxy]";
function lu(t) {
  if (!su(t))
    return !1;
  var r = St(t);
  return r == Ic || r == Pc || r == vc || r == Cc;
}
var ln = Et["__core-js_shared__"], co = (function() {
  var t = /[^.]+$/.exec(ln && ln.keys && ln.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
})();
function Nc(t) {
  return !!co && co in t;
}
var Mc = Function.prototype, Dc = Mc.toString;
function Tt(t) {
  if (t != null) {
    try {
      return Dc.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var jc = /[\\^$.*+?()[\]{}|]/g, Lc = /^\[object .+?Constructor\]$/, Uc = Function.prototype, Fc = Object.prototype, wc = Uc.toString, Bc = Fc.hasOwnProperty, Gc = RegExp(
  "^" + wc.call(Bc).replace(jc, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function $c(t) {
  if (!su(t) || Nc(t))
    return !1;
  var r = lu(t) ? Gc : Lc;
  return r.test(Tt(t));
}
function Vc(t, r) {
  return t == null ? void 0 : t[r];
}
function Ot(t, r) {
  var a = Vc(t, r);
  return $c(a) ? a : void 0;
}
var Tn = Ot(Et, "WeakMap");
function kc(t, r) {
  return t === r || t !== t && r !== r;
}
var qc = 9007199254740991;
function Hc(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= qc;
}
function zc(t) {
  return t != null && Hc(t.length) && !lu(t);
}
var Yc = Object.prototype;
function Wc(t) {
  var r = t && t.constructor, a = typeof r == "function" && r.prototype || Yc;
  return t === a;
}
function xc(t, r) {
  return function(a) {
    return t(r(a));
  };
}
var Kc = xc(Object.keys, Object), Zc = Object.prototype, Jc = Zc.hasOwnProperty;
function Xc(t) {
  if (!Wc(t))
    return Kc(t);
  var r = [];
  for (var a in Object(t))
    Jc.call(t, a) && a != "constructor" && r.push(a);
  return r;
}
var Qc = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, ed = /^\w*$/;
function td(t, r) {
  if (Mr(t))
    return !1;
  var a = typeof t;
  return a == "number" || a == "symbol" || a == "boolean" || t == null || $n(t) ? !0 : ed.test(t) || !Qc.test(t) || r != null && t in Object(r);
}
var lr = Ot(Object, "create");
function rd() {
  this.__data__ = lr ? lr(null) : {}, this.size = 0;
}
function nd(t) {
  var r = this.has(t) && delete this.__data__[t];
  return this.size -= r ? 1 : 0, r;
}
var id = "__lodash_hash_undefined__", ad = Object.prototype, od = ad.hasOwnProperty;
function ud(t) {
  var r = this.__data__;
  if (lr) {
    var a = r[t];
    return a === id ? void 0 : a;
  }
  return od.call(r, t) ? r[t] : void 0;
}
var sd = Object.prototype, ld = sd.hasOwnProperty;
function cd(t) {
  var r = this.__data__;
  return lr ? r[t] !== void 0 : ld.call(r, t);
}
var dd = "__lodash_hash_undefined__";
function pd(t, r) {
  var a = this.__data__;
  return this.size += this.has(t) ? 0 : 1, a[t] = lr && r === void 0 ? dd : r, this;
}
function ft(t) {
  var r = -1, a = t == null ? 0 : t.length;
  for (this.clear(); ++r < a; ) {
    var o = t[r];
    this.set(o[0], o[1]);
  }
}
ft.prototype.clear = rd;
ft.prototype.delete = nd;
ft.prototype.get = ud;
ft.prototype.has = cd;
ft.prototype.set = pd;
function md() {
  this.__data__ = [], this.size = 0;
}
function Dr(t, r) {
  for (var a = t.length; a--; )
    if (kc(t[a][0], r))
      return a;
  return -1;
}
var fd = Array.prototype, Ed = fd.splice;
function Td(t) {
  var r = this.__data__, a = Dr(r, t);
  if (a < 0)
    return !1;
  var o = r.length - 1;
  return a == o ? r.pop() : Ed.call(r, a, 1), --this.size, !0;
}
function bd(t) {
  var r = this.__data__, a = Dr(r, t);
  return a < 0 ? void 0 : r[a][1];
}
function gd(t) {
  return Dr(this.__data__, t) > -1;
}
function yd(t, r) {
  var a = this.__data__, o = Dr(a, t);
  return o < 0 ? (++this.size, a.push([t, r])) : a[o][1] = r, this;
}
function Rt(t) {
  var r = -1, a = t == null ? 0 : t.length;
  for (this.clear(); ++r < a; ) {
    var o = t[r];
    this.set(o[0], o[1]);
  }
}
Rt.prototype.clear = md;
Rt.prototype.delete = Td;
Rt.prototype.get = bd;
Rt.prototype.has = gd;
Rt.prototype.set = yd;
var vr = Ot(Et, "Map");
function _d() {
  this.size = 0, this.__data__ = {
    hash: new ft(),
    map: new (vr || Rt)(),
    string: new ft()
  };
}
function Ad(t) {
  var r = typeof t;
  return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? t !== "__proto__" : t === null;
}
function jr(t, r) {
  var a = t.__data__;
  return Ad(r) ? a[typeof r == "string" ? "string" : "hash"] : a.map;
}
function Sd(t) {
  var r = jr(this, t).delete(t);
  return this.size -= r ? 1 : 0, r;
}
function Od(t) {
  return jr(this, t).get(t);
}
function Rd(t) {
  return jr(this, t).has(t);
}
function hd(t, r) {
  var a = jr(this, t), o = a.size;
  return a.set(t, r), this.size += a.size == o ? 0 : 1, this;
}
function bt(t) {
  var r = -1, a = t == null ? 0 : t.length;
  for (this.clear(); ++r < a; ) {
    var o = t[r];
    this.set(o[0], o[1]);
  }
}
bt.prototype.clear = _d;
bt.prototype.delete = Sd;
bt.prototype.get = Od;
bt.prototype.has = Rd;
bt.prototype.set = hd;
var vd = "Expected a function";
function Vn(t, r) {
  if (typeof t != "function" || r != null && typeof r != "function")
    throw new TypeError(vd);
  var a = function() {
    var o = arguments, d = r ? r.apply(this, o) : o[0], E = a.cache;
    if (E.has(d))
      return E.get(d);
    var m = t.apply(this, o);
    return a.cache = E.set(d, m) || E, m;
  };
  return a.cache = new (Vn.Cache || bt)(), a;
}
Vn.Cache = bt;
var Id = 500;
function Pd(t) {
  var r = Vn(t, function(o) {
    return a.size === Id && a.clear(), o;
  }), a = r.cache;
  return r;
}
var Cd = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Nd = /\\(\\)?/g, Md = Pd(function(t) {
  var r = [];
  return t.charCodeAt(0) === 46 && r.push(""), t.replace(Cd, function(a, o, d, E) {
    r.push(d ? E.replace(Nd, "$1") : o || a);
  }), r;
});
function Dd(t) {
  return t == null ? "" : uu(t);
}
function jd(t, r) {
  return Mr(t) ? t : td(t, r) ? [t] : Md(Dd(t));
}
function Ld(t) {
  if (typeof t == "string" || $n(t))
    return t;
  var r = t + "";
  return r == "0" && 1 / t == -1 / 0 ? "-0" : r;
}
function Ud(t, r) {
  r = jd(r, t);
  for (var a = 0, o = r.length; t != null && a < o; )
    t = t[Ld(r[a++])];
  return a && a == o ? t : void 0;
}
function Fd(t, r, a) {
  var o = t == null ? void 0 : Ud(t, r);
  return o === void 0 ? a : o;
}
var wd = "\\ud800-\\udfff", Bd = "\\u0300-\\u036f", Gd = "\\ufe20-\\ufe2f", $d = "\\u20d0-\\u20ff", Vd = Bd + Gd + $d, kd = "\\ufe0e\\ufe0f", qd = "\\u200d", Hd = RegExp("[" + qd + wd + Vd + kd + "]");
function zd(t) {
  return Hd.test(t);
}
var bn = Ot(Et, "DataView"), gn = Ot(Et, "Promise"), yn = Ot(Et, "Set"), po = "[object Map]", Yd = "[object Object]", mo = "[object Promise]", fo = "[object Set]", Eo = "[object WeakMap]", To = "[object DataView]", Wd = Tt(bn), xd = Tt(vr), Kd = Tt(gn), Zd = Tt(yn), Jd = Tt(Tn), mt = St;
(bn && mt(new bn(new ArrayBuffer(1))) != To || vr && mt(new vr()) != po || gn && mt(gn.resolve()) != mo || yn && mt(new yn()) != fo || Tn && mt(new Tn()) != Eo) && (mt = function(t) {
  var r = St(t), a = r == Yd ? t.constructor : void 0, o = a ? Tt(a) : "";
  if (o)
    switch (o) {
      case Wd:
        return To;
      case xd:
        return po;
      case Kd:
        return mo;
      case Zd:
        return fo;
      case Jd:
        return Eo;
    }
  return r;
});
function Xd(t) {
  return function(r) {
    return r == null ? void 0 : r[t];
  };
}
var Qd = "[object String]";
function ep(t) {
  return typeof t == "string" || !Mr(t) && Gn(t) && St(t) == Qd;
}
var tp = "[object Number]";
function rp(t) {
  return typeof t == "number" || Gn(t) && St(t) == tp;
}
function np(t) {
  return t === void 0;
}
var ip = Xd("length"), cu = "\\ud800-\\udfff", ap = "\\u0300-\\u036f", op = "\\ufe20-\\ufe2f", up = "\\u20d0-\\u20ff", sp = ap + op + up, lp = "\\ufe0e\\ufe0f", cp = "[" + cu + "]", _n = "[" + sp + "]", An = "\\ud83c[\\udffb-\\udfff]", dp = "(?:" + _n + "|" + An + ")", du = "[^" + cu + "]", pu = "(?:\\ud83c[\\udde6-\\uddff]){2}", mu = "[\\ud800-\\udbff][\\udc00-\\udfff]", pp = "\\u200d", fu = dp + "?", Eu = "[" + lp + "]?", mp = "(?:" + pp + "(?:" + [du, pu, mu].join("|") + ")" + Eu + fu + ")*", fp = Eu + fu + mp, Ep = "(?:" + [du + _n + "?", _n, pu, mu, cp].join("|") + ")", bo = RegExp(An + "(?=" + An + ")|" + Ep + fp, "g");
function Tp(t) {
  for (var r = bo.lastIndex = 0; bo.test(t); )
    ++r;
  return r;
}
function bp(t) {
  return zd(t) ? Tp(t) : ip(t);
}
var gp = "[object Map]", yp = "[object Set]";
function _p(t) {
  if (t == null)
    return 0;
  if (zc(t))
    return ep(t) ? bp(t) : t.length;
  var r = mt(t);
  return r == gp || r == yp ? t.size : Xc(t).length;
}
var Or = { exports: {} }, Ap = Or.exports, go;
function Sp() {
  return go || (go = 1, (function(t, r) {
    (function(a, o) {
      t.exports = o();
    })(Ap, (function() {
      var a = 1e3, o = 6e4, d = 36e5, E = "millisecond", m = "second", c = "minute", f = "hour", _ = "day", u = "week", b = "month", O = "quarter", T = "year", A = "date", g = "Invalid Date", C = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, G = /\[([^\]]+)]|YYYY|YY|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, D = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(P) {
        var v = ["th", "st", "nd", "rd"], R = P % 100;
        return "[" + P + (v[(R - 20) % 10] || v[R] || v[0]) + "]";
      } }, F = function(P, v, R) {
        var N = String(P);
        return !N || N.length >= v ? P : "" + Array(v + 1 - N.length).join(R) + P;
      }, k = { s: F, z: function(P) {
        var v = -P.utcOffset(), R = Math.abs(v), N = Math.floor(R / 60), h = R % 60;
        return (v <= 0 ? "+" : "-") + F(N, 2, "0") + ":" + F(h, 2, "0");
      }, m: function P(v, R) {
        if (v.date() < R.date()) return -P(R, v);
        var N = 12 * (R.year() - v.year()) + (R.month() - v.month()), h = v.clone().add(N, b), w = R - h < 0, B = v.clone().add(N + (w ? -1 : 1), b);
        return +(-(N + (R - h) / (w ? h - B : B - h)) || 0);
      }, a: function(P) {
        return P < 0 ? Math.ceil(P) || 0 : Math.floor(P);
      }, p: function(P) {
        return { M: b, y: T, w: u, d: _, D: A, h: f, m: c, s: m, ms: E, Q: O }[P] || String(P || "").toLowerCase().replace(/s$/, "");
      }, u: function(P) {
        return P === void 0;
      } }, j = "en", W = {};
      W[j] = D;
      var Q = "$isDayjsObject", X = function(P) {
        return P instanceof H || !(!P || !P[Q]);
      }, Y = function P(v, R, N) {
        var h;
        if (!v) return j;
        if (typeof v == "string") {
          var w = v.toLowerCase();
          W[w] && (h = w), R && (W[w] = R, h = w);
          var B = v.split("-");
          if (!h && B.length > 1) return P(B[0]);
        } else {
          var L = v.name;
          W[L] = v, h = L;
        }
        return !N && h && (j = h), h || !N && j;
      }, q = function(P, v) {
        if (X(P)) return P.clone();
        var R = typeof v == "object" ? v : {};
        return R.date = P, R.args = arguments, new H(R);
      }, M = k;
      M.l = Y, M.i = X, M.w = function(P, v) {
        return q(P, { locale: v.$L, utc: v.$u, x: v.$x, $offset: v.$offset });
      };
      var H = (function() {
        function P(R) {
          this.$L = Y(R.locale, null, !0), this.parse(R), this.$x = this.$x || R.x || {}, this[Q] = !0;
        }
        var v = P.prototype;
        return v.parse = function(R) {
          this.$d = (function(N) {
            var h = N.date, w = N.utc;
            if (h === null) return /* @__PURE__ */ new Date(NaN);
            if (M.u(h)) return /* @__PURE__ */ new Date();
            if (h instanceof Date) return new Date(h);
            if (typeof h == "string" && !/Z$/i.test(h)) {
              var B = h.match(C);
              if (B) {
                var L = B[2] - 1 || 0, $ = (B[7] || "0").substring(0, 3);
                return w ? new Date(Date.UTC(B[1], L, B[3] || 1, B[4] || 0, B[5] || 0, B[6] || 0, $)) : new Date(B[1], L, B[3] || 1, B[4] || 0, B[5] || 0, B[6] || 0, $);
              }
            }
            return new Date(h);
          })(R), this.init();
        }, v.init = function() {
          var R = this.$d;
          this.$y = R.getFullYear(), this.$M = R.getMonth(), this.$D = R.getDate(), this.$W = R.getDay(), this.$H = R.getHours(), this.$m = R.getMinutes(), this.$s = R.getSeconds(), this.$ms = R.getMilliseconds();
        }, v.$utils = function() {
          return M;
        }, v.isValid = function() {
          return this.$d.toString() !== g;
        }, v.isSame = function(R, N) {
          var h = q(R);
          return this.startOf(N) <= h && h <= this.endOf(N);
        }, v.isAfter = function(R, N) {
          return q(R) < this.startOf(N);
        }, v.isBefore = function(R, N) {
          return this.endOf(N) < q(R);
        }, v.$g = function(R, N, h) {
          return M.u(R) ? this[N] : this.set(h, R);
        }, v.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, v.valueOf = function() {
          return this.$d.getTime();
        }, v.startOf = function(R, N) {
          var h = this, w = !!M.u(N) || N, B = M.p(R), L = function(Pe, ue) {
            var ge = M.w(h.$u ? Date.UTC(h.$y, ue, Pe) : new Date(h.$y, ue, Pe), h);
            return w ? ge : ge.endOf(_);
          }, $ = function(Pe, ue) {
            return M.w(h.toDate()[Pe].apply(h.toDate("s"), (w ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(ue)), h);
          }, J = this.$W, te = this.$M, le = this.$D, Ge = "set" + (this.$u ? "UTC" : "");
          switch (B) {
            case T:
              return w ? L(1, 0) : L(31, 11);
            case b:
              return w ? L(1, te) : L(0, te + 1);
            case u:
              var ve = this.$locale().weekStart || 0, Ie = (J < ve ? J + 7 : J) - ve;
              return L(w ? le - Ie : le + (6 - Ie), te);
            case _:
            case A:
              return $(Ge + "Hours", 0);
            case f:
              return $(Ge + "Minutes", 1);
            case c:
              return $(Ge + "Seconds", 2);
            case m:
              return $(Ge + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, v.endOf = function(R) {
          return this.startOf(R, !1);
        }, v.$set = function(R, N) {
          var h, w = M.p(R), B = "set" + (this.$u ? "UTC" : ""), L = (h = {}, h[_] = B + "Date", h[A] = B + "Date", h[b] = B + "Month", h[T] = B + "FullYear", h[f] = B + "Hours", h[c] = B + "Minutes", h[m] = B + "Seconds", h[E] = B + "Milliseconds", h)[w], $ = w === _ ? this.$D + (N - this.$W) : N;
          if (w === b || w === T) {
            var J = this.clone().set(A, 1);
            J.$d[L]($), J.init(), this.$d = J.set(A, Math.min(this.$D, J.daysInMonth())).$d;
          } else L && this.$d[L]($);
          return this.init(), this;
        }, v.set = function(R, N) {
          return this.clone().$set(R, N);
        }, v.get = function(R) {
          return this[M.p(R)]();
        }, v.add = function(R, N) {
          var h, w = this;
          R = Number(R);
          var B = M.p(N), L = function(te) {
            var le = q(w);
            return M.w(le.date(le.date() + Math.round(te * R)), w);
          };
          if (B === b) return this.set(b, this.$M + R);
          if (B === T) return this.set(T, this.$y + R);
          if (B === _) return L(1);
          if (B === u) return L(7);
          var $ = (h = {}, h[c] = o, h[f] = d, h[m] = a, h)[B] || 1, J = this.$d.getTime() + R * $;
          return M.w(J, this);
        }, v.subtract = function(R, N) {
          return this.add(-1 * R, N);
        }, v.format = function(R) {
          var N = this, h = this.$locale();
          if (!this.isValid()) return h.invalidDate || g;
          var w = R || "YYYY-MM-DDTHH:mm:ssZ", B = M.z(this), L = this.$H, $ = this.$m, J = this.$M, te = h.weekdays, le = h.months, Ge = h.meridiem, ve = function(ue, ge, Se, ce) {
            return ue && (ue[ge] || ue(N, w)) || Se[ge].slice(0, ce);
          }, Ie = function(ue) {
            return M.s(L % 12 || 12, ue, "0");
          }, Pe = Ge || function(ue, ge, Se) {
            var ce = ue < 12 ? "AM" : "PM";
            return Se ? ce.toLowerCase() : ce;
          };
          return w.replace(G, (function(ue, ge) {
            return ge || (function(Se) {
              switch (Se) {
                case "YY":
                  return String(N.$y).slice(-2);
                case "YYYY":
                  return M.s(N.$y, 4, "0");
                case "M":
                  return J + 1;
                case "MM":
                  return M.s(J + 1, 2, "0");
                case "MMM":
                  return ve(h.monthsShort, J, le, 3);
                case "MMMM":
                  return ve(le, J);
                case "D":
                  return N.$D;
                case "DD":
                  return M.s(N.$D, 2, "0");
                case "d":
                  return String(N.$W);
                case "dd":
                  return ve(h.weekdaysMin, N.$W, te, 2);
                case "ddd":
                  return ve(h.weekdaysShort, N.$W, te, 3);
                case "dddd":
                  return te[N.$W];
                case "H":
                  return String(L);
                case "HH":
                  return M.s(L, 2, "0");
                case "h":
                  return Ie(1);
                case "hh":
                  return Ie(2);
                case "a":
                  return Pe(L, $, !0);
                case "A":
                  return Pe(L, $, !1);
                case "m":
                  return String($);
                case "mm":
                  return M.s($, 2, "0");
                case "s":
                  return String(N.$s);
                case "ss":
                  return M.s(N.$s, 2, "0");
                case "SSS":
                  return M.s(N.$ms, 3, "0");
                case "Z":
                  return B;
              }
              return null;
            })(ue) || B.replace(":", "");
          }));
        }, v.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, v.diff = function(R, N, h) {
          var w, B = this, L = M.p(N), $ = q(R), J = ($.utcOffset() - this.utcOffset()) * o, te = this - $, le = function() {
            return M.m(B, $);
          };
          switch (L) {
            case T:
              w = le() / 12;
              break;
            case b:
              w = le();
              break;
            case O:
              w = le() / 3;
              break;
            case u:
              w = (te - J) / 6048e5;
              break;
            case _:
              w = (te - J) / 864e5;
              break;
            case f:
              w = te / d;
              break;
            case c:
              w = te / o;
              break;
            case m:
              w = te / a;
              break;
            default:
              w = te;
          }
          return h ? w : M.a(w);
        }, v.daysInMonth = function() {
          return this.endOf(b).$D;
        }, v.$locale = function() {
          return W[this.$L];
        }, v.locale = function(R, N) {
          if (!R) return this.$L;
          var h = this.clone(), w = Y(R, N, !0);
          return w && (h.$L = w), h;
        }, v.clone = function() {
          return M.w(this.$d, this);
        }, v.toDate = function() {
          return new Date(this.valueOf());
        }, v.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, v.toISOString = function() {
          return this.$d.toISOString();
        }, v.toString = function() {
          return this.$d.toUTCString();
        }, P;
      })(), ee = H.prototype;
      return q.prototype = ee, [["$ms", E], ["$s", m], ["$m", c], ["$H", f], ["$W", _], ["$M", b], ["$y", T], ["$D", A]].forEach((function(P) {
        ee[P[1]] = function(v) {
          return this.$g(v, P[0], P[1]);
        };
      })), q.extend = function(P, v) {
        return P.$i || (P(v, H, q), P.$i = !0), q;
      }, q.locale = Y, q.isDayjs = X, q.unix = function(P) {
        return q(1e3 * P);
      }, q.en = W[j], q.Ls = W, q.p = {}, q;
    }));
  })(Or)), Or.exports;
}
var Op = Sp();
const cr = /* @__PURE__ */ vn(Op);
var Rr = { exports: {} }, Rp = Rr.exports, yo;
function hp() {
  return yo || (yo = 1, (function(t, r) {
    (function(a, o) {
      t.exports = o();
    })(Rp, (function() {
      var a = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, o = {};
      return function(d, E, m) {
        var c, f = function(O, T, A) {
          A === void 0 && (A = {});
          var g = new Date(O), C = (function(G, D) {
            D === void 0 && (D = {});
            var F = D.timeZoneName || "short", k = G + "|" + F, j = o[k];
            return j || (j = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: G, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: F }), o[k] = j), j;
          })(T, A);
          return C.formatToParts(g);
        }, _ = function(O, T) {
          for (var A = f(O, T), g = [], C = 0; C < A.length; C += 1) {
            var G = A[C], D = G.type, F = G.value, k = a[D];
            k >= 0 && (g[k] = parseInt(F, 10));
          }
          var j = g[3], W = j === 24 ? 0 : j, Q = g[0] + "-" + g[1] + "-" + g[2] + " " + W + ":" + g[4] + ":" + g[5] + ":000", X = +O;
          return (m.utc(Q).valueOf() - (X -= X % 1e3)) / 6e4;
        }, u = E.prototype;
        u.tz = function(O, T) {
          if (O === void 0 && (O = c), !this.isValid()) return this;
          var A, g = this.utcOffset(), C = this.toDate(), G = C.toLocaleString("en-US", { timeZone: O }), D = _(+C, O);
          if (!Number(D)) A = this.utcOffset(0, T);
          else if (A = m(G, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(D, !0), T) {
            var F = A.utcOffset();
            A = A.add(g - F, "minute");
          }
          return A.$x.$timezone = O, A;
        }, u.offsetName = function(O) {
          var T = this.$x.$timezone || m.tz.guess(), A = f(this.valueOf(), T, { timeZoneName: O }).find((function(g) {
            return g.type.toLowerCase() === "timezonename";
          }));
          return A && A.value;
        };
        var b = u.startOf;
        u.startOf = function(O, T) {
          if (!this.$x || !this.$x.$timezone) return b.call(this, O, T);
          var A = m(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
          return b.call(A, O, T).tz(this.$x.$timezone, !0);
        }, m.tz = function(O, T, A) {
          var g = A && T, C = A || T || c, G = _(+m(), C);
          if (typeof O != "string") return m(O).tz(C);
          var D = m.utc(O, g).valueOf();
          if (Number.isNaN(D)) {
            var F = m(NaN);
            return F.$x.$timezone = C, F;
          }
          var k = (function(X, Y, q) {
            var M = X - 60 * Y * 1e3, H = _(M, q);
            if (Y === H) return [M, Y];
            var ee = _(M -= 60 * (H - Y) * 1e3, q);
            return H === ee ? [M, H] : [X - 60 * Math.min(H, ee) * 1e3, Math.max(H, ee)];
          })(D, G, C), j = k[0], W = k[1], Q = m(j).utcOffset(W);
          return Q.$x.$timezone = C, Q;
        }, m.tz.guess = function() {
          return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, m.tz.setDefault = function(O) {
          c = O;
        };
      };
    }));
  })(Rr)), Rr.exports;
}
var vp = hp();
const Ip = /* @__PURE__ */ vn(vp);
var hr = { exports: {} }, Pp = hr.exports, _o;
function Cp() {
  return _o || (_o = 1, (function(t, r) {
    (function(a, o) {
      t.exports = o();
    })(Pp, (function() {
      var a = "minute", o = /[+-]\d\d(?::?\d\d)?/g, d = /([+-]|\d\d)/g;
      return function(E, m, c) {
        var f = m.prototype;
        c.utc = function(g) {
          var C = { date: g, utc: !0, args: arguments };
          return new m(C);
        }, f.utc = function(g) {
          var C = c(this.toDate(), { locale: this.$L, utc: !0 });
          return g ? C.add(this.utcOffset(), a) : C;
        }, f.local = function() {
          return c(this.toDate(), { locale: this.$L, utc: !1 });
        };
        var _ = f.parse;
        f.parse = function(g) {
          g.utc && (this.$u = !0), this.$utils().u(g.$offset) || (this.$offset = g.$offset), _.call(this, g);
        };
        var u = f.init;
        f.init = function() {
          if (this.$u) {
            var g = this.$d;
            this.$y = g.getUTCFullYear(), this.$M = g.getUTCMonth(), this.$D = g.getUTCDate(), this.$W = g.getUTCDay(), this.$H = g.getUTCHours(), this.$m = g.getUTCMinutes(), this.$s = g.getUTCSeconds(), this.$ms = g.getUTCMilliseconds();
          } else u.call(this);
        };
        var b = f.utcOffset;
        f.utcOffset = function(g, C) {
          var G = this.$utils().u;
          if (G(g)) return this.$u ? 0 : G(this.$offset) ? b.call(this) : this.$offset;
          if (typeof g == "string" && (g = (function(j) {
            j === void 0 && (j = "");
            var W = j.match(o);
            if (!W) return null;
            var Q = ("" + W[0]).match(d) || ["-", 0, 0], X = Q[0], Y = 60 * +Q[1] + +Q[2];
            return Y === 0 ? 0 : X === "+" ? Y : -Y;
          })(g), g === null)) return this;
          var D = Math.abs(g) <= 16 ? 60 * g : g;
          if (D === 0) return this.utc(C);
          var F = this.clone();
          if (C) return F.$offset = D, F.$u = !1, F;
          var k = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          return (F = this.local().add(D + k, a)).$offset = D, F.$x.$localOffset = k, F;
        };
        var O = f.format;
        f.format = function(g) {
          var C = g || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
          return O.call(this, C);
        }, f.valueOf = function() {
          var g = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
          return this.$d.valueOf() - 6e4 * g;
        }, f.isUTC = function() {
          return !!this.$u;
        }, f.toISOString = function() {
          return this.toDate().toISOString();
        }, f.toString = function() {
          return this.toDate().toUTCString();
        };
        var T = f.toDate;
        f.toDate = function(g) {
          return g === "s" && this.$offset ? c(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : T.call(this);
        };
        var A = f.diff;
        f.diff = function(g, C, G) {
          if (g && this.$u === g.$u) return A.call(this, g, C, G);
          var D = this.local(), F = c(g).local();
          return A.call(D, F, C, G);
        };
      };
    }));
  })(hr)), hr.exports;
}
var Np = Cp();
const Mp = /* @__PURE__ */ vn(Np);
function Dp(t, r, a) {
  try {
    return r !== void 0 ? JSON.stringify(t, a, r) : JSON.stringify(t);
  } catch {
    return "";
  }
}
function qe(t) {
  return typeof t == "object" && t !== null && !gt(t);
}
function AT(t) {
  return kn(t) ? t > 0 : !1;
}
function kn(t) {
  return typeof t == "number" && !isNaN(t);
}
function ST(t) {
  return typeof t == "boolean";
}
function fr(t) {
  return typeof t == "string";
}
function OT(t) {
  return fr(t) && t.length > 0;
}
function gt(t) {
  return Array.isArray(t);
}
function jp(t) {
  return Te(t) && t.length > 0;
}
function RT(t, r = "Expected a non-empty array") {
  if (!jp(t)) throw new Error(r);
}
function Te(t) {
  return t != null;
}
function Lp(t) {
  return typeof t == "number" && isNaN(t) || t === void 0 || t === null;
}
function hT(t) {
  return Object.entries(t);
}
const Ir = [
  "data",
  "error",
  "cause",
  "response",
  "config",
  "signal",
  "reason"
];
function Up({
  fallback: t,
  options: r
}) {
  return function a(o, d, E, m = ".") {
    if (Te(r == null ? void 0 : r.limit) && _p(E) >= r.limit)
      return E;
    if (gt(o)) {
      let _ = { ...E };
      for (let u = 0; u < o.length; u++) {
        const b = `${m}[${u}]`;
        _ = a(o[u], d, _, b);
      }
      return _;
    }
    if (fr(o))
      try {
        const _ = JSON.parse(o);
        return a(_, d, E, m);
      } catch {
      }
    const c = d(o);
    let f = { ...E };
    if (Te(c)) {
      const _ = f[c];
      Te(_) ? f[c] = [..._, m] : f[c] = [m];
    }
    if (!qe(o))
      return Object.keys(f).length > 0 ? f : t();
    for (const _ of Ir)
      if (Te(o[_])) {
        const u = m === "." ? `.${_}` : `${m}.${_}`;
        f = a(o[_], d, f, u);
      }
    return Object.keys(f).length > 0 ? f : t();
  };
}
function vT({
  fallback: t,
  options: r
}) {
  return function a(o, d, E, m = ".") {
    if (Te(r == null ? void 0 : r.limit) && E.length >= r.limit)
      return E;
    if (gt(o)) {
      let _ = [...E];
      for (let u = 0; u < o.length; u++) {
        const b = `${m}[${u}]`;
        _ = a(o[u], d, _, b);
      }
      return _;
    }
    if (fr(o))
      try {
        const _ = JSON.parse(o);
        return a(_, d, E, m);
      } catch {
      }
    const c = d(o);
    let f = [...E];
    for (const _ of c)
      f.push({ value: _, path: m });
    if (!qe(o))
      return f.length > 0 ? f : t();
    for (const _ of Ir)
      if (Te(o[_])) {
        const u = m === "." ? `.${_}` : `${m}.${_}`;
        f = a(o[_], d, f, u);
      }
    return f.length > 0 ? f : t();
  };
}
function Ao(t, r) {
  return Up({
    fallback: () => ({ [Dp(t)]: ["."] }),
    options: r
  })(t, (d) => {
    if (Lp(d))
      return "";
    if (fr(d))
      return d;
    if (Fp(d))
      return d.message;
  }, {});
}
function qn(t) {
  if (qe(t) && "response" in t) {
    const o = Ao(t), d = Object.entries(o).find(
      ([E, m]) => m == null ? void 0 : m.some((c) => c === ".response.data")
    );
    if (d)
      return d[0];
  }
  const r = Ao(t, { limit: 1 });
  return wp(r)[0] ?? "";
}
function Fp(t) {
  return qe(t) && Object.prototype.hasOwnProperty.call(t, "message") && typeof t.message == "string";
}
function wp(t) {
  return Object.entries(t).map(([a, o]) => ({
    value: a,
    path: o.map(Bp).sort(So)[0]
  })).sort((a, o) => Te(a.path) ? Te(o.path) ? So(a.path, o.path) : -1 : Te(o.path) ? 1 : 0).map(({ value: a }) => a);
}
function Bp(t) {
  return [...t.matchAll(/\.([^.[]+)|\[(\d+)\]/g)].flatMap(
    ([, r, a]) => Te(a) ? [Number(a)] : Te(r) ? [r] : []
  );
}
function So(t, r) {
  if (t.length !== r.length) return t.length - r.length;
  for (let a = 0; a < t.length; a++) {
    const o = t[a], d = r[a];
    if (o === void 0 || d === void 0) break;
    const E = Gp(o, d);
    if (E !== 0) return E;
  }
  return 0;
}
function Gp(t, r) {
  return typeof t == "number" && typeof r == "number" ? t - r : typeof t == "number" ? -1 : typeof r == "number" ? 1 : Oo(t) - Oo(r) || t.localeCompare(r);
}
function Oo(t) {
  const r = Ir.indexOf(t);
  return r === -1 ? Ir.length : r;
}
const Ro = new RegExp(
  "^(?:0[1-9]|[1-2]\\d|3[0-1])[/-](?:0[1-9]|1[0-2])[/-]\\d{4}(?: (?:[0-1]\\d|2[0-4]):[0-5]\\d:[0-5]\\d)?$"
);
function IT(t) {
  return qe(t) && "data" in t;
}
cr.extend(Mp);
cr.extend(Ip);
const Sn = e.preprocess(
  (t) => t instanceof Date ? t.toISOString() : t,
  e.iso.datetime()
), _t = e.preprocess(
  (t) => t instanceof Date ? t.toISOString() : t,
  e.iso.datetime().optional()
), Tu = 5;
function $p(t) {
  return t.reduce((r, a, o) => {
    const d = a.path.findIndex((c) => rp(c)), E = d === -1 ? a.path.length - 1 : d - 1;
    return !r.some(
      (c) => c.path[E] === a.path[E]
    ) && o < Tu && r.push(a), r;
  }, []);
}
function PT(t, r) {
  const a = $p(t);
  let o = a.map((E) => {
    const m = Fd(r, E.path.join("."));
    return `${E.message}. Path: ${E.path.join("->")}. Value: ${typeof m == "object" ? JSON.stringify(m) : m}`;
  }).join(`
`);
  const d = t.length - a.length;
  return t.length > Tu ? o += `. There are ${d} additional issues.` : d > 0 && (o += `. There are ${d} similar issues.`), o;
}
function Vp(t) {
  return e.record(e.string(), t).refine((r) => Object.keys(r).length <= no, {
    message: `Record cannot exceed ${no} entries`
  });
}
function Hn(t) {
  return t.superRefine((r, a) => {
    if (qe(r))
      for (const [o, d] of Object.entries(r))
        np(d) && d !== null && a.issues.push({
          input: [o, d],
          code: "custom",
          path: [o],
          message: `${o} can be omitted, but not undefined.`
        });
  });
}
function Oe(t, r) {
  const a = r.reduce((o, d) => (d in t.shape && (o[d] = !0), o), {});
  return t.omit(a);
}
const ho = /* @__PURE__ */ new Map();
function zn(t, r) {
  let a = ho.get(r);
  return a || (a = new Intl.DateTimeFormat("sv-SE", {
    timeZone: r,
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  }), ho.set(r, a)), a.format(new Date(t * 1e3));
}
function kp(t, r, a) {
  try {
    const [o = "", d = "00:00:00"] = t.split(" "), [E, m, c] = o.split(/[/-]/), f = `${c}-${m}-${E} ${d}`, _ = new RegExp(/\b\d\b/, "g"), b = f.replace(
      _,
      "0$&"
    );
    if (cr.utc(b).format("YYYY-MM-DD HH:mm:ss") !== b)
      return a ? (a.issues.push({
        input: t,
        code: "custom",
        message: `Invalid date value: ${t}`
      }), { local: "", timezone: "", unix: 0 }) : { local: "Invalid Date", timezone: r, unix: NaN };
    const O = cr.tz(b, r).unix();
    return { local: zn(O, r), timezone: r, unix: O };
  } catch (o) {
    if (a)
      a.issues.push({
        input: t,
        code: "custom",
        message: qn(o)
      });
    else
      throw o;
    return {
      local: "",
      timezone: "",
      unix: 0
    };
  }
}
function qp(t, r, a) {
  try {
    const o = cr(t);
    if (!o.isValid())
      return { local: "Invalid Date", timezone: r, unix: NaN };
    const d = o.unix();
    return { local: zn(d, r), timezone: r, unix: d };
  } catch (o) {
    if (a)
      a.issues.push({
        input: t,
        code: "custom",
        message: qn(o)
      });
    else
      throw o;
    return {
      local: "",
      timezone: "",
      unix: 0
    };
  }
}
function Hp(t, r, a) {
  try {
    return { local: zn(t, r), timezone: r, unix: t };
  } catch (o) {
    if (a)
      a.issues.push({
        input: t,
        code: "custom",
        message: qn(o)
      });
    else
      throw o;
    return {
      local: "",
      unix: 0,
      timezone: ""
    };
  }
}
const bu = (t) => t.transform((r) => Number(r)).pipe(e.number()), gu = (t) => t.transform((r) => isFinite(Number(r)) ? Math.round(Number(r)) : 0).pipe(e.number()), yu = (t) => t.transform((r) => {
  const a = Number(r);
  return isFinite(a) && a >= 0 ? Math.round(a) : 0;
}).pipe(e.number()), zp = bu(e.unknown()), Yp = bu(e.string()), Yn = gu(e.unknown()), CT = gu(e.string()), pt = yu(
  e.unknown()
), NT = yu(e.string()), MT = e.unknown().transform((t) => t == null ? "" : qe(t) || kn(t) ? t.toString() : fr(t) ? t : "").pipe(e.string()), vo = e.unknown().transform((t) => typeof t == "object" ? JSON.stringify(t) : Te(t) ? `${t}` : "").pipe(e.string()), DT = e.unknown().transform((t) => !!t).pipe(e.boolean()), jT = e.unknown().transform((t) => gt(t) ? !!t[0] : !!t).pipe(e.boolean()), LT = e.unknown().transform((t) => gt(t) ? t.length === 0 ? 0 : Number(t[0]) : Number(t)).pipe(e.number()), UT = e.unknown().transform((t) => gt(t) ? t.join(", ") : t ?? "").pipe(e.string()), cn = e.union([e.object({ id: e.string() }), e.string()]).transform((t) => qe(t) ? t.id : t).pipe(e.string()), Wp = e.unknown().transform((t) => t === void 0 ? [] : gt(t) ? t.map((r) => vo.parse(r)) : [vo.parse(t)]).pipe(e.array(e.string())), xp = e.iso.datetime({ offset: !0 }), dr = (t) => e.string().superRefine((r, a) => {
  !Ro.test(r) && !xp.validate(r) && a.issues.push({
    input: r,
    message: `Wrong date format: ${r}`,
    code: "invalid_format",
    format: "date"
  });
}).transform((r, a) => Ro.test(r) ? kp(r, t, a) : qp(r, t, a)).pipe(be).or(
  e.number().int().nonnegative().transform((r, a) => Hp(r, t, a)).pipe(be)
).or(be), Io = e.object({
  label: e.string(),
  title: e.string(),
  id: e.number()
}), Kp = e.union([e.number(), Io]).transform((t) => kn(t) ? {
  label: "",
  title: "",
  id: t
} : t).pipe(Io), Lr = e.partialRecord(
  e.string(),
  e.array(e.number()).or(e.undefined())
), Zp = ["open", "closed", "not_set"], Wn = e.enum(Zp), xn = e.object({
  invalidCourseIds: e.boolean(),
  invalidActivityType: e.boolean()
}).partial(), _u = e.object({
  multipleAllocations: e.boolean()
}).partial(), Au = xn.extend({
  noAllocation: e.boolean()
}).partial(), Su = Au.extend({
  overEnrollment: e.boolean()
}).partial(), Ou = Su.keyof(), Jp = e.enum([
  ...Ou.exclude(xn.keyof().options).options,
  "groupDataIssues",
  "studentDataIssues"
]), Ru = e.object({
  id: e.number(),
  incompleteStudents: e.array(e.number()).optional(),
  enrolledStudents: e.array(e.number()),
  activities: e.array(e.number()),
  object: me,
  capacity: e.number().int().nonnegative().optional(),
  inWaitlist: e.number().int().nonnegative().optional(),
  issues: Su,
  openStatuses: e.array(Wn)
}), hu = e.object({
  key: e.string(),
  id: e.number(),
  incompleteStudents: e.array(e.number()).optional(),
  groups: e.array(e.number()),
  activityType: e.string(),
  courseId: e.number(),
  students: e.array(e.number()),
  capacity: e.number().int().nonnegative().optional(),
  inWaitlist: e.number().int().nonnegative().optional()
}), Xp = e.object({
  id: e.number(),
  object: me,
  issues: _u
}), vu = e.object({
  id: e.number(),
  activityId: e.number(),
  courseId: e.number(),
  object: me,
  allocated: e.number().int().nonnegative(),
  capacity: e.number().int().nonnegative(),
  inWaitlist: e.array(e.number().int().nonnegative()).default([]),
  leaving: e.array(e.number().int().nonnegative()).default([]),
  issues: Au,
  open: Wn
}), Qp = e.object({
  conflict: e.array(e.number()),
  size: e.array(e.number()),
  buffer: e.array(e.number()),
  doubleBooked: e.array(e.number()),
  dedicated: e.array(e.number()),
  hidden: e.array(e.number()),
  registrationPeriod: e.array(e.number())
}), em = e.object({
  systemError: e.partialRecord(
    e.string(),
    e.object({
      message: e.string(),
      code: e.number(),
      name: Jo,
      presentableText: e.string().nullable().optional()
    }).or(e.undefined())
  )
}), Iu = e.object({
  failsWithGroups: Qp.partial().optional(),
  failsWithMessage: em.partial().optional(),
  linkedGroupIds: e.array(e.number())
}), FT = e.partialRecord(e.string(), Iu), Kn = e.object({
  courseId: e.number(),
  activity: e.string(),
  activityId: e.number().optional()
}), wT = e.partialRecord(
  e.string(),
  e.array(Kn)
), tm = Kn.extend({
  reasons: Iu.partial().optional()
}), Zn = e.object({
  buffer: e.boolean().optional(),
  doubleBooked: e.boolean().optional(),
  dedicated: e.boolean().optional(),
  hidden: e.boolean().optional(),
  registrationPeriod: e.boolean().optional()
}), Jn = e.partialRecord(
  e.string(),
  e.array(tm)
), rm = Kn.extend({
  group: e.number()
}), nm = e.partialRecord(
  e.string(),
  e.array(rm)
), Xn = e.object({
  logId: e.string().optional(),
  failedGroups: Jn,
  successGroups: nm,
  swapStudentInfo: Lr.optional()
}), BT = Xn.omit({
  swapStudentInfo: !0
}).extend({
  swapStudentInfo: e.undefined().optional()
}), GT = Xn.omit({
  swapStudentInfo: !0
}).extend({
  swapStudentInfo: Lr
}), $T = e.object({
  missingLinks: e.array(e.number()),
  missingGroupsForActivities: e.array(e.number())
}), VT = e.object({
  addResult: Xn,
  removeResult: e.string()
}), kT = e.object({
  size: e.number(),
  isPercent: e.boolean()
}), im = ["start", "end"], qT = e.enum(im), am = e.object({
  numberOfIssues: e.number()
}), om = e.object({
  completed: e.boolean()
}), HT = e.object({
  list: e.record(Jp, am),
  issueCount: e.number(),
  courses: e.record(e.string(), om.optional())
}), um = e.object({
  courseId: e.number(),
  groupIds: e.array(e.number())
}), zT = e.object({
  changeRequests: e.array(um)
}), sm = e.object({
  groupId: e.number(),
  groupLabel: e.string(),
  courseIds: e.array(e.number()),
  courseLabels: e.array(e.string()),
  activityTypes: e.array(e.string()),
  issueNames: e.array(xn.keyof().or(e.literal("unknownIssue")))
}), YT = e.object({
  groups: e.array(sm),
  total: e.number().int().nonnegative()
}), lm = e.object({
  issueId: e.number(),
  studentId: e.number(),
  studentLabel: e.string(),
  courseId: e.number(),
  courseLabel: e.string(),
  activityId: e.number(),
  activityType: e.string(),
  groupIds: e.array(e.number()),
  groupLabels: e.array(e.string()),
  issueName: _u.keyof().or(e.literal("unknownIssue"))
}), WT = e.object({
  students: e.array(lm),
  total: e.number().int().nonnegative()
}), cm = e.object({
  id: e.number(),
  value: e.string()
}), dm = e.object({
  id: e.number()
}), Pu = e.union([
  e.object({
    kind: e.literal("category"),
    data: e.array(cm)
  }),
  e.object({
    kind: e.literal("relation"),
    data: e.array(dm)
  }),
  e.object({
    kind: e.literal("none"),
    data: e.undefined().optional()
  })
]);
var Cu = /* @__PURE__ */ ((t) => (t[t.SPREAD = 1] = "SPREAD", t))(Cu || {});
const On = e.enum(Cu);
var Nu = /* @__PURE__ */ ((t) => (t.TYPE = "t", t.FIELD = "f", t.NONE = "none", t))(Nu || {});
const pm = (t) => t, Pr = e.number(), mm = pm({
  t: e.object({
    r: On,
    v: Pr,
    k: e.literal(
      "t"
      /* TYPE */
    )
  }),
  f: e.object({
    r: On,
    v: Pr,
    k: e.literal(
      "f"
      /* FIELD */
    )
  }),
  none: e.object({
    k: e.literal(
      "none"
      /* NONE */
    )
  })
}), fm = e.discriminatedUnion(
  "k",
  Object.values(mm)
), xT = e.object({
  dedi: Pu,
  dist: fm
}), Em = e.object({
  k: e.enum(Nu).optional(),
  r: On.optional(),
  v: e.union([Pr, e.array(Pr)]).optional()
}), KT = e.object({
  groupIds: e.array(e.number()),
  distribution: Em,
  override: e.boolean()
}), Tm = e.object({
  id: e.number(),
  name: e.string(),
  activityId: e.number()
}), bm = e.object({
  id: e.number(),
  name: e.string(),
  groups: e.array(e.number()),
  courseId: e.number()
}), gm = e.object({
  id: e.number(),
  activities: e.array(e.number()).optional()
}), ym = e.object({
  id: e.number(),
  fields: e.array(mr),
  relations: e.array(e.number()),
  activities: e.array(e.number()),
  totalActivities: e.number(),
  groups: e.array(e.number())
}), _m = "ALLOCATED", Am = "NOT_ALLOCATED", ZT = "GROUP:", Sm = e.union([
  e.literal(_m),
  e.literal(Am),
  e.string().regex(/^GROUP:\d+$/)
]), JT = e.object({
  programs: e.array(me),
  students: e.array(ym),
  groupLookup: e.partialRecord(e.string(), Tm),
  courseLookup: e.partialRecord(e.string(), gm),
  activitiesLookup: e.partialRecord(e.string(), bm),
  totalStudents: e.number()
}), Mu = e.object({
  fieldId: Yn,
  values: Wp
}), Du = e.object({
  sort: e.enum(Nr).extract(["ASCFIELD", "DESCFIELD"]).optional(),
  sortFieldId: e.number().nonnegative().int().optional()
}), Om = e.object({
  sort: e.enum(Nr).extract(["ASCFIELD", "DESCFIELD"]).optional(),
  key: e.string()
}), XT = e.union([Du, Om]), Rm = e.array(
  e.object({
    reservationId: e.number(),
    start: e.number(),
    end: e.number(),
    studentSetGroupId: e.number(),
    activityId: e.number(),
    courseId: e.number()
  })
), hm = e.object({
  reservations: Rm,
  allocated: e.boolean()
}), Qn = e.record(
  e.string(),
  hm
), QT = e.record(
  e.string(),
  Qn
), eb = e.partialRecord(e.string(), e.number()), vm = e.object({
  taken: pt,
  available: pt,
  total: pt,
  raw: e.object({
    taken: pt,
    available: pt,
    total: pt,
    buffer: pt
  })
}), ju = me == null ? void 0 : me.partial().and(
  me.pick({
    id: !0,
    extId: !0,
    fields: !0,
    members: !0,
    types: !0,
    relations: !0
  })
), Lu = me.pick({
  id: !0,
  fields: !0
}), Im = Lu.extend(
  me.pick({ relations: !0 }).shape
), Pm = me.pick({
  id: !0,
  extId: !0,
  fields: !0,
  types: !0,
  relations: !0
}), ei = e.object({
  id: zp,
  label: e.string()
}), Uu = ei.extend({
  extId: e.string(),
  typeIds: e.array(e.number()),
  children: e.array(e.number()).optional().default([]),
  teObject: ju
}), Fu = ei.extend({
  children: e.array(e.number()).optional().default([]),
  parentId: e.number().int().positive()
}), ti = ei.extend({
  extId: e.string(),
  typeIds: e.array(e.number()),
  parentId: e.number().int().positive(),
  teObject: ju,
  links: e.array(e.number())
}), tb = e.object({
  courses: e.partialRecord(e.string(), Uu),
  activities: e.partialRecord(e.string(), Fu),
  groups: e.partialRecord(e.string(), ti)
}), wu = Uu.extend({
  open: e.boolean().optional(),
  showInRegistration: e.boolean().optional().transform((t) => !!t)
}), Cm = wu.pick({
  id: !0,
  label: !0,
  children: !0,
  open: !0
}).extend({ teObject: Lu }), Nm = Fu.extend({
  allocationSignal: Yo.optional().default("ISSUE"),
  open: e.boolean().optional(),
  showInRegistration: e.boolean().optional().transform((t) => !!t),
  hasWaitlist: e.boolean().default(!1),
  hasConflicts: e.boolean().default(!1)
}), Bu = ti.extend({
  seats: vm.optional().default({
    taken: 0,
    available: 0,
    total: 0,
    raw: { taken: 0, available: 0, total: 0, buffer: 0 }
  }),
  allocationStatus: Ml.optional().default("NOT_ALLOCATED"),
  open: e.boolean().optional(),
  dedicated: Pu.optional().default({
    kind: "none",
    data: void 0
  }),
  hidden: e.boolean().optional().transform((t) => !!t),
  showInRegistration: e.boolean().optional().transform((t) => !!t),
  matchDedication: e.boolean().optional().transform((t) => !!t),
  waitlistPosition: e.number().optional().default(0),
  hasStudentsInWaitlist: e.boolean().optional().default(!1)
}), Mm = Bu.pick({
  id: !0,
  label: !0,
  parentId: !0,
  links: !0,
  seats: !0,
  allocationStatus: !0,
  open: !0,
  dedicated: !0,
  hidden: !0,
  matchDedication: !0,
  waitlistPosition: !0,
  hasStudentsInWaitlist: !0
}).extend({ teObject: Im }), Gu = (t) => e.object({
  id: e.number(),
  start: dr(t),
  end: dr(t),
  name: e.string(),
  reservation: Fn,
  groupId: e.number(),
  allocationConflicts: e.array(
    e.object({
      groupId: e.number(),
      reservationId: e.number()
    })
  )
}), Dm = (t) => e.object({
  events: e.array(Gu(t)),
  conflicts: Qn,
  timezone: e.string()
}), rb = (t) => Dm(t.timezone).omit({ timezone: !0 }), jm = (t) => e.object({
  courses: e.partialRecord(e.string(), wu),
  courseIds: e.array(e.number()).optional().default([]),
  activities: e.partialRecord(e.string(), Nm),
  groups: e.partialRecord(e.string(), Bu),
  events: e.array(Gu(t.user.identifier)),
  conflicts: Qn,
  serverDateTime: dr(t.server.identifier).optional(),
  timezone: ru,
  studentId: e.number(),
  studentObject: me.optional(),
  blockStudentConflict: e.boolean().optional(),
  enableWaitlist: e.boolean().optional()
}), Po = (t) => jm(t).extend({
  courses: e.partialRecord(e.string(), Cm),
  groups: e.partialRecord(e.string(), Mm),
  studentObject: Pm.optional()
}), nb = (t) => {
  const r = ru.safeParse(t.timezone);
  if (!r.success) {
    const a = "invalid timezone", o = {
      name: a,
      identifier: a,
      extId: a,
      offset: a
    };
    return Po({
      user: o,
      server: o
    });
  }
  return Po(r.data);
}, Lm = ["teacher", "student"], ib = e.enum(Lm), ab = e.object({
  studentId: Yp.pipe(e.int().nonnegative())
}), ob = e.object({
  objectIds: e.array(e.number())
}), ub = e.object({
  teachers: e.string().optional(),
  rooms: e.string().optional()
}), sb = e.object({
  modified: e.number().optional(),
  modifiedBy: cn == null ? void 0 : cn.optional()
}), lb = (t) => e.object({
  currentDateTime: dr(t),
  offsetDateTime: dr(t)
}), Rn = e.object({
  typeId: e.number().int().positive(),
  objectIds: e.array(e.number().int().positive()).min(1)
}), Um = e.object({
  sort: En.optional(),
  sortFieldId: e.number().nonnegative().int().optional()
}), $u = Um.superRefine((t, r) => {
  const a = t.sort === En.enum.ASCFIELD || t.sort === En.enum.DESCFIELD;
  a && t.sortFieldId === void 0 && r.issues.push({
    input: t,
    code: "custom",
    message: "sortFieldId is required when sort is ASCFIELD or DESCFIELD"
  }), !a && t.sortFieldId !== void 0 && r.issues.push({
    input: t,
    code: "custom",
    path: ["sortFieldId"],
    message: "sortFieldId must be omitted unless sort is ASCFIELD or DESCFIELD"
  });
});
var dn = {}, ur = {}, Co;
function Fm() {
  if (Co) return ur;
  Co = 1, ur.byteLength = c, ur.toByteArray = _, ur.fromByteArray = O;
  for (var t = [], r = [], a = typeof Uint8Array < "u" ? Uint8Array : Array, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", d = 0, E = o.length; d < E; ++d)
    t[d] = o[d], r[o.charCodeAt(d)] = d;
  r[45] = 62, r[95] = 63;
  function m(T) {
    var A = T.length;
    if (A % 4 > 0)
      throw new Error("Invalid string. Length must be a multiple of 4");
    var g = T.indexOf("=");
    g === -1 && (g = A);
    var C = g === A ? 0 : 4 - g % 4;
    return [g, C];
  }
  function c(T) {
    var A = m(T), g = A[0], C = A[1];
    return (g + C) * 3 / 4 - C;
  }
  function f(T, A, g) {
    return (A + g) * 3 / 4 - g;
  }
  function _(T) {
    var A, g = m(T), C = g[0], G = g[1], D = new a(f(T, C, G)), F = 0, k = G > 0 ? C - 4 : C, j;
    for (j = 0; j < k; j += 4)
      A = r[T.charCodeAt(j)] << 18 | r[T.charCodeAt(j + 1)] << 12 | r[T.charCodeAt(j + 2)] << 6 | r[T.charCodeAt(j + 3)], D[F++] = A >> 16 & 255, D[F++] = A >> 8 & 255, D[F++] = A & 255;
    return G === 2 && (A = r[T.charCodeAt(j)] << 2 | r[T.charCodeAt(j + 1)] >> 4, D[F++] = A & 255), G === 1 && (A = r[T.charCodeAt(j)] << 10 | r[T.charCodeAt(j + 1)] << 4 | r[T.charCodeAt(j + 2)] >> 2, D[F++] = A >> 8 & 255, D[F++] = A & 255), D;
  }
  function u(T) {
    return t[T >> 18 & 63] + t[T >> 12 & 63] + t[T >> 6 & 63] + t[T & 63];
  }
  function b(T, A, g) {
    for (var C, G = [], D = A; D < g; D += 3)
      C = (T[D] << 16 & 16711680) + (T[D + 1] << 8 & 65280) + (T[D + 2] & 255), G.push(u(C));
    return G.join("");
  }
  function O(T) {
    for (var A, g = T.length, C = g % 3, G = [], D = 16383, F = 0, k = g - C; F < k; F += D)
      G.push(b(T, F, F + D > k ? k : F + D));
    return C === 1 ? (A = T[g - 1], G.push(
      t[A >> 2] + t[A << 4 & 63] + "=="
    )) : C === 2 && (A = (T[g - 2] << 8) + T[g - 1], G.push(
      t[A >> 10] + t[A >> 4 & 63] + t[A << 2 & 63] + "="
    )), G.join("");
  }
  return ur;
}
var yr = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
var No;
function wm() {
  return No || (No = 1, yr.read = function(t, r, a, o, d) {
    var E, m, c = d * 8 - o - 1, f = (1 << c) - 1, _ = f >> 1, u = -7, b = a ? d - 1 : 0, O = a ? -1 : 1, T = t[r + b];
    for (b += O, E = T & (1 << -u) - 1, T >>= -u, u += c; u > 0; E = E * 256 + t[r + b], b += O, u -= 8)
      ;
    for (m = E & (1 << -u) - 1, E >>= -u, u += o; u > 0; m = m * 256 + t[r + b], b += O, u -= 8)
      ;
    if (E === 0)
      E = 1 - _;
    else {
      if (E === f)
        return m ? NaN : (T ? -1 : 1) * (1 / 0);
      m = m + Math.pow(2, o), E = E - _;
    }
    return (T ? -1 : 1) * m * Math.pow(2, E - o);
  }, yr.write = function(t, r, a, o, d, E) {
    var m, c, f, _ = E * 8 - d - 1, u = (1 << _) - 1, b = u >> 1, O = d === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, T = o ? 0 : E - 1, A = o ? 1 : -1, g = r < 0 || r === 0 && 1 / r < 0 ? 1 : 0;
    for (r = Math.abs(r), isNaN(r) || r === 1 / 0 ? (c = isNaN(r) ? 1 : 0, m = u) : (m = Math.floor(Math.log(r) / Math.LN2), r * (f = Math.pow(2, -m)) < 1 && (m--, f *= 2), m + b >= 1 ? r += O / f : r += O * Math.pow(2, 1 - b), r * f >= 2 && (m++, f /= 2), m + b >= u ? (c = 0, m = u) : m + b >= 1 ? (c = (r * f - 1) * Math.pow(2, d), m = m + b) : (c = r * Math.pow(2, b - 1) * Math.pow(2, d), m = 0)); d >= 8; t[a + T] = c & 255, T += A, c /= 256, d -= 8)
      ;
    for (m = m << d | c, _ += d; _ > 0; t[a + T] = m & 255, T += A, m /= 256, _ -= 8)
      ;
    t[a + T - A] |= g * 128;
  }), yr;
}
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var Mo;
function Bm() {
  return Mo || (Mo = 1, (function(t) {
    var r = Fm(), a = wm(), o = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
    t.Buffer = c, t.SlowBuffer = D, t.INSPECT_MAX_BYTES = 50;
    var d = 2147483647;
    t.kMaxLength = d, c.TYPED_ARRAY_SUPPORT = E(), !c.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
      "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
    );
    function E() {
      try {
        var s = new Uint8Array(1), n = { foo: function() {
          return 42;
        } };
        return Object.setPrototypeOf(n, Uint8Array.prototype), Object.setPrototypeOf(s, n), s.foo() === 42;
      } catch {
        return !1;
      }
    }
    Object.defineProperty(c.prototype, "parent", {
      enumerable: !0,
      get: function() {
        if (c.isBuffer(this))
          return this.buffer;
      }
    }), Object.defineProperty(c.prototype, "offset", {
      enumerable: !0,
      get: function() {
        if (c.isBuffer(this))
          return this.byteOffset;
      }
    });
    function m(s) {
      if (s > d)
        throw new RangeError('The value "' + s + '" is invalid for option "size"');
      var n = new Uint8Array(s);
      return Object.setPrototypeOf(n, c.prototype), n;
    }
    function c(s, n, i) {
      if (typeof s == "number") {
        if (typeof n == "string")
          throw new TypeError(
            'The "string" argument must be of type string. Received type number'
          );
        return b(s);
      }
      return f(s, n, i);
    }
    c.poolSize = 8192;
    function f(s, n, i) {
      if (typeof s == "string")
        return O(s, n);
      if (ArrayBuffer.isView(s))
        return A(s);
      if (s == null)
        throw new TypeError(
          "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof s
        );
      if (ce(s, ArrayBuffer) || s && ce(s.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (ce(s, SharedArrayBuffer) || s && ce(s.buffer, SharedArrayBuffer)))
        return g(s, n, i);
      if (typeof s == "number")
        throw new TypeError(
          'The "value" argument must not be of type number. Received type number'
        );
      var l = s.valueOf && s.valueOf();
      if (l != null && l !== s)
        return c.from(l, n, i);
      var p = C(s);
      if (p) return p;
      if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof s[Symbol.toPrimitive] == "function")
        return c.from(
          s[Symbol.toPrimitive]("string"),
          n,
          i
        );
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof s
      );
    }
    c.from = function(s, n, i) {
      return f(s, n, i);
    }, Object.setPrototypeOf(c.prototype, Uint8Array.prototype), Object.setPrototypeOf(c, Uint8Array);
    function _(s) {
      if (typeof s != "number")
        throw new TypeError('"size" argument must be of type number');
      if (s < 0)
        throw new RangeError('The value "' + s + '" is invalid for option "size"');
    }
    function u(s, n, i) {
      return _(s), s <= 0 ? m(s) : n !== void 0 ? typeof i == "string" ? m(s).fill(n, i) : m(s).fill(n) : m(s);
    }
    c.alloc = function(s, n, i) {
      return u(s, n, i);
    };
    function b(s) {
      return _(s), m(s < 0 ? 0 : G(s) | 0);
    }
    c.allocUnsafe = function(s) {
      return b(s);
    }, c.allocUnsafeSlow = function(s) {
      return b(s);
    };
    function O(s, n) {
      if ((typeof n != "string" || n === "") && (n = "utf8"), !c.isEncoding(n))
        throw new TypeError("Unknown encoding: " + n);
      var i = F(s, n) | 0, l = m(i), p = l.write(s, n);
      return p !== i && (l = l.slice(0, p)), l;
    }
    function T(s) {
      for (var n = s.length < 0 ? 0 : G(s.length) | 0, i = m(n), l = 0; l < n; l += 1)
        i[l] = s[l] & 255;
      return i;
    }
    function A(s) {
      if (ce(s, Uint8Array)) {
        var n = new Uint8Array(s);
        return g(n.buffer, n.byteOffset, n.byteLength);
      }
      return T(s);
    }
    function g(s, n, i) {
      if (n < 0 || s.byteLength < n)
        throw new RangeError('"offset" is outside of buffer bounds');
      if (s.byteLength < n + (i || 0))
        throw new RangeError('"length" is outside of buffer bounds');
      var l;
      return n === void 0 && i === void 0 ? l = new Uint8Array(s) : i === void 0 ? l = new Uint8Array(s, n) : l = new Uint8Array(s, n, i), Object.setPrototypeOf(l, c.prototype), l;
    }
    function C(s) {
      if (c.isBuffer(s)) {
        var n = G(s.length) | 0, i = m(n);
        return i.length === 0 || s.copy(i, 0, 0, n), i;
      }
      if (s.length !== void 0)
        return typeof s.length != "number" || Vr(s.length) ? m(0) : T(s);
      if (s.type === "Buffer" && Array.isArray(s.data))
        return T(s.data);
    }
    function G(s) {
      if (s >= d)
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + d.toString(16) + " bytes");
      return s | 0;
    }
    function D(s) {
      return +s != s && (s = 0), c.alloc(+s);
    }
    c.isBuffer = function(n) {
      return n != null && n._isBuffer === !0 && n !== c.prototype;
    }, c.compare = function(n, i) {
      if (ce(n, Uint8Array) && (n = c.from(n, n.offset, n.byteLength)), ce(i, Uint8Array) && (i = c.from(i, i.offset, i.byteLength)), !c.isBuffer(n) || !c.isBuffer(i))
        throw new TypeError(
          'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
        );
      if (n === i) return 0;
      for (var l = n.length, p = i.length, y = 0, S = Math.min(l, p); y < S; ++y)
        if (n[y] !== i[y]) {
          l = n[y], p = i[y];
          break;
        }
      return l < p ? -1 : p < l ? 1 : 0;
    }, c.isEncoding = function(n) {
      switch (String(n).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return !0;
        default:
          return !1;
      }
    }, c.concat = function(n, i) {
      if (!Array.isArray(n))
        throw new TypeError('"list" argument must be an Array of Buffers');
      if (n.length === 0)
        return c.alloc(0);
      var l;
      if (i === void 0)
        for (i = 0, l = 0; l < n.length; ++l)
          i += n[l].length;
      var p = c.allocUnsafe(i), y = 0;
      for (l = 0; l < n.length; ++l) {
        var S = n[l];
        if (ce(S, Uint8Array))
          y + S.length > p.length ? c.from(S).copy(p, y) : Uint8Array.prototype.set.call(
            p,
            S,
            y
          );
        else if (c.isBuffer(S))
          S.copy(p, y);
        else
          throw new TypeError('"list" argument must be an Array of Buffers');
        y += S.length;
      }
      return p;
    };
    function F(s, n) {
      if (c.isBuffer(s))
        return s.length;
      if (ArrayBuffer.isView(s) || ce(s, ArrayBuffer))
        return s.byteLength;
      if (typeof s != "string")
        throw new TypeError(
          'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof s
        );
      var i = s.length, l = arguments.length > 2 && arguments[2] === !0;
      if (!l && i === 0) return 0;
      for (var p = !1; ; )
        switch (n) {
          case "ascii":
          case "latin1":
          case "binary":
            return i;
          case "utf8":
          case "utf-8":
            return Ie(s).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return i * 2;
          case "hex":
            return i >>> 1;
          case "base64":
            return ge(s).length;
          default:
            if (p)
              return l ? -1 : Ie(s).length;
            n = ("" + n).toLowerCase(), p = !0;
        }
    }
    c.byteLength = F;
    function k(s, n, i) {
      var l = !1;
      if ((n === void 0 || n < 0) && (n = 0), n > this.length || ((i === void 0 || i > this.length) && (i = this.length), i <= 0) || (i >>>= 0, n >>>= 0, i <= n))
        return "";
      for (s || (s = "utf8"); ; )
        switch (s) {
          case "hex":
            return w(this, n, i);
          case "utf8":
          case "utf-8":
            return P(this, n, i);
          case "ascii":
            return N(this, n, i);
          case "latin1":
          case "binary":
            return h(this, n, i);
          case "base64":
            return ee(this, n, i);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return B(this, n, i);
          default:
            if (l) throw new TypeError("Unknown encoding: " + s);
            s = (s + "").toLowerCase(), l = !0;
        }
    }
    c.prototype._isBuffer = !0;
    function j(s, n, i) {
      var l = s[n];
      s[n] = s[i], s[i] = l;
    }
    c.prototype.swap16 = function() {
      var n = this.length;
      if (n % 2 !== 0)
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      for (var i = 0; i < n; i += 2)
        j(this, i, i + 1);
      return this;
    }, c.prototype.swap32 = function() {
      var n = this.length;
      if (n % 4 !== 0)
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      for (var i = 0; i < n; i += 4)
        j(this, i, i + 3), j(this, i + 1, i + 2);
      return this;
    }, c.prototype.swap64 = function() {
      var n = this.length;
      if (n % 8 !== 0)
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      for (var i = 0; i < n; i += 8)
        j(this, i, i + 7), j(this, i + 1, i + 6), j(this, i + 2, i + 5), j(this, i + 3, i + 4);
      return this;
    }, c.prototype.toString = function() {
      var n = this.length;
      return n === 0 ? "" : arguments.length === 0 ? P(this, 0, n) : k.apply(this, arguments);
    }, c.prototype.toLocaleString = c.prototype.toString, c.prototype.equals = function(n) {
      if (!c.isBuffer(n)) throw new TypeError("Argument must be a Buffer");
      return this === n ? !0 : c.compare(this, n) === 0;
    }, c.prototype.inspect = function() {
      var n = "", i = t.INSPECT_MAX_BYTES;
      return n = this.toString("hex", 0, i).replace(/(.{2})/g, "$1 ").trim(), this.length > i && (n += " ... "), "<Buffer " + n + ">";
    }, o && (c.prototype[o] = c.prototype.inspect), c.prototype.compare = function(n, i, l, p, y) {
      if (ce(n, Uint8Array) && (n = c.from(n, n.offset, n.byteLength)), !c.isBuffer(n))
        throw new TypeError(
          'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof n
        );
      if (i === void 0 && (i = 0), l === void 0 && (l = n ? n.length : 0), p === void 0 && (p = 0), y === void 0 && (y = this.length), i < 0 || l > n.length || p < 0 || y > this.length)
        throw new RangeError("out of range index");
      if (p >= y && i >= l)
        return 0;
      if (p >= y)
        return -1;
      if (i >= l)
        return 1;
      if (i >>>= 0, l >>>= 0, p >>>= 0, y >>>= 0, this === n) return 0;
      for (var S = y - p, V = l - i, z = Math.min(S, V), x = this.slice(p, y), se = n.slice(i, l), Z = 0; Z < z; ++Z)
        if (x[Z] !== se[Z]) {
          S = x[Z], V = se[Z];
          break;
        }
      return S < V ? -1 : V < S ? 1 : 0;
    };
    function W(s, n, i, l, p) {
      if (s.length === 0) return -1;
      if (typeof i == "string" ? (l = i, i = 0) : i > 2147483647 ? i = 2147483647 : i < -2147483648 && (i = -2147483648), i = +i, Vr(i) && (i = p ? 0 : s.length - 1), i < 0 && (i = s.length + i), i >= s.length) {
        if (p) return -1;
        i = s.length - 1;
      } else if (i < 0)
        if (p) i = 0;
        else return -1;
      if (typeof n == "string" && (n = c.from(n, l)), c.isBuffer(n))
        return n.length === 0 ? -1 : Q(s, n, i, l, p);
      if (typeof n == "number")
        return n = n & 255, typeof Uint8Array.prototype.indexOf == "function" ? p ? Uint8Array.prototype.indexOf.call(s, n, i) : Uint8Array.prototype.lastIndexOf.call(s, n, i) : Q(s, [n], i, l, p);
      throw new TypeError("val must be string, number or Buffer");
    }
    function Q(s, n, i, l, p) {
      var y = 1, S = s.length, V = n.length;
      if (l !== void 0 && (l = String(l).toLowerCase(), l === "ucs2" || l === "ucs-2" || l === "utf16le" || l === "utf-16le")) {
        if (s.length < 2 || n.length < 2)
          return -1;
        y = 2, S /= 2, V /= 2, i /= 2;
      }
      function z(Ei, Ti) {
        return y === 1 ? Ei[Ti] : Ei.readUInt16BE(Ti * y);
      }
      var x;
      if (p) {
        var se = -1;
        for (x = i; x < S; x++)
          if (z(s, x) === z(n, se === -1 ? 0 : x - se)) {
            if (se === -1 && (se = x), x - se + 1 === V) return se * y;
          } else
            se !== -1 && (x -= x - se), se = -1;
      } else
        for (i + V > S && (i = S - V), x = i; x >= 0; x--) {
          for (var Z = !0, Tr = 0; Tr < V; Tr++)
            if (z(s, x + Tr) !== z(n, Tr)) {
              Z = !1;
              break;
            }
          if (Z) return x;
        }
      return -1;
    }
    c.prototype.includes = function(n, i, l) {
      return this.indexOf(n, i, l) !== -1;
    }, c.prototype.indexOf = function(n, i, l) {
      return W(this, n, i, l, !0);
    }, c.prototype.lastIndexOf = function(n, i, l) {
      return W(this, n, i, l, !1);
    };
    function X(s, n, i, l) {
      i = Number(i) || 0;
      var p = s.length - i;
      l ? (l = Number(l), l > p && (l = p)) : l = p;
      var y = n.length;
      l > y / 2 && (l = y / 2);
      for (var S = 0; S < l; ++S) {
        var V = parseInt(n.substr(S * 2, 2), 16);
        if (Vr(V)) return S;
        s[i + S] = V;
      }
      return S;
    }
    function Y(s, n, i, l) {
      return Se(Ie(n, s.length - i), s, i, l);
    }
    function q(s, n, i, l) {
      return Se(Pe(n), s, i, l);
    }
    function M(s, n, i, l) {
      return Se(ge(n), s, i, l);
    }
    function H(s, n, i, l) {
      return Se(ue(n, s.length - i), s, i, l);
    }
    c.prototype.write = function(n, i, l, p) {
      if (i === void 0)
        p = "utf8", l = this.length, i = 0;
      else if (l === void 0 && typeof i == "string")
        p = i, l = this.length, i = 0;
      else if (isFinite(i))
        i = i >>> 0, isFinite(l) ? (l = l >>> 0, p === void 0 && (p = "utf8")) : (p = l, l = void 0);
      else
        throw new Error(
          "Buffer.write(string, encoding, offset[, length]) is no longer supported"
        );
      var y = this.length - i;
      if ((l === void 0 || l > y) && (l = y), n.length > 0 && (l < 0 || i < 0) || i > this.length)
        throw new RangeError("Attempt to write outside buffer bounds");
      p || (p = "utf8");
      for (var S = !1; ; )
        switch (p) {
          case "hex":
            return X(this, n, i, l);
          case "utf8":
          case "utf-8":
            return Y(this, n, i, l);
          case "ascii":
          case "latin1":
          case "binary":
            return q(this, n, i, l);
          case "base64":
            return M(this, n, i, l);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return H(this, n, i, l);
          default:
            if (S) throw new TypeError("Unknown encoding: " + p);
            p = ("" + p).toLowerCase(), S = !0;
        }
    }, c.prototype.toJSON = function() {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function ee(s, n, i) {
      return n === 0 && i === s.length ? r.fromByteArray(s) : r.fromByteArray(s.slice(n, i));
    }
    function P(s, n, i) {
      i = Math.min(s.length, i);
      for (var l = [], p = n; p < i; ) {
        var y = s[p], S = null, V = y > 239 ? 4 : y > 223 ? 3 : y > 191 ? 2 : 1;
        if (p + V <= i) {
          var z, x, se, Z;
          switch (V) {
            case 1:
              y < 128 && (S = y);
              break;
            case 2:
              z = s[p + 1], (z & 192) === 128 && (Z = (y & 31) << 6 | z & 63, Z > 127 && (S = Z));
              break;
            case 3:
              z = s[p + 1], x = s[p + 2], (z & 192) === 128 && (x & 192) === 128 && (Z = (y & 15) << 12 | (z & 63) << 6 | x & 63, Z > 2047 && (Z < 55296 || Z > 57343) && (S = Z));
              break;
            case 4:
              z = s[p + 1], x = s[p + 2], se = s[p + 3], (z & 192) === 128 && (x & 192) === 128 && (se & 192) === 128 && (Z = (y & 15) << 18 | (z & 63) << 12 | (x & 63) << 6 | se & 63, Z > 65535 && Z < 1114112 && (S = Z));
          }
        }
        S === null ? (S = 65533, V = 1) : S > 65535 && (S -= 65536, l.push(S >>> 10 & 1023 | 55296), S = 56320 | S & 1023), l.push(S), p += V;
      }
      return R(l);
    }
    var v = 4096;
    function R(s) {
      var n = s.length;
      if (n <= v)
        return String.fromCharCode.apply(String, s);
      for (var i = "", l = 0; l < n; )
        i += String.fromCharCode.apply(
          String,
          s.slice(l, l += v)
        );
      return i;
    }
    function N(s, n, i) {
      var l = "";
      i = Math.min(s.length, i);
      for (var p = n; p < i; ++p)
        l += String.fromCharCode(s[p] & 127);
      return l;
    }
    function h(s, n, i) {
      var l = "";
      i = Math.min(s.length, i);
      for (var p = n; p < i; ++p)
        l += String.fromCharCode(s[p]);
      return l;
    }
    function w(s, n, i) {
      var l = s.length;
      (!n || n < 0) && (n = 0), (!i || i < 0 || i > l) && (i = l);
      for (var p = "", y = n; y < i; ++y)
        p += is[s[y]];
      return p;
    }
    function B(s, n, i) {
      for (var l = s.slice(n, i), p = "", y = 0; y < l.length - 1; y += 2)
        p += String.fromCharCode(l[y] + l[y + 1] * 256);
      return p;
    }
    c.prototype.slice = function(n, i) {
      var l = this.length;
      n = ~~n, i = i === void 0 ? l : ~~i, n < 0 ? (n += l, n < 0 && (n = 0)) : n > l && (n = l), i < 0 ? (i += l, i < 0 && (i = 0)) : i > l && (i = l), i < n && (i = n);
      var p = this.subarray(n, i);
      return Object.setPrototypeOf(p, c.prototype), p;
    };
    function L(s, n, i) {
      if (s % 1 !== 0 || s < 0) throw new RangeError("offset is not uint");
      if (s + n > i) throw new RangeError("Trying to access beyond buffer length");
    }
    c.prototype.readUintLE = c.prototype.readUIntLE = function(n, i, l) {
      n = n >>> 0, i = i >>> 0, l || L(n, i, this.length);
      for (var p = this[n], y = 1, S = 0; ++S < i && (y *= 256); )
        p += this[n + S] * y;
      return p;
    }, c.prototype.readUintBE = c.prototype.readUIntBE = function(n, i, l) {
      n = n >>> 0, i = i >>> 0, l || L(n, i, this.length);
      for (var p = this[n + --i], y = 1; i > 0 && (y *= 256); )
        p += this[n + --i] * y;
      return p;
    }, c.prototype.readUint8 = c.prototype.readUInt8 = function(n, i) {
      return n = n >>> 0, i || L(n, 1, this.length), this[n];
    }, c.prototype.readUint16LE = c.prototype.readUInt16LE = function(n, i) {
      return n = n >>> 0, i || L(n, 2, this.length), this[n] | this[n + 1] << 8;
    }, c.prototype.readUint16BE = c.prototype.readUInt16BE = function(n, i) {
      return n = n >>> 0, i || L(n, 2, this.length), this[n] << 8 | this[n + 1];
    }, c.prototype.readUint32LE = c.prototype.readUInt32LE = function(n, i) {
      return n = n >>> 0, i || L(n, 4, this.length), (this[n] | this[n + 1] << 8 | this[n + 2] << 16) + this[n + 3] * 16777216;
    }, c.prototype.readUint32BE = c.prototype.readUInt32BE = function(n, i) {
      return n = n >>> 0, i || L(n, 4, this.length), this[n] * 16777216 + (this[n + 1] << 16 | this[n + 2] << 8 | this[n + 3]);
    }, c.prototype.readIntLE = function(n, i, l) {
      n = n >>> 0, i = i >>> 0, l || L(n, i, this.length);
      for (var p = this[n], y = 1, S = 0; ++S < i && (y *= 256); )
        p += this[n + S] * y;
      return y *= 128, p >= y && (p -= Math.pow(2, 8 * i)), p;
    }, c.prototype.readIntBE = function(n, i, l) {
      n = n >>> 0, i = i >>> 0, l || L(n, i, this.length);
      for (var p = i, y = 1, S = this[n + --p]; p > 0 && (y *= 256); )
        S += this[n + --p] * y;
      return y *= 128, S >= y && (S -= Math.pow(2, 8 * i)), S;
    }, c.prototype.readInt8 = function(n, i) {
      return n = n >>> 0, i || L(n, 1, this.length), this[n] & 128 ? (255 - this[n] + 1) * -1 : this[n];
    }, c.prototype.readInt16LE = function(n, i) {
      n = n >>> 0, i || L(n, 2, this.length);
      var l = this[n] | this[n + 1] << 8;
      return l & 32768 ? l | 4294901760 : l;
    }, c.prototype.readInt16BE = function(n, i) {
      n = n >>> 0, i || L(n, 2, this.length);
      var l = this[n + 1] | this[n] << 8;
      return l & 32768 ? l | 4294901760 : l;
    }, c.prototype.readInt32LE = function(n, i) {
      return n = n >>> 0, i || L(n, 4, this.length), this[n] | this[n + 1] << 8 | this[n + 2] << 16 | this[n + 3] << 24;
    }, c.prototype.readInt32BE = function(n, i) {
      return n = n >>> 0, i || L(n, 4, this.length), this[n] << 24 | this[n + 1] << 16 | this[n + 2] << 8 | this[n + 3];
    }, c.prototype.readFloatLE = function(n, i) {
      return n = n >>> 0, i || L(n, 4, this.length), a.read(this, n, !0, 23, 4);
    }, c.prototype.readFloatBE = function(n, i) {
      return n = n >>> 0, i || L(n, 4, this.length), a.read(this, n, !1, 23, 4);
    }, c.prototype.readDoubleLE = function(n, i) {
      return n = n >>> 0, i || L(n, 8, this.length), a.read(this, n, !0, 52, 8);
    }, c.prototype.readDoubleBE = function(n, i) {
      return n = n >>> 0, i || L(n, 8, this.length), a.read(this, n, !1, 52, 8);
    };
    function $(s, n, i, l, p, y) {
      if (!c.isBuffer(s)) throw new TypeError('"buffer" argument must be a Buffer instance');
      if (n > p || n < y) throw new RangeError('"value" argument is out of bounds');
      if (i + l > s.length) throw new RangeError("Index out of range");
    }
    c.prototype.writeUintLE = c.prototype.writeUIntLE = function(n, i, l, p) {
      if (n = +n, i = i >>> 0, l = l >>> 0, !p) {
        var y = Math.pow(2, 8 * l) - 1;
        $(this, n, i, l, y, 0);
      }
      var S = 1, V = 0;
      for (this[i] = n & 255; ++V < l && (S *= 256); )
        this[i + V] = n / S & 255;
      return i + l;
    }, c.prototype.writeUintBE = c.prototype.writeUIntBE = function(n, i, l, p) {
      if (n = +n, i = i >>> 0, l = l >>> 0, !p) {
        var y = Math.pow(2, 8 * l) - 1;
        $(this, n, i, l, y, 0);
      }
      var S = l - 1, V = 1;
      for (this[i + S] = n & 255; --S >= 0 && (V *= 256); )
        this[i + S] = n / V & 255;
      return i + l;
    }, c.prototype.writeUint8 = c.prototype.writeUInt8 = function(n, i, l) {
      return n = +n, i = i >>> 0, l || $(this, n, i, 1, 255, 0), this[i] = n & 255, i + 1;
    }, c.prototype.writeUint16LE = c.prototype.writeUInt16LE = function(n, i, l) {
      return n = +n, i = i >>> 0, l || $(this, n, i, 2, 65535, 0), this[i] = n & 255, this[i + 1] = n >>> 8, i + 2;
    }, c.prototype.writeUint16BE = c.prototype.writeUInt16BE = function(n, i, l) {
      return n = +n, i = i >>> 0, l || $(this, n, i, 2, 65535, 0), this[i] = n >>> 8, this[i + 1] = n & 255, i + 2;
    }, c.prototype.writeUint32LE = c.prototype.writeUInt32LE = function(n, i, l) {
      return n = +n, i = i >>> 0, l || $(this, n, i, 4, 4294967295, 0), this[i + 3] = n >>> 24, this[i + 2] = n >>> 16, this[i + 1] = n >>> 8, this[i] = n & 255, i + 4;
    }, c.prototype.writeUint32BE = c.prototype.writeUInt32BE = function(n, i, l) {
      return n = +n, i = i >>> 0, l || $(this, n, i, 4, 4294967295, 0), this[i] = n >>> 24, this[i + 1] = n >>> 16, this[i + 2] = n >>> 8, this[i + 3] = n & 255, i + 4;
    }, c.prototype.writeIntLE = function(n, i, l, p) {
      if (n = +n, i = i >>> 0, !p) {
        var y = Math.pow(2, 8 * l - 1);
        $(this, n, i, l, y - 1, -y);
      }
      var S = 0, V = 1, z = 0;
      for (this[i] = n & 255; ++S < l && (V *= 256); )
        n < 0 && z === 0 && this[i + S - 1] !== 0 && (z = 1), this[i + S] = (n / V >> 0) - z & 255;
      return i + l;
    }, c.prototype.writeIntBE = function(n, i, l, p) {
      if (n = +n, i = i >>> 0, !p) {
        var y = Math.pow(2, 8 * l - 1);
        $(this, n, i, l, y - 1, -y);
      }
      var S = l - 1, V = 1, z = 0;
      for (this[i + S] = n & 255; --S >= 0 && (V *= 256); )
        n < 0 && z === 0 && this[i + S + 1] !== 0 && (z = 1), this[i + S] = (n / V >> 0) - z & 255;
      return i + l;
    }, c.prototype.writeInt8 = function(n, i, l) {
      return n = +n, i = i >>> 0, l || $(this, n, i, 1, 127, -128), n < 0 && (n = 255 + n + 1), this[i] = n & 255, i + 1;
    }, c.prototype.writeInt16LE = function(n, i, l) {
      return n = +n, i = i >>> 0, l || $(this, n, i, 2, 32767, -32768), this[i] = n & 255, this[i + 1] = n >>> 8, i + 2;
    }, c.prototype.writeInt16BE = function(n, i, l) {
      return n = +n, i = i >>> 0, l || $(this, n, i, 2, 32767, -32768), this[i] = n >>> 8, this[i + 1] = n & 255, i + 2;
    }, c.prototype.writeInt32LE = function(n, i, l) {
      return n = +n, i = i >>> 0, l || $(this, n, i, 4, 2147483647, -2147483648), this[i] = n & 255, this[i + 1] = n >>> 8, this[i + 2] = n >>> 16, this[i + 3] = n >>> 24, i + 4;
    }, c.prototype.writeInt32BE = function(n, i, l) {
      return n = +n, i = i >>> 0, l || $(this, n, i, 4, 2147483647, -2147483648), n < 0 && (n = 4294967295 + n + 1), this[i] = n >>> 24, this[i + 1] = n >>> 16, this[i + 2] = n >>> 8, this[i + 3] = n & 255, i + 4;
    };
    function J(s, n, i, l, p, y) {
      if (i + l > s.length) throw new RangeError("Index out of range");
      if (i < 0) throw new RangeError("Index out of range");
    }
    function te(s, n, i, l, p) {
      return n = +n, i = i >>> 0, p || J(s, n, i, 4), a.write(s, n, i, l, 23, 4), i + 4;
    }
    c.prototype.writeFloatLE = function(n, i, l) {
      return te(this, n, i, !0, l);
    }, c.prototype.writeFloatBE = function(n, i, l) {
      return te(this, n, i, !1, l);
    };
    function le(s, n, i, l, p) {
      return n = +n, i = i >>> 0, p || J(s, n, i, 8), a.write(s, n, i, l, 52, 8), i + 8;
    }
    c.prototype.writeDoubleLE = function(n, i, l) {
      return le(this, n, i, !0, l);
    }, c.prototype.writeDoubleBE = function(n, i, l) {
      return le(this, n, i, !1, l);
    }, c.prototype.copy = function(n, i, l, p) {
      if (!c.isBuffer(n)) throw new TypeError("argument should be a Buffer");
      if (l || (l = 0), !p && p !== 0 && (p = this.length), i >= n.length && (i = n.length), i || (i = 0), p > 0 && p < l && (p = l), p === l || n.length === 0 || this.length === 0) return 0;
      if (i < 0)
        throw new RangeError("targetStart out of bounds");
      if (l < 0 || l >= this.length) throw new RangeError("Index out of range");
      if (p < 0) throw new RangeError("sourceEnd out of bounds");
      p > this.length && (p = this.length), n.length - i < p - l && (p = n.length - i + l);
      var y = p - l;
      return this === n && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(i, l, p) : Uint8Array.prototype.set.call(
        n,
        this.subarray(l, p),
        i
      ), y;
    }, c.prototype.fill = function(n, i, l, p) {
      if (typeof n == "string") {
        if (typeof i == "string" ? (p = i, i = 0, l = this.length) : typeof l == "string" && (p = l, l = this.length), p !== void 0 && typeof p != "string")
          throw new TypeError("encoding must be a string");
        if (typeof p == "string" && !c.isEncoding(p))
          throw new TypeError("Unknown encoding: " + p);
        if (n.length === 1) {
          var y = n.charCodeAt(0);
          (p === "utf8" && y < 128 || p === "latin1") && (n = y);
        }
      } else typeof n == "number" ? n = n & 255 : typeof n == "boolean" && (n = Number(n));
      if (i < 0 || this.length < i || this.length < l)
        throw new RangeError("Out of range index");
      if (l <= i)
        return this;
      i = i >>> 0, l = l === void 0 ? this.length : l >>> 0, n || (n = 0);
      var S;
      if (typeof n == "number")
        for (S = i; S < l; ++S)
          this[S] = n;
      else {
        var V = c.isBuffer(n) ? n : c.from(n, p), z = V.length;
        if (z === 0)
          throw new TypeError('The value "' + n + '" is invalid for argument "value"');
        for (S = 0; S < l - i; ++S)
          this[S + i] = V[S % z];
      }
      return this;
    };
    var Ge = /[^+/0-9A-Za-z-_]/g;
    function ve(s) {
      if (s = s.split("=")[0], s = s.trim().replace(Ge, ""), s.length < 2) return "";
      for (; s.length % 4 !== 0; )
        s = s + "=";
      return s;
    }
    function Ie(s, n) {
      n = n || 1 / 0;
      for (var i, l = s.length, p = null, y = [], S = 0; S < l; ++S) {
        if (i = s.charCodeAt(S), i > 55295 && i < 57344) {
          if (!p) {
            if (i > 56319) {
              (n -= 3) > -1 && y.push(239, 191, 189);
              continue;
            } else if (S + 1 === l) {
              (n -= 3) > -1 && y.push(239, 191, 189);
              continue;
            }
            p = i;
            continue;
          }
          if (i < 56320) {
            (n -= 3) > -1 && y.push(239, 191, 189), p = i;
            continue;
          }
          i = (p - 55296 << 10 | i - 56320) + 65536;
        } else p && (n -= 3) > -1 && y.push(239, 191, 189);
        if (p = null, i < 128) {
          if ((n -= 1) < 0) break;
          y.push(i);
        } else if (i < 2048) {
          if ((n -= 2) < 0) break;
          y.push(
            i >> 6 | 192,
            i & 63 | 128
          );
        } else if (i < 65536) {
          if ((n -= 3) < 0) break;
          y.push(
            i >> 12 | 224,
            i >> 6 & 63 | 128,
            i & 63 | 128
          );
        } else if (i < 1114112) {
          if ((n -= 4) < 0) break;
          y.push(
            i >> 18 | 240,
            i >> 12 & 63 | 128,
            i >> 6 & 63 | 128,
            i & 63 | 128
          );
        } else
          throw new Error("Invalid code point");
      }
      return y;
    }
    function Pe(s) {
      for (var n = [], i = 0; i < s.length; ++i)
        n.push(s.charCodeAt(i) & 255);
      return n;
    }
    function ue(s, n) {
      for (var i, l, p, y = [], S = 0; S < s.length && !((n -= 2) < 0); ++S)
        i = s.charCodeAt(S), l = i >> 8, p = i % 256, y.push(p), y.push(l);
      return y;
    }
    function ge(s) {
      return r.toByteArray(ve(s));
    }
    function Se(s, n, i, l) {
      for (var p = 0; p < l && !(p + i >= n.length || p >= s.length); ++p)
        n[p + i] = s[p];
      return p;
    }
    function ce(s, n) {
      return s instanceof n || s != null && s.constructor != null && s.constructor.name != null && s.constructor.name === n.name;
    }
    function Vr(s) {
      return s !== s;
    }
    var is = (function() {
      for (var s = "0123456789abcdef", n = new Array(256), i = 0; i < 16; ++i)
        for (var l = i * 16, p = 0; p < 16; ++p)
          n[l + p] = s[i] + s[p];
      return n;
    })();
  })(dn)), dn;
}
var Gm = Bm();
const cb = e.object({
  id: e.number(),
  fields: e.array(mr),
  members: e.array(Un)
}), db = e.object({
  id: e.number(),
  begin: e.number().optional(),
  end: e.number().optional(),
  objects: e.array(
    e.object({
      objectId: e.number(),
      typeId: e.number()
    })
  ),
  fields: e.array(
    e.object({
      fieldId: e.number(),
      values: e.array(e.string())
    })
  )
}), At = e.object({
  id: e.string(),
  name: e.string(),
  value: e.number().optional(),
  cost: e.number().optional()
}), Vu = e.object({
  impossible: e.number(),
  impossibleInCurrent: e.number(),
  notEnoughSpaceOnPossible: e.number()
}), $m = Object.keys(Vu.shape), Vm = e.enum($m), km = At.extend({
  id: e.literal("nofFailedDecisions"),
  kpis: e.array(
    At.extend({
      id: Vm
    })
  )
}), ku = e.object({
  nofAssignedDecisions: e.number(),
  nofCompleteStudents: e.number(),
  nofIncompleteStudents: e.number(),
  nofFailedDecisions: e.number()
}), qm = Object.keys(ku.shape), Hm = e.enum(qm), zm = At.extend({
  id: e.literal("solutionAnalysis"),
  kpis: e.array(
    e.union([
      km,
      At.extend({
        id: Hm
      })
    ])
  )
}), qu = e.object({
  nofStudents: e.number(),
  nofStudentSetGroups: e.number(),
  nofLockedDecisions: e.number(),
  nofNonLockedDecisions: e.number(),
  nofLockedStudents: e.number()
}), Ym = Object.keys(qu.shape), Wm = e.enum(Ym), xm = At.extend({
  id: e.literal("problemAnalysis"),
  kpis: e.array(
    At.extend({
      id: Wm
    })
  )
}), Km = e.discriminatedUnion("id", [
  zm,
  xm
]), Zm = e.object({
  userId: e.string(),
  timestamp: e.number()
}), pb = e.object({
  outputPath: e.string(),
  jobId: e.string(),
  internalJobId: e.string(),
  jobType: e.string(),
  status: e.string()
});
var Hu = /* @__PURE__ */ ((t) => (t[t.Success = 0] = "Success", t[t.Impossible = 1] = "Impossible", t[t.ImpossibleInCurrent = 2] = "ImpossibleInCurrent", t[t.NotEnoughSpaceOnPossible = 3] = "NotEnoughSpaceOnPossible", t))(Hu || {});
const Jm = e.enum(Hu), Xm = e.looseObject({
  studentId: e.number(),
  statuses: e.array(Jm)
}), Qm = e.looseObject({
  students: e.array(e.number()),
  studentSetGroupId: e.number()
}), ef = e.object({
  kpis: e.array(Km),
  studentStatuses: e.array(Xm),
  solution: e.looseObject({
    assignments: e.array(Qm)
  })
}), zu = e.looseObject({
  errorCode: e.number(),
  message: e.string()
}), mb = e.discriminatedUnion("exit_status", [
  e.object({
    build: e.string(),
    dataVersion: e.number(),
    exit_status: e.literal("success"),
    id: e.string(),
    meta: Zm,
    result: ef
  }),
  e.object({
    build: e.string(),
    dataVersion: e.number(),
    exit_status: e.literal("error"),
    id: e.string(),
    error: zu
  })
]), pn = (t) => Gm.Buffer.isBuffer(t) || globalThis.Buffer.isBuffer(t), Yu = e.unknown().superRefine((t, r) => {
  pn(t) || t && typeof t == "object" && "buffer" in t && pn(t.buffer) || r.issues.push({
    code: "custom",
    message: "Invalid Buffer type",
    input: t
  });
}).transform((t) => t && typeof t == "object" && "buffer" in t && pn(t.buffer) ? t.buffer : t), tf = [
  "corrupted",
  "init_failed",
  "initializing",
  "unreceived",
  "failed",
  "pending",
  "completed",
  "allocating",
  "allocation_failed",
  "allocated"
], I = e.enum(tf), fb = {
  [I.enum.corrupted]: ["corrupted"],
  [I.enum.init_failed]: [
    "init_failed",
    "initializing",
    "unreceived",
    "failed",
    "pending",
    "completed",
    "allocating",
    "allocation_failed",
    "allocated"
  ],
  [I.enum.initializing]: [
    "initializing",
    "unreceived",
    "failed",
    "pending",
    "completed",
    "allocating",
    "allocation_failed",
    "allocated"
  ],
  [I.enum.unreceived]: [
    "unreceived",
    "failed",
    "pending",
    "completed",
    "allocating",
    "allocation_failed",
    "allocated"
  ],
  [I.enum.failed]: [
    "failed",
    "pending",
    "completed",
    "allocating",
    "allocation_failed",
    "allocated"
  ],
  [I.enum.pending]: [
    "pending",
    "completed",
    "allocating",
    "allocation_failed",
    "allocated"
  ],
  [I.enum.completed]: [
    "completed",
    "allocating",
    "allocation_failed",
    "allocated"
  ],
  [I.enum.allocating]: [
    "allocating",
    "allocation_failed",
    "allocated"
  ],
  [I.enum.allocation_failed]: [
    "allocation_failed",
    "allocated"
  ],
  [I.enum.allocated]: ["allocated"]
}, rf = e.object({
  ...ku.shape,
  ...qu.shape,
  ...Vu.shape
}), nf = e.object({
  time: e.string().optional(),
  allocationTime: _t,
  userId: e.string(),
  logId: e.string().optional()
}), af = e.object({
  time: e.string().optional(),
  allocationTime: _t,
  userId: e.string(),
  logId: e.string().optional(),
  failedGroups: Jn
}), $e = {
  conflicts: "noConflicts",
  fill: "fillGroupsEvenly",
  distribution: "useAllocationSettings",
  optimizeForStudentPreferences: !0
}, mn = {
  conflicts: [$e.conflicts],
  fill: [$e.fill],
  distribution: [$e.distribution]
}, Cr = e.object({
  conflicts: e.enum(mn.conflicts).optional().default($e.conflicts),
  fill: e.enum(mn.fill).optional().default($e.fill),
  distribution: e.enum(mn.distribution).optional().default($e.distribution),
  optimizeForStudentPreferences: e.boolean().optional().default($e.optimizeForStudentPreferences)
}), ri = e.object({
  userId: e.string(),
  startTime: e.string().optional(),
  jobId: e.string(),
  createdAt: _t,
  updatedAt: _t
}), Ur = e.object({
  userId: e.string(),
  startTime: e.string().optional(),
  jobId: e.string(),
  inputUrl: e.string(),
  issues: e.number(),
  settings: Cr.optional().default($e),
  selection: e.object({
    studentSetGroups: e.number(),
    totalStudents: e.number(),
    incompleteStudents: e.number(),
    courses: e.array(Kp)
  }),
  inputData: Yu,
  createdAt: _t,
  updatedAt: _t
}), ni = ri.extend({
  status: e.literal(I.enum.initializing)
}), ii = ri.extend({
  status: e.literal(I.enum.init_failed),
  error: e.unknown().optional()
}), ai = Ur.extend({
  status: e.literal(I.enum.pending)
}), ht = Ur.extend({
  status: e.literal(I.enum.completed),
  outputData: Yu,
  proposalResult: rf,
  outputUrl: e.string()
}), oi = Ur.extend({
  status: e.literal(I.enum.unreceived),
  error: e.unknown().optional()
}), ui = Ur.extend({
  status: e.literal(I.enum.failed),
  error: zu
}), si = ht.extend({
  status: e.literal(I.enum.allocating)
}), li = ht.extend({
  status: e.literal(I.enum.allocation_failed),
  error: e.unknown().optional()
}), ci = ht.extend({
  allocationResult: af,
  status: e.literal(I.enum.allocated)
}), di = ri.extend({
  status: e.literal(I.enum.corrupted),
  error: e.unknown().optional()
}).loose(), pi = (t) => t, Re = [
  "outputData",
  "inputData",
  "allocationResult"
], Be = {
  username: e.object({
    creator: e.string()
  })
}, of = pi({
  [I.enum.corrupted]: Oe(
    di,
    Re
  ).extend(Be).loose(),
  [I.enum.allocated]: Oe(
    ci,
    Re
  ).extend({
    username: e.object({
      creator: e.string(),
      allocator: e.string()
    }),
    allocationResult: nf
  }),
  [I.enum.allocation_failed]: Oe(
    li,
    Re
  ).extend(Be),
  [I.enum.allocating]: Oe(
    si,
    Re
  ).extend(Be),
  [I.enum.completed]: Oe(
    ht,
    Re
  ).extend(Be),
  [I.enum.pending]: Oe(
    ai,
    Re
  ).extend(Be),
  [I.enum.unreceived]: Oe(
    oi,
    Re
  ).extend(Be),
  [I.enum.failed]: Oe(
    ui,
    Re
  ).extend(Be),
  [I.enum.init_failed]: Oe(
    ii,
    Re
  ).extend(Be),
  [I.enum.initializing]: Oe(
    ni,
    Re
  ).extend(Be)
}), uf = e.discriminatedUnion(
  "status",
  Object.values(of)
), sf = pi({
  [I.enum.corrupted]: di,
  [I.enum.allocated]: ci,
  [I.enum.allocation_failed]: li,
  [I.enum.allocating]: si,
  [I.enum.completed]: ht,
  [I.enum.pending]: ai,
  [I.enum.unreceived]: oi,
  [I.enum.failed]: ui,
  [I.enum.init_failed]: ii,
  [I.enum.initializing]: ni
}), Eb = e.discriminatedUnion(
  "status",
  Object.values(sf)
), lf = pi({
  [I.enum.corrupted]: di.partial().extend({
    jobId: e.string(),
    status: e.literal(I.enum.corrupted)
  }),
  [I.enum.allocated]: ci.omit({ settings: !0 }).partial().extend({
    jobId: e.string(),
    status: e.literal(I.enum.allocated)
  }),
  [I.enum.allocation_failed]: li.omit({
    settings: !0
  }).partial().extend({
    jobId: e.string(),
    status: e.literal(I.enum.allocation_failed)
  }),
  [I.enum.allocating]: si.omit({ settings: !0 }).partial().extend({
    jobId: e.string(),
    status: e.literal(I.enum.allocating)
  }),
  [I.enum.completed]: ht.omit({ settings: !0 }).partial().extend({
    jobId: e.string(),
    status: e.literal(I.enum.completed)
  }),
  [I.enum.pending]: ai.omit({ settings: !0 }).partial().extend({
    jobId: e.string(),
    status: e.literal(I.enum.pending),
    settings: Cr.optional()
  }),
  [I.enum.unreceived]: oi.partial().extend({
    jobId: e.string(),
    status: e.literal(I.enum.unreceived)
  }),
  [I.enum.failed]: ui.partial().extend({
    jobId: e.string(),
    status: e.literal(I.enum.failed)
  }),
  [I.enum.initializing]: ni.partial().extend({
    jobId: e.string(),
    status: e.literal(I.enum.initializing)
  }),
  [I.enum.init_failed]: ii.partial().extend({
    jobId: e.string(),
    status: e.literal(I.enum.init_failed)
  })
}), Tb = Hn(
  e.discriminatedUnion(
    "status",
    Object.values(lf)
  )
), bb = e.object({
  jobId: e.string(),
  allocationResults: e.array(Jn)
}), gb = e.object({
  jobId: e.string(),
  date: be
}), yb = e.object({
  jobs: e.array(uf),
  total: e.number()
}), cf = e.object({
  id: e.number(),
  course: e.string(),
  courseTitle: e.string(),
  activity: e.string(),
  reason: e.string(),
  studentId: e.string(),
  activityId: e.string(),
  studentValues: e.array(e.string()),
  link: e.string()
}), df = e.object({
  rows: e.array(cf),
  studentColumns: e.array(e.string())
}), _b = e.object({
  content: df,
  startTime: e.string()
}), pf = e.object({
  key: e.string(),
  course: e.string(),
  activityType: e.string(),
  group: e.string(),
  student: e.string(),
  issueType: e.string(),
  manageStudentLink: e.string(),
  activityTypeId: e.number().optional(),
  logId: e.string().optional()
}), Ab = e.object({
  total: e.number(),
  data: e.array(pf)
}), mf = (t) => e.object({
  data: t,
  status: e.number(),
  message: e.string()
}), Sb = mf(e.unknown()), Ob = e.object({
  objectIds: e.array(e.number().nonnegative().int()),
  useCache: e.boolean()
}), Wu = e.object({
  ids: e.array(e.number().nonnegative().int()).optional(),
  typeId: e.number().nonnegative().int().optional().or(e.array(e.number().nonnegative().int())),
  useCache: e.boolean().optional(),
  limit: e.number().nonnegative().int().optional(),
  pageSize: e.number().nonnegative().int().optional(),
  page: e.number().nonnegative().int().optional(),
  fields: e.array(e.string().or(e.number().nonnegative().int())).optional(),
  relations: Rn.optional(),
  members: Rn.optional(),
  text: e.string().optional(),
  category: e.array(Mu).optional()
}), ff = Wu.and($u).superRefine(
  (t, r) => {
    var a;
    !((a = t.ids) != null && a.length) && !t.limit && !t.pageSize && r.issues.push({
      input: t,
      code: "custom",
      path: ["limit"],
      message: "Limit or pageSize required when no ids are specified"
    }), t.limit && t.pageSize && r.issues.push({
      input: t,
      code: "custom",
      path: ["limit"],
      message: "Do not set both limit and pageSize"
    });
  }
);
var Ef = /* @__PURE__ */ ((t) => (t.related = "related", t.all = "all", t))(Ef || {});
const Tf = e.discriminatedUnion("filterMode", [
  e.object({
    filterMode: e.literal(
      "related"
      /* related */
    ),
    courseIds: e.array(e.number().int().positive()).min(1)
  }),
  e.object({
    filterMode: e.literal(
      "all"
      /* all */
    )
  })
]), Rb = ff.and(Tf), bf = e.object({
  exactSearchFields: e.array(Mu).optional(),
  generalSearchFieldIds: e.array(Yn).optional(),
  searchText: e.string().optional()
}), gf = [
  "only_selected",
  "include_linked",
  "all"
], hn = e.enum(gf), xu = e.object({
  fields: bf.optional(),
  idsToFilter: e.array(Yn).optional(),
  relations: Rn.optional(),
  filterCompleteStudents: e.boolean().optional(),
  filterRegistrationPeriod: e.array(Wn).optional(),
  filterIssues: e.array(Ou).optional(),
  filterSelectionMode: hn.optional(),
  limit: e.number().nonnegative().int().optional(),
  pageSize: e.number().nonnegative().int().optional(),
  page: e.number().nonnegative().int().optional()
}), yf = xu.pick({
  fields: !0,
  relations: !0,
  idsToFilter: !0,
  filterCompleteStudents: !0
}), Fr = xu.and($u), hb = Fr.superRefine(
  (t, r) => {
    !t.limit && !t.pageSize && r.issues.push({
      input: t,
      code: "custom",
      path: ["limit"],
      message: "Limit or pageSize required"
    }), t.limit && t.pageSize && r.issues.push({
      input: t,
      code: "custom",
      path: ["limit"],
      message: "Do not set both limit and pageSize"
    });
  }
), vb = e.object({
  objects: e.array(me),
  totalFilteredObjects: e.number()
}), Ib = e.array(
  e.object({ id: e.number(), fields: e.array(mr) })
), _f = ["partial", "none"], mi = e.enum(_f), Pb = e.object({
  studentInfo: Lr,
  conflictControl: mi,
  overrides: Zn.optional(),
  updateWaitlist: e.boolean().optional()
}), Cb = e.object({
  jobId: e.string(),
  conflictControl: mi,
  overrides: Zn.optional()
}), Nb = e.object({
  studentInfo: Lr
}), Mb = e.object({ jobId: e.string() }), Db = e.object({
  studentId: e.number(),
  newObjectId: e.number()
}), jb = e.object({
  studentId: e.number(),
  newObjectId: e.number(),
  conflictControl: mi,
  overrides: Zn.optional()
}), Lb = e.object({
  groups: e.partialRecord(e.string(), ti)
}), Ub = e.object({
  summary: e.record(Yo, e.number())
}), Fb = e.looseObject({
  results: e.array(
    e.object({
      status: e.number(),
      message: e.object({
        status: e.number(),
        message: e.string(),
        errorCode: e.number().optional()
      }).or(e.string()),
      memberObjectId: e.number().optional(),
      groupObjectId: e.number().optional(),
      operation: e.enum(["add", "remove"])
    })
  )
}), Af = e.union([e.literal("asc"), e.literal("desc")]), Sf = e.array(e.tuple([e.string(), Af])), wb = e.object({
  skip: e.string().optional(),
  limit: e.string().optional(),
  jobId: e.string().optional(),
  sort: Sf.optional()
}), Bb = e.object({
  force: e.boolean().optional()
}), Gb = e.union([
  e.object({
    loadCoursesProps: Fr,
    settings: Cr
  }).strict(),
  e.object({
    groupIds: e.array(e.number()),
    settings: Cr
  }).strict()
]), $b = e.object({
  jobId: e.string(),
  csv: e.boolean().optional()
}), Vb = e.object({
  jobId: e.string(),
  page: e.number(),
  pageSize: e.number()
}).required(), Of = e.object({
  reloadReservations: e.boolean().optional(),
  groupIds: e.array(e.number()).optional(),
  loadCoursesProps: yf
}), Rf = e.object({
  reloadReservations: e.boolean().optional(),
  groupIds: e.array(e.number()).optional(),
  ids: e.array(e.number())
}), hf = e.object({
  reloadReservations: e.boolean().optional(),
  groupIds: e.array(e.number())
}), kb = e.union([
  Rf,
  Of,
  hf
]), qb = e.object({
  groups: e.record(e.string(), vu.optional()),
  coursesToUpdate: Vp(Ru.optional()),
  reservations: e.array(Fn),
  activities: e.record(e.string(), hu.optional()),
  studentIds: e.array(e.number())
}), Hb = e.union([
  e.object({ loadCoursesProps: Fr }).strict(),
  e.object({
    groupIds: e.array(e.number()),
    filterSelectionMode: hn.optional()
  }).strict(),
  e.object({
    ids: e.array(e.number()),
    filterSelectionMode: hn.optional()
  }).strict()
]), vf = e.object({
  courses: e.record(e.string(), Ru.optional()),
  totalFilteredCourses: e.number().nonnegative().int(),
  studentsRelated: e.record(e.string(), Xp.optional()),
  groupsRelated: e.record(e.string(), vu.optional()),
  selectedIncompleteStudents: e.number().nonnegative().int(),
  activities: e.record(e.string(), hu.optional())
}), If = vf.omit({
  studentsRelated: !0
}).extend({
  students: e.number()
}), zb = If.omit({
  selectedIncompleteStudents: !0
}), Yb = Wu.omit({
  useCache: !0,
  typeId: !0
}).extend({
  ...Du.shape,
  groupIds: e.array(e.number()).optional(),
  numberOfStudents: e.number().int().nonnegative().optional(),
  filterCompleteStudents: e.boolean().optional(),
  programIds: e.array(e.number()).optional(),
  allocationStatus: e.object({
    values: e.array(Sm),
    selectedGroupId: e.number()
  }).optional()
});
var Ku = /* @__PURE__ */ ((t) => (t.buttonClick = "button_click", t.pageView = "page_view", t))(Ku || {});
const Wb = e.object({
  event: e.enum(Ku),
  properties: e.record(e.string(), e.union([e.string(), e.number(), e.boolean()])).optional()
}), Pf = e.object({
  groupId: e.number(),
  linkedIds: e.array(e.number())
}), xb = e.object({
  linked: e.array(Pf)
}), Kb = e.object({
  loadCoursesProps: Fr
}), wr = e.number(), Br = e.number(), Zu = e.string(), Cf = e.string(), Nf = e.object({
  sequence: e.number(),
  groupId: Br
}), Mf = Nf.extend({
  studentId: wr,
  trigger: Zu,
  userId: Cf
}), Zb = Mf.extend({
  position: e.number()
}), Jb = e.object({
  studentId: wr,
  groupId: Br,
  trigger: Zu
}), Xb = e.object({
  studentId: wr,
  groupId: Br
}), Qb = e.object({
  studentId: wr,
  groupId: Br
}), eg = e.object({ studentId: e.string() }), Df = e.object({
  evaluatedGroups: e.number(),
  allocations: e.number(),
  allocatedGroups: e.number(),
  allocatedStudents: e.number()
}), Ju = {
  EVALUATE_WAITLIST: "eval-waitlist"
}, jf = e.enum(Ju), tg = e.object({
  jobName: jf
}), rg = e.string(), sr = {
  POPULATE_CACHE: "Registration - Populate Cache",
  AUTO_ALLOCATE: "Auto Allocate",
  AUTO_ALLOCATE_DAILY: "Auto Allocate Daily",
  ...Ju
}, Er = e.enum(
  Object.values(sr)
), Lf = [
  "uninitialized",
  "pending",
  "completed",
  "failed"
], Xu = e.enum(Lf), Uf = e.union([
  Xu,
  e.literal("timeout"),
  e.undefined()
]), He = e.object({
  name: Er,
  jobId: e.string(),
  lastRunAt: e.number(),
  lastFinishedAt: e.number().nullable().optional(),
  status: Xu
}), Qu = e.object({
  status: e.number(),
  name: e.string(),
  message: e.string()
}), es = {
  [sr.EVALUATE_WAITLIST]: e.object({
    stats: Df
  }).optional().default({
    stats: {
      evaluatedGroups: 0,
      allocations: 0,
      allocatedGroups: 0,
      allocatedStudents: 0
    }
  }),
  [sr.POPULATE_CACHE]: e.undefined().optional(),
  [sr.AUTO_ALLOCATE]: e.undefined().optional(),
  [sr.AUTO_ALLOCATE_DAILY]: e.undefined().optional()
}, Ff = He.extend({
  status: e.literal("uninitialized")
}), wf = He.extend({
  status: e.literal("pending")
}), Bf = He.extend({
  status: e.literal("completed")
}), Gf = He.extend({
  status: e.literal("failed"),
  error: Qu
});
function $f(t) {
  const r = es[t];
  return Bf.extend({ meta: r });
}
function Vf(t) {
  return Hn(
    e.discriminatedUnion("status", [
      Ff,
      wf,
      $f(t),
      Gf
    ])
  );
}
const kf = He.partial().extend({
  name: Er,
  jobId: e.string(),
  status: e.literal("uninitialized")
}), qf = He.partial().extend({
  name: Er,
  jobId: e.string(),
  status: e.literal("pending")
}), Hf = He.partial().extend({
  name: Er,
  jobId: e.string(),
  status: e.literal("completed")
}), zf = He.partial().extend({
  name: Er,
  jobId: e.string(),
  status: e.literal("failed"),
  error: Qu
});
function Yf(t) {
  const r = es[t];
  return Hf.extend({ meta: r.optional() });
}
function ng(t) {
  return Hn(
    e.discriminatedUnion("status", [
      kf,
      qf,
      Yf(t),
      zf
    ])
  );
}
function ig(t) {
  const r = Vf(t);
  return e.object({
    status: Uf,
    job: r.optional()
  });
}
const Wf = e.jwt().brand(), xf = e.preprocess(
  (t) => typeof t == "string" ? t.replace(/^\s*bearer\s+/i, "") : t,
  Wf
), ag = e.object({
  serverUrl: e.string().optional(),
  token: xf,
  user: Ql,
  organizationId: e.string(),
  listOptions: e.object({
    limit: e.number(),
    page: e.string(),
    sortBy: e.string().optional()
  }).optional()
}), og = e.object({
  limitToAdminsOnly: e.string().default("")
}), Kf = {
  id: "nofFailedDecisions",
  kpis: [
    {
      id: "impossible",
      name: "Impossible",
      value: 0
    },
    {
      id: "impossibleInCurrent",
      name: "ImpossibleInCurrent",
      value: 0
    },
    {
      id: "notEnoughSpaceOnPossible",
      name: "NotEnoughSpaceOnPossible",
      value: 7
    }
  ],
  name: "Number of failed decisions",
  value: 7
}, Zf = {
  id: "nofCompleteStudents",
  name: "Number of complete students",
  value: 12
}, Jf = {
  id: "nofStudents",
  name: "Number of students",
  value: 7
}, ug = {
  build: "128df39122a8313636f41bf4a529ef271efc84be",
  dataVersion: 1,
  exit_status: "success",
  id: "9100122e-21c5-4392-84be-e02bcc48d3da",
  meta: {
    timestamp: 1738740836,
    userId: "66d72106e434c91283e65c04"
  },
  result: {
    kpis: [
      {
        id: "problemAnalysis",
        kpis: [
          Jf,
          {
            id: "nofStudentSetGroups",
            name: "Number of studentSetGroups",
            value: 5
          },
          {
            id: "nofLockedDecisions",
            name: "Number of locked decisions",
            value: 21
          },
          {
            id: "nofNonLockedDecisions",
            name: "Number of non-locked decisions",
            value: 7
          },
          {
            id: "nofLockedStudents",
            name: "Number of locked students",
            value: 0
          }
        ],
        name: "Problem Analysis"
      },
      {
        id: "solutionAnalysis",
        kpis: [
          {
            id: "nofAssignedDecisions",
            name: "Number of assigned decisions",
            value: 3
          },
          Kf,
          Zf,
          {
            id: "nofIncompleteStudents",
            name: "Number of incompletely assigned students",
            value: 4
          }
        ],
        name: "Solution Analysis"
      }
    ],
    solution: {
      assignments: [
        {
          studentSetGroupId: 70308,
          students: [96984, 96469, 94696]
        }
      ]
    },
    studentStatuses: [
      {
        statuses: [0],
        studentId: 96984
      },
      {
        statuses: [0],
        studentId: 96469
      },
      {
        statuses: [3],
        studentId: 97304
      },
      {
        statuses: [3],
        studentId: 94442
      },
      {
        statuses: [0],
        studentId: 94696
      },
      {
        statuses: [3],
        studentId: 94706
      },
      {
        statuses: [3],
        studentId: 97011
      }
    ]
  }
}, sg = e.object({
  failedLinks: e.array(e.string())
}), lg = e.partialRecord(
  e.string(),
  e.array(e.number())
), Xf = ["en", "sv"], cg = e.enum(Xf), Qf = e.object({
  message: e.string(),
  errorName: Jo.catch(Mn.Error)
}), eE = [
  "Exams unexpected",
  "Student assessment not enabled",
  "Exams not found"
], tE = ["Missing preferred groups"], rE = ["User object cache write failed"], nE = [
  ...eE,
  ...tE,
  ...rE,
  // What a reason this client does not know reads as.
  "Unknown"
], iE = e.enum(nE), aE = e.object({
  /**
   * What went wrong. Typed on the server by the controller's union of
   * failures, so each reason identifies one kind of failure.
   * A reason this client does not know reads as `Unknown`.
   */
  reason: iE.catch("Unknown"),
  /**
   * Ids of the entities the failure affected. Empty `subjects` might mean
   * the entities could not be identified, and is not the same as none
   * affected.
   */
  subjects: e.array(e.number()).optional(),
  /** The status the underlying error maps to; absent when nothing was thrown. */
  status: e.number().int().optional(),
  /** The underlying error, reduced to the fields safe to send to a client. */
  error: Qf.optional()
}), fi = {
  failures: e.array(aE).optional(),
  logId: e.string().optional()
}, oE = ["morning", "afternoon", "no_preference"], uE = "system_default", Gr = e.enum(oE), sE = [
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat",
  "Sun"
], lE = e.enum(sE), cE = ["prefer", "avoid"], dE = e.enum(cE), Do = e.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, "time must be HH:mm"), $r = e.object({
  begin: Do,
  end: Do,
  day: lE,
  sentiment: dE
}).refine((t) => t.begin < t.end, {
  message: "begin must be before end",
  path: ["end"]
}), dg = {
  timeOfDay: "no_preference",
  preferredGroupIds: [],
  timePreferences: [],
  modifiedBy: uE
}, ts = e.object({
  studentId: e.number(),
  timeOfDay: Gr,
  preferredGroupIds: e.array(e.number()).default([]),
  timePreferences: e.array($r).default([]),
  modifiedBy: e.string(),
  createdAt: Sn,
  updatedAt: Sn
}), pg = ts.pick({
  studentId: !0,
  timeOfDay: !0,
  preferredGroupIds: !0
}), mg = e.object({
  timeOfDay: Gr.optional(),
  preferredGroupIds: e.array(e.number()).optional(),
  timePreferences: e.array($r).optional()
}), rs = e.object({
  groupIds: e.array(e.number()),
  courseLabel: e.string(),
  groupName: e.string()
}), pE = e.object({
  group: e.boolean(),
  time: e.boolean(),
  timeOfDay: e.boolean()
}), fg = e.object({
  timeOfDay: Gr,
  updatedAtUserTime: e.string().optional(),
  preferredGroups: e.array(rs),
  timePreferences: e.array($r),
  enabledSteps: pE,
  ...fi
}), Eg = e.object({
  studentId: e.string().regex(/^\d+$/, "studentId must be numeric")
}), mE = ["create", "update", "delete"], fE = e.enum(mE), EE = (t) => e.object({
  operation: fE,
  snapshot: t,
  modifiedBy: e.string(),
  timestamp: Sn
});
function TE(t) {
  return EE(t);
}
const Tg = TE(
  ts
).extend({
  studentId: e.number()
}), bE = e.object({
  name: e.string(),
  timestamp: e.string(),
  timeOfDay: Gr,
  preferredGroups: e.array(rs).optional(),
  timePreferences: e.array($r).default([])
}), bg = e.array(
  bE
), gE = e.object({
  time: e.string(),
  operationType: e.string(),
  itemType: e.string(),
  username: e.string(),
  objectIds: e.array(e.number()),
  courses: e.array(e.string()),
  activities: e.array(e.string()),
  groups: e.array(e.string())
}), yE = e.array(gE), gg = e.object({
  history: yE,
  total: e.number().int().nonnegative(),
  page: e.number().int().positive()
}), _E = 50, yg = e.object({
  objectId: e.string().regex(/^\d+$/, "objectId must be numeric")
}), _g = e.object({
  current: e.coerce.number().int().positive().optional(),
  pageSize: e.coerce.number().int().positive().max(_E).optional()
}), ns = e.object({
  // action
  itemType: e.string(),
  operationType: e.string(),
  // user
  changed: e.number().optional().nullable(),
  changedBy: e.string().optional().nullable(),
  // objects
  objectId: e.number().optional().nullable(),
  objectIds: e.array(e.number()).optional().nullable(),
  // fields and types
  typeId: e.number().optional().nullable(),
  fieldId: e.number().optional().nullable(),
  // dates
  begin: e.number().optional().nullable(),
  end: e.number().optional().nullable(),
  // props
  name: e.string().optional().nullable(),
  value: e.string().optional().nullable(),
  // availability
  availabilityTypeId: e.number().optional().nullable()
}), Ag = e.array(ns), Sg = e.object({
  objectId: e.number(),
  idFormat: e.literal("INTERNAL"),
  sort: e.enum(["ASC", "DESC"]),
  page: e.number(),
  limit: e.number(),
  skipNoChanged: e.boolean().optional(),
  itemTypes: e.array(
    e.enum([
      "MEMBER",
      "RELATION",
      "OPTIONAL_RELATION",
      "AVAILABILITY_RELATION",
      "FIELD",
      "TYPE",
      "PROPERTY",
      "NONE"
    ])
  ).optional()
}), Og = he(ns), _r = {
  displayName: e.string().optional()
}, oe = e.discriminatedUnion("type", [
  e.object({
    ..._r,
    type: e.literal("reservation"),
    // Single numerical string
    value: e.string().regex(/^\d+$/)
  }),
  e.object({
    ..._r,
    type: e.literal("object-field"),
    // Two numerical strings joined by a dash
    value: e.string().regex(/^\d+-\d+$/)
  }),
  e.object({
    ..._r,
    type: e.literal("text"),
    value: e.string()
  }),
  e.object({
    ..._r,
    type: e.literal("unmapped")
  })
]), jo = oe.and(e.object({ label: e.string() })), AE = e.object({
  absoluteStartTime: e.number().optional(),
  absoluteEndTime: e.number().optional(),
  relativeStartTime: e.number().optional(),
  relativeEndTime: e.number().optional()
}), SE = e.object({
  datelimit: AE.optional(),
  module: e.object({
    name: oe.optional(),
    code: oe.optional()
  }).optional(),
  location: e.object({
    room: oe.optional(),
    building: oe.optional(),
    campus: oe.optional(),
    type: oe.optional(),
    map: oe.optional(),
    image: oe.optional(),
    equipment: oe.optional(),
    onlineMeetingLink: oe.optional(),
    extraFields: e.array(jo).optional()
  }).optional(),
  digitalResources: e.object({
    recording: oe.optional(),
    lmsLink: oe.optional()
  }).optional(),
  staff: e.object({
    name: oe.optional()
  }).optional(),
  activity: e.object({
    displayName: oe.optional(),
    alternativeTitle: oe.optional()
  }).optional(),
  messageToStudent: oe.optional(),
  extraFields: e.array(jo).optional(),
  updatedBy: e.string().optional(),
  updatedAt: e.coerce.date().optional(),
  reservationStatuses: e.array(e.enum(U.EReservationStatuses)).optional(),
  reservationMode: e.number().optional()
}), OE = e.object({
  enabled: e.boolean(),
  path: e.string().optional(),
  page: e.string().optional()
}), Rg = e.object({
  studentReservationDisplaySettings: SE.optional(),
  studentSubscribeSettings: OE.optional()
}), hg = e.discriminatedUnion("direction", [
  e.object({
    direction: e.literal("initial")
  }),
  e.object({
    direction: e.literal("next"),
    from: e.number().int().positive()
  }),
  e.object({
    direction: e.literal("previous"),
    from: e.number().int().positive()
  }),
  e.object({
    direction: e.literal("full")
  })
]), vg = e.object({
  results: e.array(Sr.nullable()),
  /** Page number to pass as `from` on the next forward request, or null when the forward side is exhausted. */
  nextFrom: e.number().int().nullable(),
  /** Page number to pass as `from` on the next backward request, or null when the backward side is exhausted or the backward range is empty. */
  previousFrom: e.number().int().nullable(),
  userTodayLocal: e.string(),
  subscribeEnabled: e.boolean(),
  datelimitText: e.object({
    before: be,
    after: be
  }).optional(),
  ...fi
}), RE = e.object({
  key: e.number(),
  title: e.string().optional(),
  subtitle: e.string(),
  allDay: e.boolean().optional(),
  start: Sr.shape.begin,
  end: Sr.shape.end,
  location: Sr.shape.location
}), Ig = e.object({
  results: e.array(RE.nullable()),
  ...fi
}), Pg = e.object({
  appleURL: e.string(),
  googleURL: e.string(),
  rawURL: e.string()
}), hE = e.enum(["TE_HUB", "TE_EXAM_V3"]), vE = e.object({
  examReservationMode: e.number().optional()
}), Cg = e.object({
  reservationSettings: vE.optional()
}), Ng = e.object({
  date: e.object({
    startDate: e.number().int().optional(),
    // epoch seconds
    endDate: e.number().int().optional()
    // epoch seconds
  }).refine(
    (t) => t.startDate === void 0 || t.endDate === void 0 || t.endDate >= t.startDate,
    {
      message: "endDate must not be before startDate",
      path: ["endDate"]
    }
  ).optional(),
  ids: e.array(e.number().int().positive()).min(1).max(io).optional(),
  settingsSource: hE,
  page: e.number().int().min(1).optional(),
  limit: e.number().int().min(1).max(io).optional()
}).refine((t) => t.date !== void 0 != (t.ids !== void 0), {
  message: "Exactly one of date or ids must be given"
}), Ar = iu(e.string()), IE = e.object({
  id: e.number(),
  start: e.string(),
  end: e.string(),
  lastModified: e.string(),
  examName: e.string(),
  examType: e.string(),
  location: Ar(e.string()),
  seatNo: Ar(e.string().nullable()),
  fields: e.array(
    Ar(e.string()).and(
      e.object({
        label: e.string(),
        type: e.string().optional()
      })
    )
  ),
  information: e.array(
    Ar(
      e.object({
        title: e.string().optional(),
        type: e.enum(["error", "warning", "info"]).optional(),
        value: e.string()
      })
    )
  )
}), Mg = e.object({
  results: e.array(IE),
  limit: e.number(),
  page: e.number(),
  totalPages: e.number(),
  totalResults: e.number(),
  examReservationMode: e.number().optional()
});
export {
  _m as ALLOCATION_FILTER_ALLOCATED,
  ZT as ALLOCATION_FILTER_GROUP_PREFIX,
  Am as ALLOCATION_FILTER_NOT_ALLOCATED,
  NE as APP_PERMISSION,
  bT as AUTO_ALLOCATE_FREQUENCIES,
  wT as ActivityIdentifiers,
  Kn as ActivityIdentifiersValue,
  nm as ActivityWithGroup,
  rm as ActivityWithGroupValue,
  Jn as ActivityWithReason,
  tm as ActivityWithReasonValue,
  Wb as AddEventBody,
  Zn as AddStudentsToGroupsOverrides,
  Jb as AddWaitlistBody,
  hu as AllocateActivity,
  Ru as AllocateCourse,
  og as AllocateFeatureFlags,
  vu as AllocateGroup,
  Cb as AllocateProposalBody,
  Pb as AllocateRequest,
  oc as AllocateSettings,
  Xp as AllocateStudent,
  VT as AllocateStudentsControllerResult,
  kT as AllocationBuffer,
  Sm as AllocationFilterValue,
  jE as AllocationRegistrationScope,
  af as AllocationResult,
  Ab as AllocationResultDataSource,
  Vb as AllocationResultDataSourceBody,
  pf as AllocationResultDataSourceData,
  bb as AllocationResultsSchema,
  xT as AllocationRules,
  Yo as AllocationSignal,
  Ml as AllocationStatus,
  Ku as AnalyticEventsClient,
  ag as AuthParams,
  nu as AutoAllocateFrequencyOptions,
  ei as BaseCatalogObject,
  jT as BooleanFieldTransform,
  DT as BooleanTransform,
  Pf as BulkLinked,
  tb as Catalog,
  Fu as CatalogActivity,
  Uu as CatalogCourse,
  ti as CatalogGroup,
  ju as CatalogTEObject,
  um as ChangeRequest,
  zT as ChangeRequestResult,
  jf as CloudJob,
  tg as CloudJobBody,
  Ju as CloudJobNames,
  rg as CloudJobResponse,
  ht as CompletedJobSchema,
  mi as ConflictControlStrategy,
  di as CorruptedJobSchema,
  Su as CourseIssues,
  cc as CurrentPeriod,
  Qn as CurrentStudentConflictsData,
  be as DateInfo,
  AE as DateLimit,
  dr as DateTransform,
  Mb as DeallocateProposalBody,
  Nb as DeallocateRequest,
  cm as DedicatedCategory,
  Pu as DedicatedGroup,
  dm as DedicatedRelation,
  fm as Distribution,
  KT as DistributionBody,
  Nu as DistributionKind,
  On as DistributionRules,
  Cu as DistributionRulesEnum,
  _b as DownloadProposalResult,
  $b as DownloadProposalResultBody,
  fn as EPersonalInformation,
  Xo as EReservationSortOrder,
  Nr as ESortOrder,
  Mn as ErrorName,
  Mu as ExactSearch,
  vE as ExamReservationSettings,
  Cg as ExamReservationSettingsResponse,
  hE as ExamSettingsSource,
  Kb as ExportAllocateOverviewBody,
  jo as ExtraField,
  cn as ExtractIdTransform,
  Re as FRONTEND_KEYS_TO_OMIT,
  FT as FailedDistribution,
  Iu as FailedTypes,
  Qp as FailsWithGroups,
  em as FailsWithMessage,
  Hb as FetchAllocateDataBody,
  If as FetchAllocateDataResponse,
  vf as FetchAllocateDataReturn,
  lg as FetchLinkedGroupsResult,
  lc as FieldValues,
  hn as FilterSelectionMode,
  Wp as FilterValueTransform,
  Rb as FindProgramsBody,
  Ob as FindReservationsBody,
  Ng as FindStudentExamsBody,
  uf as FrontendOptimizerJobSchema,
  yb as FrontendOptimizerJobs,
  nb as FrontendRegistration,
  Cm as FrontendRegistrationCourse,
  Lu as FrontendRegistrationCourseTEObject,
  Mm as FrontendRegistrationGroup,
  Im as FrontendRegistrationGroupTEObject,
  Pm as FrontendRegistrationStudentObject,
  Gb as GenerateProposalBody,
  ab as GetRegistrationStaffParams,
  Fr as GetStaffCoursesBody,
  eb as GetStudentConflicts,
  sm as GroupDataIssueValue,
  xn as GroupDataIssues,
  YT as GroupDataIssuesReturn,
  Au as GroupIssues,
  ME as GroupState,
  fE as HistoryOperation,
  tc as IFieldMapping,
  fT as IMapping,
  Ql as ITEToken,
  rc as ITypeMapping,
  gT as IdName,
  yT as InitialSettings,
  Yn as IntegerTransform,
  Ou as IssueKey,
  om as IssueListCourse,
  Jp as IssueListKey,
  am as IssueValue,
  HT as Issues,
  sr as JobNames,
  I as JobStatus,
  Wf as JwtToken,
  cg as LanguageCode,
  hb as LimitedGetStaffCoursesBody,
  xb as LinkAllGroupsBody,
  sg as LinkReturnId,
  vb as LoadAllObjectsResult,
  ff as LoadBody,
  ob as LoadRegistrationExpandBody,
  ub as LoadRegistrationExpandResult,
  Qu as LongRunningJobError,
  Er as LongRunningJobNameEnum,
  He as LongRunningJobSchemaBase,
  Xu as LongRunningJobStatus,
  Tu as MAX_ERRORS,
  no as MAX_RECORD_ENTRIES,
  oe as MappedValue,
  tu as MappingData,
  ET as MappingResponse,
  gb as MarkJobStartReturn,
  Sf as MongooseSort,
  mc as MyExamReservationDetail,
  pc as MyGeneralReservationDetail,
  Sr as MyReservation,
  _T as MyReservationDetail,
  hg as MyScheduleBody,
  vg as MyScheduleResponse,
  RE as MyScheduleWidgetEvent,
  Ig as MyScheduleWidgetResponse,
  Pg as MySubscriptionResponse,
  pt as NonNegativeIntegerTransform,
  LT as NumberFieldTransform,
  zp as NumberTransform,
  _E as OBJECT_HISTORY_MAX_PAGE_SIZE,
  gE as ObjectHistoryEntry,
  yE as ObjectHistoryList,
  yg as ObjectHistoryParameters,
  _g as ObjectHistoryQuery,
  gg as ObjectHistoryReturn,
  MT as ObjectIdTransform,
  Rn as ObjectIdsWithType,
  Wn as OpenStatus,
  Io as OptimizerCourseSelectionInfo,
  Kp as OptimizerCourseSelectionInfoTransform,
  zu as OptimizerError,
  Eb as OptimizerJobSchema,
  At as OptimizerKpiBase,
  Zm as OptimizerMeta,
  cb as OptimizerObject,
  pb as OptimizerOutputSchema,
  db as OptimizerReservation,
  mb as OptimizerResponse,
  ef as OptimizerResult,
  Hu as OptimizerStatusCodesEnum,
  Du as OurFieldSort,
  Om as OurKeySort,
  XT as OurSort,
  Fb as PacemakerSwapResponse,
  lb as ParsedDateTimeInfo,
  aE as PartialFailure,
  iE as PartialFailureReason,
  Tb as PartialOptimizerJobSchema,
  Uf as PollStatus,
  Bb as PopulateCacheBody,
  rs as PreferredGroupSummary,
  DE as ProblemStatus,
  Df as ProcessAllWaitlistsStats,
  Ef as ProgramFilterMode,
  df as ProposalList,
  wb as ProposalLoad,
  rf as ProposalResult,
  cf as ProposalRow,
  Cr as ProposalSettings,
  Nm as RegistrationActivity,
  wu as RegistrationCourse,
  Bu as RegistrationGroup,
  ib as RegistrationMode,
  Ve as RelatedId,
  kb as ReloadAllocateDataBody,
  hf as ReloadAllocateDataBodyWithGroupIds,
  Rf as ReloadAllocateDataBodyWithIds,
  Of as ReloadAllocateDataBodyWithProps,
  qb as ReloadAllocateDataResponse,
  Xb as RemoveWaitlistBody,
  he as RestApiMultipleResultsSchema,
  Wl as RestApiMultipleResultsSchemaPassthrough,
  Kl as RestApiMultipleResultsSchemaPut,
  br as SCOPE,
  uE as SYSTEM_DEFAULT_MODIFIED_BY,
  Qf as SafeError,
  Ib as SaveBody,
  uT as SaveReservationResult,
  Xn as SaveStudentsResult,
  BT as SaveStudentsResultNoSwap,
  GT as SaveStudentsResultSwap,
  rb as Schedule,
  Gu as ScheduleEvent,
  pg as SchedulePreferences,
  mg as SchedulePreferencesBody,
  ts as SchedulePreferencesDBSchema,
  Tg as SchedulePreferencesHistoryDBSchema,
  bE as SchedulePreferencesHistoryEntry,
  bg as SchedulePreferencesHistoryList,
  pE as SchedulePreferencesSteps,
  fg as SchedulePreferencesStudentFrontend,
  Lb as ScheduleRequest,
  bf as SearchFields,
  vm as Seats,
  $T as SetDistributionResponse,
  Ub as SignalsPayload,
  Af as SortOrder,
  zb as StaffCoursesResponse,
  Eg as StaffSchedulePreferencesParameters,
  jb as StaffSwapRequest,
  qT as StartOrEnd,
  UT as StringFieldTransform,
  CT as StringToIntegerTransform,
  NT as StringToNonNegativeIntegerTransform,
  Yp as StringToNumberTransform,
  vo as StringTransform,
  bm as StudentAdjustmentActivity,
  Yb as StudentAdjustmentBody,
  gm as StudentAdjustmentCourse,
  Tm as StudentAdjustmentGroup,
  JT as StudentAdjustmentResponse,
  QT as StudentConflictsData,
  lm as StudentDataIssueValue,
  WT as StudentDataIssuesReturn,
  IE as StudentExam,
  Mg as StudentExamsResponse,
  Rg as StudentHubSettings,
  Lr as StudentInfo,
  _u as StudentIssues,
  SE as StudentReservationSettings,
  OE as StudentSubscribeSettings,
  Db as StudentSwapRequest,
  eg as StudentWaitlistsParameters,
  Zb as StudentWaitlistsSchema,
  Sb as SuccessHandlerResponse,
  pT as TAllocateUser,
  KE as TAltDesignations,
  Dn as TAttributeValueArrayPair,
  xE as TAttributesAndValuesPair,
  XE as TAvailabilityRelations,
  dT as TCurrentUser,
  Un as TDateRange,
  Qo as TDateRangeRelations,
  ns as TEObjectHistoryEntry,
  Ag as TEObjectHistoryList,
  Sg as TEObjectsHistoryFindBody,
  Og as TEObjectsHistoryFindResult,
  io as TE_SERVER_GENERAL_LIMIT,
  jn as TField,
  ql as TFieldType,
  ZE as TFields,
  Jl as TFindReservationsBody,
  aT as TFindReservationsRequest,
  sb as THistory,
  lT as TLogins,
  Ln as TMemberType,
  JE as TMemberTypes,
  Hl as TMemberTypesItem,
  eu as TOrganization,
  iT as TOrganizationPublic,
  nT as TOrganizations,
  Fn as TReservation,
  oT as TReservations,
  Zl as TReservationsSearchObject,
  mr as TTEFieldValue,
  zl as TTEFindObjectsBody,
  QE as TTEFindObjectsRequest,
  me as TTEObject,
  Yl as TTEObjectPassthrough,
  xl as TTEObjectPut,
  eT as TTEObjects,
  tT as TTEObjectsPassthrough,
  rT as TTEObjectsPut,
  Bn as TTEUser,
  mT as TTEUserIdentities,
  ec as TTEUserIdentity,
  cT as TTEUsers,
  TT as TTimeZones,
  wn as TType,
  sT as TTypes,
  Xl as TUserProfile,
  ao as TUserProfileIdentifier,
  Gr as TimeOfDay,
  $r as TimePreference,
  dE as TimePreferenceSentiment,
  oo as TimeZoneData,
  ru as TimeZoneNamed,
  nc as TimeZoneObject,
  ic as ViewLink,
  dc as ViewLinkParsed,
  Mf as WaitlistDBSchema,
  Nf as WaitlistDBSequenceSchema,
  Qb as WaitlistPositionBody,
  lE as WeekDay,
  sE as WeekDayValues,
  wl as ZAppIdOptional,
  Ko as ZAppIdRequired,
  Fl as ZAppProperties,
  Ul as ZApplicationObjectTypeGroup,
  Jo as ZErrorName,
  UE as ZObjectTypeMappingStatusesOptional,
  FE as ZObjectTypeMappingStatusesRequired,
  wE as ZOrganizationTypeOptional,
  BE as ZOrganizationTypeRequired,
  Bl as ZOrganizationVisibilityOptional,
  GE as ZOrganizationVisibilityRequired,
  kE as ZPersonalDataCheck,
  qE as ZPersonalInformation,
  HE as ZPreferencesFilterOptional,
  zE as ZPreferencesFilterRequired,
  YE as ZPropertyOptional,
  WE as ZPropertyRequired,
  Zo as ZRegionOptional,
  LE as ZRegionRequired,
  $l as ZReservationSortOrder,
  En as ZSortOrder,
  Gl as ZTokenTypeOptional,
  $E as ZTokenTypeRequired,
  VE as ZUserVisibility,
  Ro as allocateDateTimeFormatRegex,
  Cl as allocationSignals,
  Nl as allocationStatuses,
  RT as assertNonEmptyArray,
  ug as bucketOutputMock,
  _f as conflictControlStrategies,
  TE as createHistoryDBSchema,
  mf as createSuccessHandlerResponse,
  iu as createTimedFieldValue,
  PT as createZodErrorMessage,
  Sn as dateToISOString,
  _t as dateToISOStringOptional,
  $e as defaultProposalSettings,
  Vl as defaultReservationStatuses,
  K as detailEntry,
  $p as filterIssues,
  qp as fromIsoDateString,
  kp as fromTeDateString,
  Hp as fromTimestamp,
  hT as getEntries,
  qn as getErrorMessage,
  Vf as getLongRunningJobSchema,
  Ao as getManyErrorMessage,
  ng as getPartialLongRunningJobSchema,
  ig as getPollStatusSchema,
  wp as getSortedErrorValues,
  Dl as groupStates,
  IT as hasData,
  dg as initialSchedulePreferences,
  gt as isArray,
  ST as isBoolean,
  Te as isDefined,
  Fp as isErrorWithMessage,
  jp as isNonEmptyArray,
  Lp as isNullish,
  kn as isNumber,
  AT as isPositiveNumber,
  qe as isRecord,
  fr as isString,
  OT as isStringWithValue,
  fb as jobStatusLevels,
  Dp as jsonStringify,
  Vp as limitedRecord,
  vT as makeRecurseFnForObjects,
  Up as makeRecurseFnForScalars,
  fi as multiStatusShape,
  Zf as nofCompleteStudentsMock,
  Kf as nofFailedDecisionsMock,
  Jf as nofStudentsMock,
  Oe as omitIfExists,
  Hn as partialNotUndefined,
  jl as problemStatuses,
  Lm as registrationModes,
  im as startOrEnd
};
